
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dBs8J", function(module, exports) {
"use strict";
function $9e748f0e7cb702a5$var$Vnode(tag, key, attrs, children, text, dom) {
    return {
        tag: tag,
        key: key,
        attrs: attrs,
        children: children,
        text: text,
        dom: dom,
        domSize: undefined,
        state: undefined,
        events: undefined,
        instance: undefined
    };
}
$9e748f0e7cb702a5$var$Vnode.normalize = function(node) {
    if (Array.isArray(node)) return $9e748f0e7cb702a5$var$Vnode("[", undefined, undefined, $9e748f0e7cb702a5$var$Vnode.normalizeChildren(node), undefined, undefined);
    if (node == null || typeof node === "boolean") return null;
    if (typeof node === "object") return node;
    return $9e748f0e7cb702a5$var$Vnode("#", undefined, undefined, String(node), undefined, undefined);
};
$9e748f0e7cb702a5$var$Vnode.normalizeChildren = function(input) {
    var children = [];
    if (input.length) {
        var isKeyed = input[0] != null && input[0].key != null;
        // Note: this is a *very* perf-sensitive check.
        // Fun fact: merging the loop like this is somehow faster than splitting
        // it, noticeably so.
        for(var i = 1; i < input.length; i++){
            if ((input[i] != null && input[i].key != null) !== isKeyed) throw new TypeError(isKeyed && (input[i] != null || typeof input[i] === "boolean") ? "In fragments, vnodes must either all have keys or none have keys. You may wish to consider using an explicit keyed empty fragment, m.fragment({key: ...}), instead of a hole." : "In fragments, vnodes must either all have keys or none have keys.");
        }
        for(var i = 0; i < input.length; i++)children[i] = $9e748f0e7cb702a5$var$Vnode.normalize(input[i]);
    }
    return children;
};
module.exports = $9e748f0e7cb702a5$var$Vnode;

});

parcelRegister("e2F9W", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(html) {
    if (html == null) html = "";
    return $dBs8J("<", undefined, undefined, html, undefined, undefined);
};

});

parcelRegister("7PZrX", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");
module.exports = function() {
    var vnode = $5sRXF.apply(0, arguments);
    vnode.tag = "[";
    vnode.children = $dBs8J.normalizeChildren(vnode.children);
    return vnode;
};

});
parcelRegister("5sRXF", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
// Call via `hyperscriptVnode.apply(startOffset, arguments)`
//
// The reason I do it this way, forwarding the arguments and passing the start
// offset in `this`, is so I don't have to create a temporary array in a
// performance-critical path.
//
// In native ES6, I'd instead add a final `...args` parameter to the
// `hyperscript` and `fragment` factories and define this as
// `hyperscriptVnode(...args)`, since modern engines do optimize that away. But
// ES5 (what Mithril.js requires thanks to IE support) doesn't give me that luxury,
// and engines aren't nearly intelligent enough to do either of these:
//
// 1. Elide the allocation for `[].slice.call(arguments, 1)` when it's passed to
//    another function only to be indexed.
// 2. Elide an `arguments` allocation when it's passed to any function other
//    than `Function.prototype.apply` or `Reflect.apply`.
//
// In ES6, it'd probably look closer to this (I'd need to profile it, though):
// module.exports = function(attrs, ...children) {
//     if (attrs == null || typeof attrs === "object" && attrs.tag == null && !Array.isArray(attrs)) {
//         if (children.length === 1 && Array.isArray(children[0])) children = children[0]
//     } else {
//         children = children.length === 0 && Array.isArray(attrs) ? attrs : [attrs, ...children]
//         attrs = undefined
//     }
//
//     if (attrs == null) attrs = {}
//     return Vnode("", attrs.key, attrs, children)
// }
module.exports = function() {
    var attrs = arguments[this], start = this + 1, children;
    if (attrs == null) attrs = {};
    else if (typeof attrs !== "object" || attrs.tag != null || Array.isArray(attrs)) {
        attrs = {};
        start = this;
    }
    if (arguments.length === start + 1) {
        children = arguments[start];
        if (!Array.isArray(children)) children = [
            children
        ];
    } else {
        children = [];
        while(start < arguments.length)children.push(arguments[start++]);
    }
    return $dBs8J("", attrs.key, attrs, children);
};

});


parcelRegister("k7iQv", function(module, exports) {
"use strict";
/** @constructor */ var $ea53147a45dc1bd2$var$PromisePolyfill = function(executor) {
    if (!(this instanceof $ea53147a45dc1bd2$var$PromisePolyfill)) throw new Error("Promise must be called with 'new'.");
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var self = this, resolvers = [], rejectors = [], resolveCurrent = handler(resolvers, true), rejectCurrent = handler(rejectors, false);
    var instance = self._instance = {
        resolvers: resolvers,
        rejectors: rejectors
    };
    var callAsync = typeof setImmediate === "function" ? setImmediate : setTimeout;
    function handler(list, shouldAbsorb) {
        return function execute(value) {
            var then;
            try {
                if (shouldAbsorb && value != null && (typeof value === "object" || typeof value === "function") && typeof (then = value.then) === "function") {
                    if (value === self) throw new TypeError("Promise can't be resolved with itself.");
                    executeOnce(then.bind(value));
                } else callAsync(function() {
                    if (!shouldAbsorb && list.length === 0) console.error("Possible unhandled promise rejection:", value);
                    for(var i = 0; i < list.length; i++)list[i](value);
                    resolvers.length = 0, rejectors.length = 0;
                    instance.state = shouldAbsorb;
                    instance.retry = function() {
                        execute(value);
                    };
                });
            } catch (e) {
                rejectCurrent(e);
            }
        };
    }
    function executeOnce(then) {
        var runs = 0;
        function run(fn) {
            return function(value) {
                if (runs++ > 0) return;
                fn(value);
            };
        }
        var onerror = run(rejectCurrent);
        try {
            then(run(resolveCurrent), onerror);
        } catch (e) {
            onerror(e);
        }
    }
    executeOnce(executor);
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.then = function(onFulfilled, onRejection) {
    var self = this, instance = self._instance;
    function handle(callback, list, next, state) {
        list.push(function(value) {
            if (typeof callback !== "function") next(value);
            else try {
                resolveNext(callback(value));
            } catch (e) {
                if (rejectNext) rejectNext(e);
            }
        });
        if (typeof instance.retry === "function" && state === instance.state) instance.retry();
    }
    var resolveNext, rejectNext;
    var promise = new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        resolveNext = resolve, rejectNext = reject;
    });
    handle(onFulfilled, instance.resolvers, resolveNext, true), handle(onRejection, instance.rejectors, rejectNext, false);
    return promise;
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.catch = function(onRejection) {
    return this.then(null, onRejection);
};
$ea53147a45dc1bd2$var$PromisePolyfill.prototype.finally = function(callback) {
    return this.then(function(value) {
        return $ea53147a45dc1bd2$var$PromisePolyfill.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        return $ea53147a45dc1bd2$var$PromisePolyfill.resolve(callback()).then(function() {
            return $ea53147a45dc1bd2$var$PromisePolyfill.reject(reason);
        });
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.resolve = function(value) {
    if (value instanceof $ea53147a45dc1bd2$var$PromisePolyfill) return value;
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve) {
        resolve(value);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.reject = function(value) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        reject(value);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.all = function(list) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        var total = list.length, count = 0, values = [];
        if (list.length === 0) resolve([]);
        else for(var i = 0; i < list.length; i++)(function(i) {
            function consume(value) {
                count++;
                values[i] = value;
                if (count === total) resolve(values);
            }
            if (list[i] != null && (typeof list[i] === "object" || typeof list[i] === "function") && typeof list[i].then === "function") list[i].then(consume, reject);
            else consume(list[i]);
        })(i);
    });
};
$ea53147a45dc1bd2$var$PromisePolyfill.race = function(list) {
    return new $ea53147a45dc1bd2$var$PromisePolyfill(function(resolve, reject) {
        for(var i = 0; i < list.length; i++)list[i].then(resolve, reject);
    });
};
module.exports = $ea53147a45dc1bd2$var$PromisePolyfill;

});

parcelRegister("j25vk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6JDlc"))(typeof window !== "undefined" ? window : null);

});
parcelRegister("6JDlc", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function($window) {
    var $doc = $window && $window.document;
    var currentRedraw;
    var nameSpace = {
        svg: "http://www.w3.org/2000/svg",
        math: "http://www.w3.org/1998/Math/MathML"
    };
    function getNameSpace(vnode) {
        return vnode.attrs && vnode.attrs.xmlns || nameSpace[vnode.tag];
    }
    //sanity check to discourage people from doing `vnode.state = ...`
    function checkState(vnode, original) {
        if (vnode.state !== original) throw new Error("'vnode.state' must not be modified.");
    }
    //Note: the hook is passed as the `this` argument to allow proxying the
    //arguments without requiring a full array allocation to do so. It also
    //takes advantage of the fact the current `vnode` is the first argument in
    //all lifecycle methods.
    function callHook(vnode) {
        var original = vnode.state;
        try {
            return this.apply(original, arguments);
        } finally{
            checkState(vnode, original);
        }
    }
    // IE11 (at least) throws an UnspecifiedError when accessing document.activeElement when
    // inside an iframe. Catch and swallow this error, and heavy-handidly return null.
    function activeElement() {
        try {
            return $doc.activeElement;
        } catch (e) {
            return null;
        }
    }
    //create
    function createNodes(parent, vnodes, start, end, hooks, nextSibling, ns) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function createNode(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        if (typeof tag === "string") {
            vnode.state = {};
            if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
            switch(tag){
                case "#":
                    createText(parent, vnode, nextSibling);
                    break;
                case "<":
                    createHTML(parent, vnode, ns, nextSibling);
                    break;
                case "[":
                    createFragment(parent, vnode, hooks, ns, nextSibling);
                    break;
                default:
                    createElement(parent, vnode, hooks, ns, nextSibling);
            }
        } else createComponent(parent, vnode, hooks, ns, nextSibling);
    }
    function createText(parent, vnode, nextSibling) {
        vnode.dom = $doc.createTextNode(vnode.children);
        insertNode(parent, vnode.dom, nextSibling);
    }
    var possibleParents = {
        caption: "table",
        thead: "table",
        tbody: "table",
        tfoot: "table",
        tr: "tbody",
        th: "tr",
        td: "tr",
        colgroup: "table",
        col: "colgroup"
    };
    function createHTML(parent, vnode, ns, nextSibling) {
        var match = vnode.children.match(/^\s*?<(\w+)/im) || [];
        // not using the proper parent makes the child element(s) vanish.
        //     var div = document.createElement("div")
        //     div.innerHTML = "<td>i</td><td>j</td>"
        //     console.log(div.innerHTML)
        // --> "ij", no <td> in sight.
        var temp = $doc.createElement(possibleParents[match[1]] || "div");
        if (ns === "http://www.w3.org/2000/svg") {
            temp.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg">' + vnode.children + "</svg>";
            temp = temp.firstChild;
        } else temp.innerHTML = vnode.children;
        vnode.dom = temp.firstChild;
        vnode.domSize = temp.childNodes.length;
        // Capture nodes to remove, so we don't confuse them.
        vnode.instance = [];
        var fragment = $doc.createDocumentFragment();
        var child;
        while(child = temp.firstChild){
            vnode.instance.push(child);
            fragment.appendChild(child);
        }
        insertNode(parent, fragment, nextSibling);
    }
    function createFragment(parent, vnode, hooks, ns, nextSibling) {
        var fragment = $doc.createDocumentFragment();
        if (vnode.children != null) {
            var children = vnode.children;
            createNodes(fragment, children, 0, children.length, hooks, null, ns);
        }
        vnode.dom = fragment.firstChild;
        vnode.domSize = fragment.childNodes.length;
        insertNode(parent, fragment, nextSibling);
    }
    function createElement(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        var attrs = vnode.attrs;
        var is = attrs && attrs.is;
        ns = getNameSpace(vnode) || ns;
        var element = ns ? is ? $doc.createElementNS(ns, tag, {
            is: is
        }) : $doc.createElementNS(ns, tag) : is ? $doc.createElement(tag, {
            is: is
        }) : $doc.createElement(tag);
        vnode.dom = element;
        if (attrs != null) setAttrs(vnode, attrs, ns);
        insertNode(parent, element, nextSibling);
        if (!maybeSetContentEditable(vnode)) {
            if (vnode.children != null) {
                var children = vnode.children;
                createNodes(element, children, 0, children.length, hooks, null, ns);
                if (vnode.tag === "select" && attrs != null) setLateSelectAttrs(vnode, attrs);
            }
        }
    }
    function initComponent(vnode, hooks) {
        var sentinel;
        if (typeof vnode.tag.view === "function") {
            vnode.state = Object.create(vnode.tag);
            sentinel = vnode.state.view;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
        } else {
            vnode.state = void 0;
            sentinel = vnode.tag;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
            vnode.state = vnode.tag.prototype != null && typeof vnode.tag.prototype.view === "function" ? new vnode.tag(vnode) : vnode.tag(vnode);
        }
        initLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        sentinel.$$reentrantLock$$ = null;
    }
    function createComponent(parent, vnode, hooks, ns, nextSibling) {
        initComponent(vnode, hooks);
        if (vnode.instance != null) {
            createNode(parent, vnode.instance, hooks, ns, nextSibling);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.dom != null ? vnode.instance.domSize : 0;
        } else vnode.domSize = 0;
    }
    //update
    /**
	 * @param {Element|Fragment} parent - the parent element
	 * @param {Vnode[] | null} old - the list of vnodes of the last `render()` call for
	 *                               this part of the tree
	 * @param {Vnode[] | null} vnodes - as above, but for the current `render()` call.
	 * @param {Function[]} hooks - an accumulator of post-render hooks (oncreate/onupdate)
	 * @param {Element | null} nextSibling - the next DOM node if we're dealing with a
	 *                                       fragment that is not the last item in its
	 *                                       parent
	 * @param {'svg' | 'math' | String | null} ns) - the current XML namespace, if any
	 * @returns void
	 */ // This function diffs and patches lists of vnodes, both keyed and unkeyed.
    //
    // We will:
    //
    // 1. describe its general structure
    // 2. focus on the diff algorithm optimizations
    // 3. discuss DOM node operations.
    // ## Overview:
    //
    // The updateNodes() function:
    // - deals with trivial cases
    // - determines whether the lists are keyed or unkeyed based on the first non-null node
    //   of each list.
    // - diffs them and patches the DOM if needed (that's the brunt of the code)
    // - manages the leftovers: after diffing, are there:
    //   - old nodes left to remove?
    // 	 - new nodes to insert?
    // 	 deal with them!
    //
    // The lists are only iterated over once, with an exception for the nodes in `old` that
    // are visited in the fourth part of the diff and in the `removeNodes` loop.
    // ## Diffing
    //
    // Reading https://github.com/localvoid/ivi/blob/ddc09d06abaef45248e6133f7040d00d3c6be853/packages/ivi/src/vdom/implementation.ts#L617-L837
    // may be good for context on longest increasing subsequence-based logic for moving nodes.
    //
    // In order to diff keyed lists, one has to
    //
    // 1) match nodes in both lists, per key, and update them accordingly
    // 2) create the nodes present in the new list, but absent in the old one
    // 3) remove the nodes present in the old list, but absent in the new one
    // 4) figure out what nodes in 1) to move in order to minimize the DOM operations.
    //
    // To achieve 1) one can create a dictionary of keys => index (for the old list), then iterate
    // over the new list and for each new vnode, find the corresponding vnode in the old list using
    // the map.
    // 2) is achieved in the same step: if a new node has no corresponding entry in the map, it is new
    // and must be created.
    // For the removals, we actually remove the nodes that have been updated from the old list.
    // The nodes that remain in that list after 1) and 2) have been performed can be safely removed.
    // The fourth step is a bit more complex and relies on the longest increasing subsequence (LIS)
    // algorithm.
    //
    // the longest increasing subsequence is the list of nodes that can remain in place. Imagine going
    // from `1,2,3,4,5` to `4,5,1,2,3` where the numbers are not necessarily the keys, but the indices
    // corresponding to the keyed nodes in the old list (keyed nodes `e,d,c,b,a` => `b,a,e,d,c` would
    //  match the above lists, for example).
    //
    // In there are two increasing subsequences: `4,5` and `1,2,3`, the latter being the longest. We
    // can update those nodes without moving them, and only call `insertNode` on `4` and `5`.
    //
    // @localvoid adapted the algo to also support node deletions and insertions (the `lis` is actually
    // the longest increasing subsequence *of old nodes still present in the new list*).
    //
    // It is a general algorithm that is fireproof in all circumstances, but it requires the allocation
    // and the construction of a `key => oldIndex` map, and three arrays (one with `newIndex => oldIndex`,
    // the `LIS` and a temporary one to create the LIS).
    //
    // So we cheat where we can: if the tails of the lists are identical, they are guaranteed to be part of
    // the LIS and can be updated without moving them.
    //
    // If two nodes are swapped, they are guaranteed not to be part of the LIS, and must be moved (with
    // the exception of the last node if the list is fully reversed).
    //
    // ## Finding the next sibling.
    //
    // `updateNode()` and `createNode()` expect a nextSibling parameter to perform DOM operations.
    // When the list is being traversed top-down, at any index, the DOM nodes up to the previous
    // vnode reflect the content of the new list, whereas the rest of the DOM nodes reflect the old
    // list. The next sibling must be looked for in the old list using `getNextSibling(... oldStart + 1 ...)`.
    //
    // In the other scenarios (swaps, upwards traversal, map-based diff),
    // the new vnodes list is traversed upwards. The DOM nodes at the bottom of the list reflect the
    // bottom part of the new vnodes list, and we can use the `v.dom`  value of the previous node
    // as the next sibling (cached in the `nextSibling` variable).
    // ## DOM node moves
    //
    // In most scenarios `updateNode()` and `createNode()` perform the DOM operations. However,
    // this is not the case if the node moved (second and fourth part of the diff algo). We move
    // the old DOM nodes before updateNode runs because it enables us to use the cached `nextSibling`
    // variable rather than fetching it using `getNextSibling()`.
    //
    // The fourth part of the diff currently inserts nodes unconditionally, leading to issues
    // like #1791 and #1999. We need to be smarter about those situations where adjascent old
    // nodes remain together in the new list in a way that isn't covered by parts one and
    // three of the diff algo.
    function updateNodes(parent, old, vnodes, hooks, nextSibling, ns) {
        if (old === vnodes || old == null && vnodes == null) return;
        else if (old == null || old.length === 0) createNodes(parent, vnodes, 0, vnodes.length, hooks, nextSibling, ns);
        else if (vnodes == null || vnodes.length === 0) removeNodes(parent, old, 0, old.length);
        else {
            var isOldKeyed = old[0] != null && old[0].key != null;
            var isKeyed = vnodes[0] != null && vnodes[0].key != null;
            var start = 0, oldStart = 0;
            if (!isOldKeyed) while(oldStart < old.length && old[oldStart] == null)oldStart++;
            if (!isKeyed) while(start < vnodes.length && vnodes[start] == null)start++;
            if (isOldKeyed !== isKeyed) {
                removeNodes(parent, old, oldStart, old.length);
                createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else if (!isKeyed) {
                // Don't index past the end of either list (causes deopts).
                var commonLength = old.length < vnodes.length ? old.length : vnodes.length;
                // Rewind if necessary to the first non-null index on either side.
                // We could alternatively either explicitly create or remove nodes when `start !== oldStart`
                // but that would be optimizing for sparse lists which are more rare than dense ones.
                start = start < oldStart ? start : oldStart;
                for(; start < commonLength; start++){
                    o = old[start];
                    v = vnodes[start];
                    if (o === v || o == null && v == null) continue;
                    else if (o == null) createNode(parent, v, hooks, ns, getNextSibling(old, start + 1, nextSibling));
                    else if (v == null) removeNode(parent, o);
                    else updateNode(parent, o, v, hooks, getNextSibling(old, start + 1, nextSibling), ns);
                }
                if (old.length > commonLength) removeNodes(parent, old, start, old.length);
                if (vnodes.length > commonLength) createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else {
                // keyed diff
                var oldEnd = old.length - 1, end = vnodes.length - 1, map, o, v, oe, ve, topSibling;
                // bottom-up
                while(oldEnd >= oldStart && end >= start){
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                }
                // top-down
                while(oldEnd >= oldStart && end >= start){
                    o = old[oldStart];
                    v = vnodes[start];
                    if (o.key !== v.key) break;
                    oldStart++, start++;
                    if (o !== v) updateNode(parent, o, v, hooks, getNextSibling(old, oldStart, nextSibling), ns);
                }
                // swaps and list reversals
                while(oldEnd >= oldStart && end >= start){
                    if (start === end) break;
                    if (o.key !== ve.key || oe.key !== v.key) break;
                    topSibling = getNextSibling(old, oldStart, nextSibling);
                    moveNodes(parent, oe, topSibling);
                    if (oe !== v) updateNode(parent, oe, v, hooks, topSibling, ns);
                    if (++start <= --end) moveNodes(parent, o, nextSibling);
                    if (o !== ve) updateNode(parent, o, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldStart++;
                    oldEnd--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    o = old[oldStart];
                    v = vnodes[start];
                }
                // bottom up once again
                while(oldEnd >= oldStart && end >= start){
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                }
                if (start > end) removeNodes(parent, old, oldStart, oldEnd + 1);
                else if (oldStart > oldEnd) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                else {
                    // inspired by ivi https://github.com/ivijs/ivi/ by Boris Kaul
                    var originalNextSibling = nextSibling, vnodesLength = end - start + 1, oldIndices = new Array(vnodesLength), li = 0, i = 0, pos = 2147483647, matched = 0, map, lisIndices;
                    for(i = 0; i < vnodesLength; i++)oldIndices[i] = -1;
                    for(i = end; i >= start; i--){
                        if (map == null) map = getKeyMap(old, oldStart, oldEnd + 1);
                        ve = vnodes[i];
                        var oldIndex = map[ve.key];
                        if (oldIndex != null) {
                            pos = oldIndex < pos ? oldIndex : -1 // becomes -1 if nodes were re-ordered
                            ;
                            oldIndices[i - start] = oldIndex;
                            oe = old[oldIndex];
                            old[oldIndex] = null;
                            if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                            if (ve.dom != null) nextSibling = ve.dom;
                            matched++;
                        }
                    }
                    nextSibling = originalNextSibling;
                    if (matched !== oldEnd - oldStart + 1) removeNodes(parent, old, oldStart, oldEnd + 1);
                    if (matched === 0) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                    else {
                        if (pos === -1) {
                            // the indices of the indices of the items that are part of the
                            // longest increasing subsequence in the oldIndices list
                            lisIndices = makeLisIndices(oldIndices);
                            li = lisIndices.length - 1;
                            for(i = end; i >= start; i--){
                                v = vnodes[i];
                                if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                                else if (lisIndices[li] === i - start) li--;
                                else moveNodes(parent, v, nextSibling);
                                if (v.dom != null) nextSibling = vnodes[i].dom;
                            }
                        } else for(i = end; i >= start; i--){
                            v = vnodes[i];
                            if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                            if (v.dom != null) nextSibling = vnodes[i].dom;
                        }
                    }
                }
            }
        }
    }
    function updateNode(parent, old, vnode, hooks, nextSibling, ns) {
        var oldTag = old.tag, tag = vnode.tag;
        if (oldTag === tag) {
            vnode.state = old.state;
            vnode.events = old.events;
            if (shouldNotUpdate(vnode, old)) return;
            if (typeof oldTag === "string") {
                if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
                switch(oldTag){
                    case "#":
                        updateText(old, vnode);
                        break;
                    case "<":
                        updateHTML(parent, old, vnode, ns, nextSibling);
                        break;
                    case "[":
                        updateFragment(parent, old, vnode, hooks, nextSibling, ns);
                        break;
                    default:
                        updateElement(old, vnode, hooks, ns);
                }
            } else updateComponent(parent, old, vnode, hooks, nextSibling, ns);
        } else {
            removeNode(parent, old);
            createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function updateText(old, vnode) {
        if (old.children.toString() !== vnode.children.toString()) old.dom.nodeValue = vnode.children;
        vnode.dom = old.dom;
    }
    function updateHTML(parent, old, vnode, ns, nextSibling) {
        if (old.children !== vnode.children) {
            removeHTML(parent, old);
            createHTML(parent, vnode, ns, nextSibling);
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
            vnode.instance = old.instance;
        }
    }
    function updateFragment(parent, old, vnode, hooks, nextSibling, ns) {
        updateNodes(parent, old.children, vnode.children, hooks, nextSibling, ns);
        var domSize = 0, children = vnode.children;
        vnode.dom = null;
        if (children != null) {
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null && child.dom != null) {
                    if (vnode.dom == null) vnode.dom = child.dom;
                    domSize += child.domSize || 1;
                }
            }
            if (domSize !== 1) vnode.domSize = domSize;
        }
    }
    function updateElement(old, vnode, hooks, ns) {
        var element = vnode.dom = old.dom;
        ns = getNameSpace(vnode) || ns;
        if (vnode.tag === "textarea") {
            if (vnode.attrs == null) vnode.attrs = {};
        }
        updateAttrs(vnode, old.attrs, vnode.attrs, ns);
        if (!maybeSetContentEditable(vnode)) updateNodes(element, old.children, vnode.children, hooks, null, ns);
    }
    function updateComponent(parent, old, vnode, hooks, nextSibling, ns) {
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        updateLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
        if (vnode.instance != null) {
            if (old.instance == null) createNode(parent, vnode.instance, hooks, ns, nextSibling);
            else updateNode(parent, old.instance, vnode.instance, hooks, nextSibling, ns);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.instance.domSize;
        } else if (old.instance != null) {
            removeNode(parent, old.instance);
            vnode.dom = undefined;
            vnode.domSize = 0;
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function getKeyMap(vnodes, start, end) {
        var map = Object.create(null);
        for(; start < end; start++){
            var vnode = vnodes[start];
            if (vnode != null) {
                var key = vnode.key;
                if (key != null) map[key] = start;
            }
        }
        return map;
    }
    // Lifted from ivi https://github.com/ivijs/ivi/
    // takes a list of unique numbers (-1 is special and can
    // occur multiple times) and returns an array with the indices
    // of the items that are part of the longest increasing
    // subsequence
    var lisTemp = [];
    function makeLisIndices(a) {
        var result = [
            0
        ];
        var u = 0, v = 0, i = 0;
        var il = lisTemp.length = a.length;
        for(var i = 0; i < il; i++)lisTemp[i] = a[i];
        for(var i = 0; i < il; ++i){
            if (a[i] === -1) continue;
            var j = result[result.length - 1];
            if (a[j] < a[i]) {
                lisTemp[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                // Fast integer average without overflow.
                // eslint-disable-next-line no-bitwise
                var c = (u >>> 1) + (v >>> 1) + (u & v & 1);
                if (a[result[c]] < a[i]) u = c + 1;
                else v = c;
            }
            if (a[i] < a[result[u]]) {
                if (u > 0) lisTemp[i] = result[u - 1];
                result[u] = i;
            }
        }
        u = result.length;
        v = result[u - 1];
        while(u-- > 0){
            result[u] = v;
            v = lisTemp[v];
        }
        lisTemp.length = 0;
        return result;
    }
    function getNextSibling(vnodes, i, nextSibling) {
        for(; i < vnodes.length; i++){
            if (vnodes[i] != null && vnodes[i].dom != null) return vnodes[i].dom;
        }
        return nextSibling;
    }
    // This covers a really specific edge case:
    // - Parent node is keyed and contains child
    // - Child is removed, returns unresolved promise in `onbeforeremove`
    // - Parent node is moved in keyed diff
    // - Remaining children still need moved appropriately
    //
    // Ideally, I'd track removed nodes as well, but that introduces a lot more
    // complexity and I'm not exactly interested in doing that.
    function moveNodes(parent, vnode, nextSibling) {
        var frag = $doc.createDocumentFragment();
        moveChildToFrag(parent, frag, vnode);
        insertNode(parent, frag, nextSibling);
    }
    function moveChildToFrag(parent, frag, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") for(var i = 0; i < vnode.instance.length; i++)frag.appendChild(vnode.instance[i]);
            else if (vnode.tag !== "[") // Don't recurse for text nodes *or* elements, just fragments
            frag.appendChild(vnode.dom);
            else if (vnode.children.length === 1) {
                vnode = vnode.children[0];
                if (vnode != null) continue;
            } else for(var i = 0; i < vnode.children.length; i++){
                var child = vnode.children[i];
                if (child != null) moveChildToFrag(parent, frag, child);
            }
            break;
        }
    }
    function insertNode(parent, dom, nextSibling) {
        if (nextSibling != null) parent.insertBefore(dom, nextSibling);
        else parent.appendChild(dom);
    }
    function maybeSetContentEditable(vnode) {
        if (vnode.attrs == null || vnode.attrs.contenteditable == null && // attribute
        vnode.attrs.contentEditable == null // property
        ) return false;
        var children = vnode.children;
        if (children != null && children.length === 1 && children[0].tag === "<") {
            var content = children[0].children;
            if (vnode.dom.innerHTML !== content) vnode.dom.innerHTML = content;
        } else if (children != null && children.length !== 0) throw new Error("Child node of a contenteditable must be trusted.");
        return true;
    }
    //remove
    function removeNodes(parent, vnodes, start, end) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) removeNode(parent, vnode);
        }
    }
    function removeNode(parent, vnode) {
        var mask = 0;
        var original = vnode.state;
        var stateResult, attrsResult;
        if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeremove === "function") {
            var result = callHook.call(vnode.state.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                mask = 1;
                stateResult = result;
            }
        }
        if (vnode.attrs && typeof vnode.attrs.onbeforeremove === "function") {
            var result = callHook.call(vnode.attrs.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                // eslint-disable-next-line no-bitwise
                mask |= 2;
                attrsResult = result;
            }
        }
        checkState(vnode, original);
        // If we can, try to fast-path it and avoid all the overhead of awaiting
        if (!mask) {
            onremove(vnode);
            removeChild(parent, vnode);
        } else {
            if (stateResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 1) {
                        mask &= 2;
                        if (!mask) reallyRemove();
                    }
                };
                stateResult.then(next, next);
            }
            if (attrsResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 2) {
                        mask &= 1;
                        if (!mask) reallyRemove();
                    }
                };
                attrsResult.then(next, next);
            }
        }
        function reallyRemove() {
            checkState(vnode, original);
            onremove(vnode);
            removeChild(parent, vnode);
        }
    }
    function removeHTML(parent, vnode) {
        for(var i = 0; i < vnode.instance.length; i++)parent.removeChild(vnode.instance[i]);
    }
    function removeChild(parent, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") removeHTML(parent, vnode);
            else {
                if (vnode.tag !== "[") {
                    parent.removeChild(vnode.dom);
                    if (!Array.isArray(vnode.children)) break;
                }
                if (vnode.children.length === 1) {
                    vnode = vnode.children[0];
                    if (vnode != null) continue;
                } else for(var i = 0; i < vnode.children.length; i++){
                    var child = vnode.children[i];
                    if (child != null) removeChild(parent, child);
                }
            }
            break;
        }
    }
    function onremove(vnode) {
        if (typeof vnode.tag !== "string" && typeof vnode.state.onremove === "function") callHook.call(vnode.state.onremove, vnode);
        if (vnode.attrs && typeof vnode.attrs.onremove === "function") callHook.call(vnode.attrs.onremove, vnode);
        if (typeof vnode.tag !== "string") {
            if (vnode.instance != null) onremove(vnode.instance);
        } else {
            var children = vnode.children;
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null) onremove(child);
            }
        }
    }
    //attrs
    function setAttrs(vnode, attrs, ns) {
        // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
        //
        // Also, the DOM does things to inputs based on the value, so it needs set first.
        // See: https://github.com/MithrilJS/mithril.js/issues/2622
        if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
        var isFileInput = attrs != null && vnode.tag === "input" && attrs.type === "file";
        for(var key in attrs)setAttr(vnode, key, null, attrs[key], ns, isFileInput);
    }
    function setAttr(vnode, key, old, value, ns, isFileInput) {
        if (key === "key" || key === "is" || value == null || isLifecycleMethod(key) || old === value && !isFormAttribute(vnode, key) && typeof value !== "object" || key === "type" && vnode.tag === "input") return;
        if (key[0] === "o" && key[1] === "n") return updateEvent(vnode, key, value);
        if (key.slice(0, 6) === "xlink:") vnode.dom.setAttributeNS("http://www.w3.org/1999/xlink", key.slice(6), value);
        else if (key === "style") updateStyle(vnode.dom, old, value);
        else if (hasPropertyKey(vnode, key, ns)) {
            if (key === "value") {
                // Only do the coercion if we're actually going to check the value.
                /* eslint-disable no-implicit-coercion */ //setting input[value] to same value by typing on focused element moves cursor to end in Chrome
                //setting input[type=file][value] to same value causes an error to be generated if it's non-empty
                if ((vnode.tag === "input" || vnode.tag === "textarea") && vnode.dom.value === "" + value && (isFileInput || vnode.dom === activeElement())) return;
                //setting select[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "select" && old !== null && vnode.dom.value === "" + value) return;
                //setting option[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "option" && old !== null && vnode.dom.value === "" + value) return;
                //setting input[type=file][value] to different value is an error if it's non-empty
                // Not ideal, but it at least works around the most common source of uncaught exceptions for now.
                if (isFileInput && "" + value !== "") {
                    console.error("`value` is read-only on file inputs!");
                    return;
                }
            /* eslint-enable no-implicit-coercion */ }
            vnode.dom[key] = value;
        } else if (typeof value === "boolean") {
            if (value) vnode.dom.setAttribute(key, "");
            else vnode.dom.removeAttribute(key);
        } else vnode.dom.setAttribute(key === "className" ? "class" : key, value);
    }
    function removeAttr(vnode, key, old, ns) {
        if (key === "key" || key === "is" || old == null || isLifecycleMethod(key)) return;
        if (key[0] === "o" && key[1] === "n") updateEvent(vnode, key, undefined);
        else if (key === "style") updateStyle(vnode.dom, old, null);
        else if (hasPropertyKey(vnode, key, ns) && key !== "className" && key !== "title" // creates "null" as title
         && !(key === "value" && (vnode.tag === "option" || vnode.tag === "select" && vnode.dom.selectedIndex === -1 && vnode.dom === activeElement())) && !(vnode.tag === "input" && key === "type")) vnode.dom[key] = null;
        else {
            var nsLastIndex = key.indexOf(":");
            if (nsLastIndex !== -1) key = key.slice(nsLastIndex + 1);
            if (old !== false) vnode.dom.removeAttribute(key === "className" ? "class" : key);
        }
    }
    function setLateSelectAttrs(vnode, attrs) {
        if ("value" in attrs) {
            if (attrs.value === null) {
                if (vnode.dom.selectedIndex !== -1) vnode.dom.value = null;
            } else {
                var normalized = "" + attrs.value // eslint-disable-line no-implicit-coercion
                ;
                if (vnode.dom.value !== normalized || vnode.dom.selectedIndex === -1) vnode.dom.value = normalized;
            }
        }
        if ("selectedIndex" in attrs) setAttr(vnode, "selectedIndex", null, attrs.selectedIndex, undefined);
    }
    function updateAttrs(vnode, old, attrs, ns) {
        if (old && old === attrs) console.warn("Don't reuse attrs object, use new object for every redraw, this will throw in next major");
        if (attrs != null) {
            // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
            //
            // Also, the DOM does things to inputs based on the value, so it needs set first.
            // See: https://github.com/MithrilJS/mithril.js/issues/2622
            if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
            var isFileInput = vnode.tag === "input" && attrs.type === "file";
            for(var key in attrs)setAttr(vnode, key, old && old[key], attrs[key], ns, isFileInput);
        }
        var val;
        if (old != null) {
            for(var key in old)if ((val = old[key]) != null && (attrs == null || attrs[key] == null)) removeAttr(vnode, key, val, ns);
        }
    }
    function isFormAttribute(vnode, attr) {
        return attr === "value" || attr === "checked" || attr === "selectedIndex" || attr === "selected" && vnode.dom === activeElement() || vnode.tag === "option" && vnode.dom.parentNode === $doc.activeElement;
    }
    function isLifecycleMethod(attr) {
        return attr === "oninit" || attr === "oncreate" || attr === "onupdate" || attr === "onremove" || attr === "onbeforeremove" || attr === "onbeforeupdate";
    }
    function hasPropertyKey(vnode, key, ns) {
        // Filter out namespaced keys
        return ns === undefined && // If it's a custom element, just keep it.
        (vnode.tag.indexOf("-") > -1 || vnode.attrs != null && vnode.attrs.is || // If it's a normal element, let's try to avoid a few browser bugs.
        key !== "href" && key !== "list" && key !== "form" && key !== "width" && key !== "height" // && key !== "type"
        ) && key in vnode.dom;
    }
    //style
    var uppercaseRegex = /[A-Z]/g;
    function toLowerCase(capital) {
        return "-" + capital.toLowerCase();
    }
    function normalizeKey(key) {
        return key[0] === "-" && key[1] === "-" ? key : key === "cssFloat" ? "float" : key.replace(uppercaseRegex, toLowerCase);
    }
    function updateStyle(element, old, style) {
        if (old === style) ;
        else if (style == null) // New style is missing, just clear it.
        element.style.cssText = "";
        else if (typeof style !== "object") // New style is a string, let engine deal with patching.
        element.style.cssText = style;
        else if (old == null || typeof old !== "object") {
            // `old` is missing or a string, `style` is an object.
            element.style.cssText = "";
            // Add new style properties
            for(var key in style){
                var value = style[key];
                if (value != null) element.style.setProperty(normalizeKey(key), String(value));
            }
        } else {
            // Both old & new are (different) objects.
            // Update style properties that have changed
            for(var key in style){
                var value = style[key];
                if (value != null && (value = String(value)) !== String(old[key])) element.style.setProperty(normalizeKey(key), value);
            }
            // Remove style properties that no longer exist
            for(var key in old)if (old[key] != null && style[key] == null) element.style.removeProperty(normalizeKey(key));
        }
    }
    // Here's an explanation of how this works:
    // 1. The event names are always (by design) prefixed by `on`.
    // 2. The EventListener interface accepts either a function or an object
    //    with a `handleEvent` method.
    // 3. The object does not inherit from `Object.prototype`, to avoid
    //    any potential interference with that (e.g. setters).
    // 4. The event name is remapped to the handler before calling it.
    // 5. In function-based event handlers, `ev.target === this`. We replicate
    //    that below.
    // 6. In function-based event handlers, `return false` prevents the default
    //    action and stops event propagation. We replicate that below.
    function EventDict() {
        // Save this, so the current redraw is correctly tracked.
        this._ = currentRedraw;
    }
    EventDict.prototype = Object.create(null);
    EventDict.prototype.handleEvent = function(ev) {
        var handler = this["on" + ev.type];
        var result;
        if (typeof handler === "function") result = handler.call(ev.currentTarget, ev);
        else if (typeof handler.handleEvent === "function") handler.handleEvent(ev);
        if (this._ && ev.redraw !== false) (0, this._)();
        if (result === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    //event
    function updateEvent(vnode, key, value) {
        if (vnode.events != null) {
            vnode.events._ = currentRedraw;
            if (vnode.events[key] === value) return;
            if (value != null && (typeof value === "function" || typeof value === "object")) {
                if (vnode.events[key] == null) vnode.dom.addEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = value;
            } else {
                if (vnode.events[key] != null) vnode.dom.removeEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = undefined;
            }
        } else if (value != null && (typeof value === "function" || typeof value === "object")) {
            vnode.events = new EventDict();
            vnode.dom.addEventListener(key.slice(2), vnode.events, false);
            vnode.events[key] = value;
        }
    }
    //lifecycle
    function initLifecycle(source, vnode, hooks) {
        if (typeof source.oninit === "function") callHook.call(source.oninit, vnode);
        if (typeof source.oncreate === "function") hooks.push(callHook.bind(source.oncreate, vnode));
    }
    function updateLifecycle(source, vnode, hooks) {
        if (typeof source.onupdate === "function") hooks.push(callHook.bind(source.onupdate, vnode));
    }
    function shouldNotUpdate(vnode, old) {
        do {
            if (vnode.attrs != null && typeof vnode.attrs.onbeforeupdate === "function") {
                var force = callHook.call(vnode.attrs.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeupdate === "function") {
                var force = callHook.call(vnode.state.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            return false;
        }while (false); // eslint-disable-line no-constant-condition
        vnode.dom = old.dom;
        vnode.domSize = old.domSize;
        vnode.instance = old.instance;
        // One would think having the actual latest attributes would be ideal,
        // but it doesn't let us properly diff based on our current internal
        // representation. We have to save not only the old DOM info, but also
        // the attributes used to create it, as we diff *that*, not against the
        // DOM directly (with a few exceptions in `setAttr`). And, of course, we
        // need to save the children and text as they are conceptually not
        // unlike special "attributes" internally.
        vnode.attrs = old.attrs;
        vnode.children = old.children;
        vnode.text = old.text;
        return true;
    }
    var currentDOM;
    return function(dom, vnodes, redraw) {
        if (!dom) throw new TypeError("DOM element being rendered to does not exist.");
        if (currentDOM != null && dom.contains(currentDOM)) throw new TypeError("Node is currently being rendered to and thus is locked.");
        var prevRedraw = currentRedraw;
        var prevDOM = currentDOM;
        var hooks = [];
        var active = activeElement();
        var namespace = dom.namespaceURI;
        currentDOM = dom;
        currentRedraw = typeof redraw === "function" ? redraw : undefined;
        try {
            // First time rendering into a node clears it out
            if (dom.vnodes == null) dom.textContent = "";
            vnodes = $dBs8J.normalizeChildren(Array.isArray(vnodes) ? vnodes : [
                vnodes
            ]);
            updateNodes(dom, dom.vnodes, vnodes, hooks, null, namespace === "http://www.w3.org/1999/xhtml" ? undefined : namespace);
            dom.vnodes = vnodes;
            // `document.activeElement` can return null: https://html.spec.whatwg.org/multipage/interaction.html#dom-document-activeelement
            if (active != null && activeElement() !== active && typeof active.focus === "function") active.focus();
            for(var i = 0; i < hooks.length; i++)hooks[i]();
        } finally{
            currentRedraw = prevRedraw;
            currentDOM = prevDOM;
        }
    };
};

});


parcelRegister("iZais", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(render, schedule, console) {
    var subscriptions = [];
    var pending = false;
    var offset = -1;
    function sync() {
        for(offset = 0; offset < subscriptions.length; offset += 2)try {
            render(subscriptions[offset], $dBs8J(subscriptions[offset + 1]), redraw);
        } catch (e) {
            console.error(e);
        }
        offset = -1;
    }
    function redraw() {
        if (!pending) {
            pending = true;
            schedule(function() {
                pending = false;
                sync();
            });
        }
    }
    redraw.sync = sync;
    function mount(root, component) {
        if (component != null && component.view == null && typeof component !== "function") throw new TypeError("m.mount expects a component, not a vnode.");
        var index = subscriptions.indexOf(root);
        if (index >= 0) {
            subscriptions.splice(index, 2);
            if (index <= offset) offset -= 2;
            render(root, []);
        }
        if (component != null) {
            subscriptions.push(root, component);
            render(root, $dBs8J(component), redraw);
        }
    }
    return {
        mount: mount,
        redraw: redraw
    };
};

});

parcelRegister("5y2KI", function(module, exports) {
"use strict";

var $cITMw = parcelRequire("cITMw");

var $9eOch = parcelRequire("9eOch");
module.exports = function($window, Promise, oncompletion) {
    var callbackCount = 0;
    function PromiseProxy(executor) {
        return new Promise(executor);
    }
    // In case the global Promise is some userland library's where they rely on
    // `foo instanceof this.constructor`, `this.constructor.resolve(value)`, or
    // similar. Let's *not* break them.
    PromiseProxy.prototype = Promise.prototype;
    PromiseProxy.__proto__ = Promise // eslint-disable-line no-proto
    ;
    function makeRequest(factory) {
        return function(url, args) {
            if (typeof url !== "string") {
                args = url;
                url = url.url;
            } else if (args == null) args = {};
            var promise = new Promise(function(resolve, reject) {
                factory($cITMw(url, args.params), args, function(data) {
                    if (typeof args.type === "function") {
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)data[i] = new args.type(data[i]);
                        else data = new args.type(data);
                    }
                    resolve(data);
                }, reject);
            });
            if (args.background === true) return promise;
            var count = 0;
            function complete() {
                if (--count === 0 && typeof oncompletion === "function") oncompletion();
            }
            return wrap(promise);
            function wrap(promise) {
                var then = promise.then;
                // Set the constructor, so engines know to not await or resolve
                // this as a native promise. At the time of writing, this is
                // only necessary for V8, but their behavior is the correct
                // behavior per spec. See this spec issue for more details:
                // https://github.com/tc39/ecma262/issues/1577. Also, see the
                // corresponding comment in `request/tests/test-request.js` for
                // a bit more background on the issue at hand.
                promise.constructor = PromiseProxy;
                promise.then = function() {
                    count++;
                    var next = then.apply(promise, arguments);
                    next.then(complete, function(e) {
                        complete();
                        if (count === 0) throw e;
                    });
                    return wrap(next);
                };
                return promise;
            }
        };
    }
    function hasHeader(args, name) {
        for(var key in args.headers){
            if ($9eOch.call(args.headers, key) && key.toLowerCase() === name) return true;
        }
        return false;
    }
    return {
        request: makeRequest(function(url, args, resolve, reject) {
            var method = args.method != null ? args.method.toUpperCase() : "GET";
            var body = args.body;
            var assumeJSON = (args.serialize == null || args.serialize === JSON.serialize) && !(body instanceof $window.FormData || body instanceof $window.URLSearchParams);
            var responseType = args.responseType || (typeof args.extract === "function" ? "" : "json");
            var xhr = new $window.XMLHttpRequest(), aborted = false, isTimeout = false;
            var original = xhr, replacedAbort;
            var abort = xhr.abort;
            xhr.abort = function() {
                aborted = true;
                abort.call(this);
            };
            xhr.open(method, url, args.async !== false, typeof args.user === "string" ? args.user : undefined, typeof args.password === "string" ? args.password : undefined);
            if (assumeJSON && body != null && !hasHeader(args, "content-type")) xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
            if (typeof args.deserialize !== "function" && !hasHeader(args, "accept")) xhr.setRequestHeader("Accept", "application/json, text/*");
            if (args.withCredentials) xhr.withCredentials = args.withCredentials;
            if (args.timeout) xhr.timeout = args.timeout;
            xhr.responseType = responseType;
            for(var key in args.headers)if ($9eOch.call(args.headers, key)) xhr.setRequestHeader(key, args.headers[key]);
            xhr.onreadystatechange = function(ev) {
                // Don't throw errors on xhr.abort().
                if (aborted) return;
                if (ev.target.readyState === 4) try {
                    var success = ev.target.status >= 200 && ev.target.status < 300 || ev.target.status === 304 || /^file:\/\//i.test(url);
                    // When the response type isn't "" or "text",
                    // `xhr.responseText` is the wrong thing to use.
                    // Browsers do the right thing and throw here, and we
                    // should honor that and do the right thing by
                    // preferring `xhr.response` where possible/practical.
                    var response = ev.target.response, message;
                    if (responseType === "json") {
                        // For IE and Edge, which don't implement
                        // `responseType: "json"`.
                        if (!ev.target.responseType && typeof args.extract !== "function") // Handle no-content which will not parse.
                        try {
                            response = JSON.parse(ev.target.responseText);
                        } catch (e) {
                            response = null;
                        }
                    } else if (!responseType || responseType === "text") // Only use this default if it's text. If a parsed
                    // document is needed on old IE and friends (all
                    // unsupported), the user should use a custom
                    // `config` instead. They're already using this at
                    // their own risk.
                    {
                        if (response == null) response = ev.target.responseText;
                    }
                    if (typeof args.extract === "function") {
                        response = args.extract(ev.target, args);
                        success = true;
                    } else if (typeof args.deserialize === "function") response = args.deserialize(response);
                    if (success) resolve(response);
                    else {
                        var completeErrorResponse = function() {
                            try {
                                message = ev.target.responseText;
                            } catch (e) {
                                message = response;
                            }
                            var error = new Error(message);
                            error.code = ev.target.status;
                            error.response = response;
                            reject(error);
                        };
                        if (xhr.status === 0) // Use setTimeout to push this code block onto the event queue
                        // This allows `xhr.ontimeout` to run in the case that there is a timeout
                        // Without this setTimeout, `xhr.ontimeout` doesn't have a chance to reject
                        // as `xhr.onreadystatechange` will run before it
                        setTimeout(function() {
                            if (isTimeout) return;
                            completeErrorResponse();
                        });
                        else completeErrorResponse();
                    }
                } catch (e) {
                    reject(e);
                }
            };
            xhr.ontimeout = function(ev) {
                isTimeout = true;
                var error = new Error("Request timed out");
                error.code = ev.target.status;
                reject(error);
            };
            if (typeof args.config === "function") {
                xhr = args.config(xhr, args, url) || xhr;
                // Propagate the `abort` to any replacement XHR as well.
                if (xhr !== original) {
                    replacedAbort = xhr.abort;
                    xhr.abort = function() {
                        aborted = true;
                        replacedAbort.call(this);
                    };
                }
            }
            if (body == null) xhr.send();
            else if (typeof args.serialize === "function") xhr.send(args.serialize(body));
            else if (body instanceof $window.FormData || body instanceof $window.URLSearchParams) xhr.send(body);
            else xhr.send(JSON.stringify(body));
        }),
        jsonp: makeRequest(function(url, args, resolve, reject) {
            var callbackName = args.callbackName || "_mithril_" + Math.round(Math.random() * 1e16) + "_" + callbackCount++;
            var script = $window.document.createElement("script");
            $window[callbackName] = function(data) {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                resolve(data);
            };
            script.onerror = function() {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                reject(new Error("JSONP request failed"));
            };
            script.src = url + (url.indexOf("?") < 0 ? "?" : "&") + encodeURIComponent(args.callbackKey || "callback") + "=" + encodeURIComponent(callbackName);
            $window.document.documentElement.appendChild(script);
        })
    };
};

});
parcelRegister("cITMw", function(module, exports) {
"use strict";

var $iRA82 = parcelRequire("iRA82");

var $enXzN = parcelRequire("enXzN");
// Returns `path` from `template` + `params`
module.exports = function(template, params) {
    if (/:([^\/\.-]+)(\.{3})?:/.test(template)) throw new SyntaxError("Template parameter names must be separated by either a '/', '-', or '.'.");
    if (params == null) return template;
    var queryIndex = template.indexOf("?");
    var hashIndex = template.indexOf("#");
    var queryEnd = hashIndex < 0 ? template.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = template.slice(0, pathEnd);
    var query = {};
    $enXzN(query, params);
    var resolved = path.replace(/:([^\/\.-]+)(\.{3})?/g, function(m, key, variadic) {
        delete query[key];
        // If no such parameter exists, don't interpolate it.
        if (params[key] == null) return m;
        // Escape normal parameters, but not variadic ones.
        return variadic ? params[key] : encodeURIComponent(String(params[key]));
    });
    // In case the template substitution adds new query/hash parameters.
    var newQueryIndex = resolved.indexOf("?");
    var newHashIndex = resolved.indexOf("#");
    var newQueryEnd = newHashIndex < 0 ? resolved.length : newHashIndex;
    var newPathEnd = newQueryIndex < 0 ? newQueryEnd : newQueryIndex;
    var result = resolved.slice(0, newPathEnd);
    if (queryIndex >= 0) result += template.slice(queryIndex, queryEnd);
    if (newQueryIndex >= 0) result += (queryIndex < 0 ? "?" : "&") + resolved.slice(newQueryIndex, newQueryEnd);
    var querystring = $iRA82(query);
    if (querystring) result += (queryIndex < 0 && newQueryIndex < 0 ? "?" : "&") + querystring;
    if (hashIndex >= 0) result += template.slice(hashIndex);
    if (newHashIndex >= 0) result += (hashIndex < 0 ? "" : "&") + resolved.slice(newHashIndex);
    return result;
};

});
parcelRegister("iRA82", function(module, exports) {
"use strict";
module.exports = function(object) {
    if (Object.prototype.toString.call(object) !== "[object Object]") return "";
    var args = [];
    for(var key in object)destructure(key, object[key]);
    return args.join("&");
    function destructure(key, value) {
        if (Array.isArray(value)) for(var i = 0; i < value.length; i++)destructure(key + "[" + i + "]", value[i]);
        else if (Object.prototype.toString.call(value) === "[object Object]") for(var i in value)destructure(key + "[" + i + "]", value[i]);
        else args.push(encodeURIComponent(key) + (value != null && value !== "" ? "=" + encodeURIComponent(value) : ""));
    }
};

});

parcelRegister("enXzN", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";

var $9eOch = parcelRequire("9eOch");
module.exports = Object.assign || function(target, source) {
    for(var key in source)if ($9eOch.call(source, key)) target[key] = source[key];
};

});
parcelRegister("9eOch", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";
module.exports = ({}).hasOwnProperty;

});




parcelRegister("4Ppi2", function(module, exports) {
"use strict";

var $7EF0O = parcelRequire("7EF0O");

module.exports = (parcelRequire("eFHZ8"))(typeof window !== "undefined" ? window : null, $7EF0O);

});
parcelRegister("7EF0O", function(module, exports) {
"use strict";

var $j25vk = parcelRequire("j25vk");

module.exports = (parcelRequire("iZais"))($j25vk, typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : null, typeof console !== "undefined" ? console : null);

});

parcelRegister("eFHZ8", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $iVcuU = parcelRequire("iVcuU");

var $2uPnQ = parcelRequire("2uPnQ");

var $cITMw = parcelRequire("cITMw");

var $7lWrV = parcelRequire("7lWrV");

var $8KlxE = parcelRequire("8KlxE");

var $enXzN = parcelRequire("enXzN");

var $e9o88 = parcelRequire("e9o88");
var $aae70388e69e8325$var$sentinel = {};
function $aae70388e69e8325$var$decodeURIComponentSave(component) {
    try {
        return decodeURIComponent(component);
    } catch (e) {
        return component;
    }
}
module.exports = function($window, mountRedraw) {
    var callAsync = $window == null ? null : typeof $window.setImmediate === "function" ? $window.setImmediate : $window.setTimeout;
    var p = $2uPnQ.resolve();
    var scheduled = false;
    // state === 0: init
    // state === 1: scheduled
    // state === 2: done
    var ready = false;
    var state = 0;
    var compiled, fallbackRoute;
    var currentResolver = $aae70388e69e8325$var$sentinel, component, attrs, currentPath, lastUpdate;
    var RouterRoot = {
        onbeforeupdate: function() {
            state = state ? 2 : 1;
            return !(!state || $aae70388e69e8325$var$sentinel === currentResolver);
        },
        onremove: function() {
            $window.removeEventListener("popstate", fireAsync, false);
            $window.removeEventListener("hashchange", resolveRoute, false);
        },
        view: function() {
            if (!state || $aae70388e69e8325$var$sentinel === currentResolver) return;
            // Wrap in a fragment to preserve existing key semantics
            var vnode = [
                $dBs8J(component, attrs.key, attrs)
            ];
            if (currentResolver) vnode = currentResolver.render(vnode[0]);
            return vnode;
        }
    };
    var SKIP = route.SKIP = {};
    function resolveRoute() {
        scheduled = false;
        // Consider the pathname holistically. The prefix might even be invalid,
        // but that's not our problem.
        var prefix = $window.location.hash;
        if (route.prefix[0] !== "#") {
            prefix = $window.location.search + prefix;
            if (route.prefix[0] !== "?") {
                prefix = $window.location.pathname + prefix;
                if (prefix[0] !== "/") prefix = "/" + prefix;
            }
        }
        // This seemingly useless `.concat()` speeds up the tests quite a bit,
        // since the representation is consistently a relatively poorly
        // optimized cons string.
        var path = prefix.concat().replace(/(?:%[a-f89][a-f0-9])+/gim, $aae70388e69e8325$var$decodeURIComponentSave).slice(route.prefix.length);
        var data = $7lWrV(path);
        $enXzN(data.params, $window.history.state);
        function reject(e) {
            console.error(e);
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
        loop(0);
        function loop(i) {
            // state === 0: init
            // state === 1: scheduled
            // state === 2: done
            for(; i < compiled.length; i++)if (compiled[i].check(data)) {
                var payload = compiled[i].component;
                var matchedRoute = compiled[i].route;
                var localComp = payload;
                var update = lastUpdate = function(comp) {
                    if (update !== lastUpdate) return;
                    if (comp === SKIP) return loop(i + 1);
                    component = comp != null && (typeof comp.view === "function" || typeof comp === "function") ? comp : "div";
                    attrs = data.params, currentPath = path, lastUpdate = null;
                    currentResolver = payload.render ? payload : null;
                    if (state === 2) mountRedraw.redraw();
                    else {
                        state = 2;
                        mountRedraw.redraw.sync();
                    }
                };
                // There's no understating how much I *wish* I could
                // use `async`/`await` here...
                if (payload.view || typeof payload === "function") {
                    payload = {};
                    update(localComp);
                } else if (payload.onmatch) p.then(function() {
                    return payload.onmatch(data.params, path, matchedRoute);
                }).then(update, path === fallbackRoute ? null : reject);
                else update("div");
                return;
            }
            if (path === fallbackRoute) throw new Error("Could not resolve default route " + fallbackRoute + ".");
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
    }
    // Set it unconditionally so `m.route.set` and `m.route.Link` both work,
    // even if neither `pushState` nor `hashchange` are supported. It's
    // cleared if `hashchange` is used, since that makes it automatically
    // async.
    function fireAsync() {
        if (!scheduled) {
            scheduled = true;
            // TODO: just do `mountRedraw.redraw()` here and elide the timer
            // dependency. Note that this will muck with tests a *lot*, so it's
            // not as easy of a change as it sounds.
            callAsync(resolveRoute);
        }
    }
    function setPath(path, data, options) {
        path = $cITMw(path, data);
        if (ready) {
            fireAsync();
            var state = options ? options.state : null;
            var title = options ? options.title : null;
            if (options && options.replace) $window.history.replaceState(state, title, route.prefix + path);
            else $window.history.pushState(state, title, route.prefix + path);
        } else $window.location.href = route.prefix + path;
    }
    function route(root, defaultRoute, routes) {
        if (!root) throw new TypeError("DOM element being rendered to does not exist.");
        compiled = Object.keys(routes).map(function(route) {
            if (route[0] !== "/") throw new SyntaxError("Routes must start with a '/'.");
            if (/:([^\/\.-]+)(\.{3})?:/.test(route)) throw new SyntaxError("Route parameter names must be separated with either '/', '.', or '-'.");
            return {
                route: route,
                component: routes[route],
                check: $8KlxE(route)
            };
        });
        fallbackRoute = defaultRoute;
        if (defaultRoute != null) {
            var defaultData = $7lWrV(defaultRoute);
            if (!compiled.some(function(i) {
                return i.check(defaultData);
            })) throw new ReferenceError("Default route doesn't match any known routes.");
        }
        if (typeof $window.history.pushState === "function") $window.addEventListener("popstate", fireAsync, false);
        else if (route.prefix[0] === "#") $window.addEventListener("hashchange", resolveRoute, false);
        ready = true;
        mountRedraw.mount(root, RouterRoot);
        resolveRoute();
    }
    route.set = function(path, data, options) {
        if (lastUpdate != null) {
            options = options || {};
            options.replace = true;
        }
        lastUpdate = null;
        setPath(path, data, options);
    };
    route.get = function() {
        return currentPath;
    };
    route.prefix = "#!";
    route.Link = {
        view: function(vnode) {
            // Omit the used parameters from the rendered element - they are
            // internal. Also, censor the various lifecycle methods.
            //
            // We don't strip the other parameters because for convenience we
            // let them be specified in the selector as well.
            var child = $iVcuU(vnode.attrs.selector || "a", $e9o88(vnode.attrs, [
                "options",
                "params",
                "selector",
                "onclick"
            ]), vnode.children);
            var options, onclick, href;
            // Let's provide a *right* way to disable a route link, rather than
            // letting people screw up accessibility on accident.
            //
            // The attribute is coerced so users don't get surprised over
            // `disabled: 0` resulting in a button that's somehow routable
            // despite being visibly disabled.
            if (child.attrs.disabled = Boolean(child.attrs.disabled)) {
                child.attrs.href = null;
                child.attrs["aria-disabled"] = "true";
            // If you *really* do want add `onclick` on a disabled link, use
            // an `oncreate` hook to add it.
            } else {
                options = vnode.attrs.options;
                onclick = vnode.attrs.onclick;
                // Easier to build it now to keep it isomorphic.
                href = $cITMw(child.attrs.href, vnode.attrs.params);
                child.attrs.href = route.prefix + href;
                child.attrs.onclick = function(e) {
                    var result;
                    if (typeof onclick === "function") result = onclick.call(e.currentTarget, e);
                    else if (onclick == null || typeof onclick !== "object") ;
                    else if (typeof onclick.handleEvent === "function") onclick.handleEvent(e);
                    // Adapted from React Router's implementation:
                    // https://github.com/ReactTraining/react-router/blob/520a0acd48ae1b066eb0b07d6d4d1790a1d02482/packages/react-router-dom/modules/Link.js
                    //
                    // Try to be flexible and intuitive in how we handle links.
                    // Fun fact: links aren't as obvious to get right as you
                    // would expect. There's a lot more valid ways to click a
                    // link than this, and one might want to not simply click a
                    // link, but right click or command-click it to copy the
                    // link target, etc. Nope, this isn't just for blind people.
                    if (// Skip if `onclick` prevented default
                    result !== false && !e.defaultPrevented && // Ignore everything but left clicks
                    (e.button === 0 || e.which === 0 || e.which === 1) && // Let the browser handle `target=_blank`, etc.
                    (!e.currentTarget.target || e.currentTarget.target === "_self") && // No modifier keys
                    !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        e.redraw = false;
                        route.set(href, null, options);
                    }
                };
            }
            return child;
        }
    };
    route.param = function(key) {
        return attrs && key != null ? attrs[key] : attrs;
    };
    return route;
};

});
parcelRegister("iVcuU", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");

var $9eOch = parcelRequire("9eOch");
var $dc673ea23ab51a3f$var$selectorParser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g;
var $dc673ea23ab51a3f$var$selectorCache = {};
function $dc673ea23ab51a3f$var$isEmpty(object) {
    for(var key in object)if ($9eOch.call(object, key)) return false;
    return true;
}
function $dc673ea23ab51a3f$var$compileSelector(selector) {
    var match, tag = "div", classes = [], attrs = {};
    while(match = $dc673ea23ab51a3f$var$selectorParser.exec(selector)){
        var type = match[1], value = match[2];
        if (type === "" && value !== "") tag = value;
        else if (type === "#") attrs.id = value;
        else if (type === ".") classes.push(value);
        else if (match[3][0] === "[") {
            var attrValue = match[6];
            if (attrValue) attrValue = attrValue.replace(/\\(["'])/g, "$1").replace(/\\\\/g, "\\");
            if (match[4] === "class") classes.push(attrValue);
            else attrs[match[4]] = attrValue === "" ? attrValue : attrValue || true;
        }
    }
    if (classes.length > 0) attrs.className = classes.join(" ");
    return $dc673ea23ab51a3f$var$selectorCache[selector] = {
        tag: tag,
        attrs: attrs
    };
}
function $dc673ea23ab51a3f$var$execSelector(state, vnode) {
    var attrs = vnode.attrs;
    var hasClass = $9eOch.call(attrs, "class");
    var className = hasClass ? attrs.class : attrs.className;
    vnode.tag = state.tag;
    vnode.attrs = {};
    if (!$dc673ea23ab51a3f$var$isEmpty(state.attrs) && !$dc673ea23ab51a3f$var$isEmpty(attrs)) {
        var newAttrs = {};
        for(var key in attrs)if ($9eOch.call(attrs, key)) newAttrs[key] = attrs[key];
        attrs = newAttrs;
    }
    for(var key in state.attrs)if ($9eOch.call(state.attrs, key) && key !== "className" && !$9eOch.call(attrs, key)) attrs[key] = state.attrs[key];
    if (className != null || state.attrs.className != null) attrs.className = className != null ? state.attrs.className != null ? String(state.attrs.className) + " " + String(className) : className : state.attrs.className != null ? state.attrs.className : null;
    if (hasClass) attrs.class = null;
    for(var key in attrs)if ($9eOch.call(attrs, key) && key !== "key") {
        vnode.attrs = attrs;
        break;
    }
    return vnode;
}
function $dc673ea23ab51a3f$var$hyperscript(selector) {
    if (selector == null || typeof selector !== "string" && typeof selector !== "function" && typeof selector.view !== "function") throw Error("The selector must be either a string or a component.");
    var vnode = $5sRXF.apply(1, arguments);
    if (typeof selector === "string") {
        vnode.children = $dBs8J.normalizeChildren(vnode.children);
        if (selector !== "[") return $dc673ea23ab51a3f$var$execSelector($dc673ea23ab51a3f$var$selectorCache[selector] || $dc673ea23ab51a3f$var$compileSelector(selector), vnode);
    }
    vnode.tag = selector;
    return vnode;
}
module.exports = $dc673ea23ab51a3f$var$hyperscript;

});

parcelRegister("2uPnQ", function(module, exports) {
/* global window */ "use strict";

var $k7iQv = parcelRequire("k7iQv");
if (typeof window !== "undefined") {
    if (typeof window.Promise === "undefined") window.Promise = $k7iQv;
    else if (!window.Promise.prototype.finally) window.Promise.prototype.finally = $k7iQv.prototype.finally;
    module.exports = window.Promise;
} else if (typeof $parcel$global !== "undefined") {
    if (typeof $parcel$global.Promise === "undefined") $parcel$global.Promise = $k7iQv;
    else if (!$parcel$global.Promise.prototype.finally) $parcel$global.Promise.prototype.finally = $k7iQv.prototype.finally;
    module.exports = $parcel$global.Promise;
} else module.exports = $k7iQv;

});

parcelRegister("7lWrV", function(module, exports) {
"use strict";

var $gZZfO = parcelRequire("gZZfO");
// Returns `{path, params}` from `url`
module.exports = function(url) {
    var queryIndex = url.indexOf("?");
    var hashIndex = url.indexOf("#");
    var queryEnd = hashIndex < 0 ? url.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = url.slice(0, pathEnd).replace(/\/{2,}/g, "/");
    if (!path) path = "/";
    else {
        if (path[0] !== "/") path = "/" + path;
        if (path.length > 1 && path[path.length - 1] === "/") path = path.slice(0, -1);
    }
    return {
        path: path,
        params: queryIndex < 0 ? {} : $gZZfO(url.slice(queryIndex + 1, queryEnd))
    };
};

});
parcelRegister("gZZfO", function(module, exports) {
"use strict";
function $c601dba597649f5e$var$decodeURIComponentSave(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        return str;
    }
}
module.exports = function(string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"), counters = {}, data = {};
    for(var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key = $c601dba597649f5e$var$decodeURIComponentSave(entry[0]);
        var value = entry.length === 2 ? $c601dba597649f5e$var$decodeURIComponentSave(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key.split(/\]\[?|\[/);
        var cursor = data;
        if (key.indexOf("[") > -1) levels.pop();
        for(var j = 0; j < levels.length; j++){
            var level = levels[j], nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            if (level === "") {
                var key = levels.slice(0, j).join();
                if (counters[key] == null) counters[key] = Array.isArray(cursor) ? cursor.length : 0;
                level = counters[key]++;
            } else if (level === "__proto__") break;
            if (j === levels.length - 1) cursor[level] = value;
            else {
                // Read own properties exclusively to disallow indirect
                // prototype pollution
                var desc = Object.getOwnPropertyDescriptor(cursor, level);
                if (desc != null) desc = desc.value;
                if (desc == null) cursor[level] = desc = isNumber ? [] : {};
                cursor = desc;
            }
        }
    }
    return data;
};

});


parcelRegister("8KlxE", function(module, exports) {
"use strict";

var $7lWrV = parcelRequire("7lWrV");
// Compiles a template into a function that takes a resolved path (without query
// strings) and returns an object containing the template parameters with their
// parsed values. This expects the input of the compiled template to be the
// output of `parsePathname`. Note that it does *not* remove query parameters
// specified in the template.
module.exports = function(template) {
    var templateData = $7lWrV(template);
    var templateKeys = Object.keys(templateData.params);
    var keys = [];
    var regexp = new RegExp("^" + templateData.path.replace(// I escape literal text so people can use things like `:file.:ext` or
    // `:lang-:locale` in routes. This is all merged into one pass so I
    // don't also accidentally escape `-` and make it harder to detect it to
    // ban it from template parameters.
    /:([^\/.-]+)(\.{3}|\.(?!\.)|-)?|[\\^$*+.()|\[\]{}]/g, function(m, key, extra) {
        if (key == null) return "\\" + m;
        keys.push({
            k: key,
            r: extra === "..."
        });
        if (extra === "...") return "(.*)";
        if (extra === ".") return "([^/]+)\\.";
        return "([^/]+)" + (extra || "");
    }) + "$");
    return function(data) {
        // First, check the params. Usually, there isn't any, and it's just
        // checking a static set.
        for(var i = 0; i < templateKeys.length; i++){
            if (templateData.params[templateKeys[i]] !== data.params[templateKeys[i]]) return false;
        }
        // If no interpolations exist, let's skip all the ceremony
        if (!keys.length) return regexp.test(data.path);
        var values = regexp.exec(data.path);
        if (values == null) return false;
        for(var i = 0; i < keys.length; i++)data.params[keys[i].k] = keys[i].r ? values[i + 1] : decodeURIComponent(values[i + 1]);
        return true;
    };
};

});

parcelRegister("e9o88", function(module, exports) {
"use strict";

var $9eOch = parcelRequire("9eOch");
// Words in RegExp literals are sometimes mangled incorrectly by the internal bundler, so use RegExp().
var $a4d49fb46380177c$var$magic = new RegExp("^(?:key|oninit|oncreate|onbeforeupdate|onupdate|onbeforeremove|onremove)$");
module.exports = function(attrs, extras) {
    var result = {};
    if (extras != null) {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key) && extras.indexOf(key) < 0) result[key] = attrs[key];
    } else {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key)) result[key] = attrs[key];
    }
    return result;
};

});



parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

var $65d5daca13f5010c$exports = {};
"use strict";
var $20d57ad7857b7d5d$exports = {};
"use strict";

var $iVcuU = parcelRequire("iVcuU");

$iVcuU.trust = (parcelRequire("e2F9W"));

$iVcuU.fragment = (parcelRequire("7PZrX"));
$20d57ad7857b7d5d$exports = $iVcuU;


var $8fa9e1679f027da0$exports = {};
"use strict";

var $2uPnQ = parcelRequire("2uPnQ");

var $7EF0O = parcelRequire("7EF0O");

$8fa9e1679f027da0$exports = (parcelRequire("5y2KI"))(typeof window !== "undefined" ? window : null, $2uPnQ, $7EF0O.redraw);



var $7EF0O = parcelRequire("7EF0O");
var $65d5daca13f5010c$var$m = function m() {
    return $20d57ad7857b7d5d$exports.apply(this, arguments);
};
$65d5daca13f5010c$var$m.m = $20d57ad7857b7d5d$exports;
$65d5daca13f5010c$var$m.trust = $20d57ad7857b7d5d$exports.trust;
$65d5daca13f5010c$var$m.fragment = $20d57ad7857b7d5d$exports.fragment;
$65d5daca13f5010c$var$m.Fragment = "[";
$65d5daca13f5010c$var$m.mount = $7EF0O.mount;

$65d5daca13f5010c$var$m.route = (parcelRequire("4Ppi2"));

$65d5daca13f5010c$var$m.render = (parcelRequire("j25vk"));
$65d5daca13f5010c$var$m.redraw = $7EF0O.redraw;
$65d5daca13f5010c$var$m.request = $8fa9e1679f027da0$exports.request;
$65d5daca13f5010c$var$m.jsonp = $8fa9e1679f027da0$exports.jsonp;

$65d5daca13f5010c$var$m.parseQueryString = (parcelRequire("gZZfO"));

$65d5daca13f5010c$var$m.buildQueryString = (parcelRequire("iRA82"));

$65d5daca13f5010c$var$m.parsePathname = (parcelRequire("7lWrV"));

$65d5daca13f5010c$var$m.buildPathname = (parcelRequire("cITMw"));

$65d5daca13f5010c$var$m.vnode = (parcelRequire("dBs8J"));

$65d5daca13f5010c$var$m.PromisePolyfill = (parcelRequire("k7iQv"));

$65d5daca13f5010c$var$m.censor = (parcelRequire("e9o88"));
$65d5daca13f5010c$exports = $65d5daca13f5010c$var$m;




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $560ae065107eea8c$export$4dbe3495bda74f11 = {
    // Modifiers
    XS: "cui-xs",
    SM: "cui-sm",
    LG: "cui-lg",
    XL: "cui-xl",
    PRIMARY: "cui-primary",
    NEGATIVE: "cui-negative",
    POSITIVE: "cui-positive",
    WARNING: "cui-warning",
    ACTIVE: "cui-active",
    DISABLED: "cui-disabled",
    LOADING: "cui-loading",
    BASIC: "cui-basic",
    OUTLINED: "cui-outlined",
    ROUNDED: "cui-rounded",
    READONLY: "cui-readonly",
    SELECTED: "cui-selected",
    INTERACTIVE: "cui-interactive",
    ELEVATION: "cui-elevation",
    HIDDEN: "cui-hidden",
    // Headings
    H1: "cui-h1",
    H2: "cui-h2",
    H3: "cui-h3",
    H4: "cui-h4",
    H5: "cui-h5",
    H6: "cui-h6",
    // Utility
    ALIGN: "cui-align",
    ALIGN_RIGHT: "cui-align-right",
    ALIGN_LEFT: "cui-align-left",
    FLUID: "cui-fluid",
    TEXT_MUTED: "cui-text-muted",
    TEXT_DISABLED: "cui-text-disabled",
    FOCUS_DISABLED: "cui-focus-disabled",
    COMPACT: "cui-compact",
    // Component
    BREADCRUMB: "cui-breadcrumb",
    BREADCRUMB_ITEM: "cui-breadcrumb-item",
    BREADCRUMB_SEPERATOR: "cui-breadcrumb-seperator",
    BUTTON: "cui-button",
    BUTTON_LABEL: "cui-button-label",
    BUTTON_SUBLABEL: "cui-button-sublabel",
    BUTTON_GROUP: "cui-button-group",
    BUTTON_ICON: "cui-button-icon",
    CARD: "cui-card",
    CARD_INTERACTIVE: "cui-card-interactive",
    CALLOUT: "cui-callout",
    CALLOUT_HEADER: "cui-callout-header",
    CALLOUT_CONTENT: "cui-callout-content",
    CALLOUT_ICON: "cui-callout-icon",
    CALLOUT_DISMISS_ICON: "cui-callout-dismiss",
    CHECKBOX: "cui-checkbox",
    COLLAPSE: "cui-collapse",
    COLLAPSE_BODY: "cui-collapse-body",
    CONTEXT_MENU: "cui-context-menu",
    CONTROL: "cui-control",
    CONTROL_INDICATOR: "cui-control-indicator",
    CONTROL_GROUP: "cui-control-group",
    CUSTOM_SELECT: "cui-custom-select",
    CUSTOM_SELECT_TRIGGER: "cui-custom-select-trigger",
    CUSTOM_SELECT_INPUT: "cui-custom-select-input",
    CUSTOM_SELECT_HIDDEN: "cui-custom-select-hidden",
    DIALOG: "cui-dialog",
    DIALOG_CLOSE_BUTTON: "cui-dialog-close-button",
    DIALOG_CONTENT: "cui-dialog-content",
    DIALOG_HEADER: "cui-dialog-header",
    DIALOG_BODY: "cui-dialog-body",
    DIALOG_FOOTER: "cui-dialog-footer",
    DRAWER: "cui-drawer",
    DRAWER_CONTENT: "cui-drawer-content",
    EMPTY_STATE: "cui-empty-state",
    EMPTY_STATE_ICON: "cui-empty-state-icon",
    EMPTY_STATE_CONTENT: "cui-empty-state-content",
    EMPTY_STATE_HEADER: "cui-empty-state-header",
    EMPTY_STATE_FILL: "cui-empty-state-fill",
    FORM: "cui-form",
    FORM_GROUP: "cui-form-group",
    FORM_LABEL: "cui-form-label",
    GRID: "cui-grid",
    COL: "cui-col",
    INPUT_FILE: "cui-input-file",
    INPUT_FILE_CONTENT: "cui-input-file-content",
    INPUT_FILE_TEXT: "cui-input-file-text",
    INPUT_FILE_BUTTON: "cui-input-file-button",
    ICON: "cui-icon",
    ICON_ACTION: "cui-icon-action",
    INPUT: "cui-input",
    INPUT_GROUP: "cui-input-group",
    INPUT_POPOVER: "cui-input-popover",
    INPUT_POPOVER_CONTENT: "cui-input-popover-content",
    INPUT_SELECT: "cui-input-select",
    LIST: "cui-list",
    LIST_ITEM: "cui-list-item",
    LIST_ITEM_LABEL: "cui-list-item-label",
    LIST_ITEM_CONTENT_LEFT: "cui-list-item-content-left",
    LIST_ITEM_CONTENT_RIGHT: "cui-list-item-content-right",
    MENU: "cui-menu",
    MENU_ITEM: "cui-menu-item",
    MENU_DIVIDER: "cui-menu-divider",
    MENU_HEADING: "cui-menu-heading",
    OVERLAY: "cui-overlay",
    OVERLAY_CONTENT: "cui-overlay-content",
    OVERLAY_BACKDROP: "cui-overlay-backdrop",
    OVERLAY_OPEN: "cui-overlay-open",
    OVERLAY_INLINE: "cui-overlay-inline",
    OVERLAY_SCROLL_CONTAINER: "cui-overlay-scroll-container",
    POPOVER: "cui-popover",
    POPOVER_OPEN: "cui-popover-open",
    POPOVER_CONTENT: "cui-popover-content",
    POPOVER_ARROW: "cui-popover-arrow",
    POPOVER_TRIGGER_ACTIVE: "cui-popover-trigger-active",
    POPOVER_BACKDROP: "cui-popover-backdrop",
    POPOVER_DISSMISS: "cui-popover-dismiss",
    POPOVER_MENU: "cui-popover-menu",
    PORTAL: "cui-portal",
    QUERY_LIST: "cui-query-list",
    QUERY_LIST_CHECKMARK: "cui-query-list-checkmark",
    QUERY_LIST_EMPTY: "cui-query-list-empty",
    QUERY_LIST_INITIAL: "cui-query-list-initial",
    QUERY_LIST_MESSAGE: "cui-query-list-message",
    RADIO: "cui-radio",
    RADIO_GROUP: "cui-radio-group",
    SELECT: "cui-select",
    SELECT_ARROW: "cui-select-arrow",
    SELECT_LIST: "cui-select-list",
    SPINNER: "cui-spinner",
    SPINNER_CONTENT: "cui-spinner-content",
    SPINNER_ICON: "cui-spinner-icon",
    SPINNER_MESSAGE: "cui-spinner-message",
    SPINNER_FILL: "cui-spinner-fill",
    SPINNER_ACTIVE: "cui-spinner-active",
    SPINNER_BG: "cui-spinner-bg",
    SWITCH: "cui-switch",
    TABLE: "cui-table",
    TABLE_BORDERED: "cui-table-bordered",
    TABLE_STRIPED: "cui-table-striped",
    TABLE_INTERACTIVE: "cui-table-interactive",
    TAG: "cui-tag",
    TAG_REMOVABLE: "cui-tag-removable",
    TAG_INPUT: "cui-tag-input",
    TAG_INPUT_VALUES: "cui-tag-input-values",
    TABS: "cui-tabs",
    TABS_BORDERED: "cui-tabs-bordered",
    TABS_ITEM: "cui-tabs-item",
    TEXT_AREA: "cui-text-area",
    TOAST: "cui-toast",
    TOAST_MESSAGE: "cui-toast-message",
    TOASTER: "cui-toaster",
    TOASTER_INLINE: "cui-toaster-inline",
    TOOLTIP: "cui-tooltip",
    TREE: "cui-tree",
    TREE_NODE: "cui-tree-node",
    TREE_NODE_LIST: "cui-tree-node-list",
    TREE_NODE_CONTENT: "cui-tree-node-content",
    TREE_NODE_CARET: "cui-tree-node-caret",
    TREE_NODE_CARET_OPEN: "cui-tree-node-caret-open",
    TREE_NODE_CARET_CLOSED: "cui-tree-node-caret-closed",
    TREE_NODE_CARET_NONE: "cui-tree-node-caret-none",
    TREE_NODE_SELECTED: "cui-tree-node-selected",
    TREE_NODE_EXPANDED: "cui-tree-node-expanded",
    TREE_NODE_LABEL: "cui-tree-node-label",
    TREE_NODE_CONTENT_RIGHT: "cui-tree-node-content-right",
    TREE_NODE_CONTENT_LEFT: "cui-tree-node-content-left"
};


function $68113dfa49ce8411$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $68113dfa49ce8411$export$175e60bb96229ece(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if ($68113dfa49ce8411$export$f6e2535fb5126e54(func)) return func.apply(void 0, args);
}
function $68113dfa49ce8411$export$211731fc355e9121(el, selector) {
    if (el.matches(selector)) return el;
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = matches.length;
        while(--i >= 0 && matches.item(i) !== this);
        return i > -1;
    };
    for(; el && el !== document; el = el.parentNode){
        if (el.matches(selector)) return el;
    }
    return null;
}
function $68113dfa49ce8411$export$ace028f8da1a6300() {
    var el = document.createElement("div");
    el.style.width = "100px";
    el.style.height = "100px";
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    document.body.appendChild(el);
    var scrollbarWidth = el.offsetWidth - el.clientWidth;
    document.body.removeChild(el);
    return scrollbarWidth;
}
function $68113dfa49ce8411$export$4d450e1748530b6a(el) {
    return el.scrollHeight > window.innerHeight;
}
function $68113dfa49ce8411$export$3c0fcc112e8e7788(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function $68113dfa49ce8411$export$8756898546458274(style) {
    if (typeof style === "string") {
        var result = {};
        var attributes = style.replace(/\s/g, "").split(";");
        for(var i = 0; i < attributes.length; i++){
            var entry = attributes[i].split(":");
            result[entry.splice(0, 1)[0]] = entry.join(":");
        }
        return result;
    } else return style;
}
function $68113dfa49ce8411$export$2069c0f7afbb4fb9(containerEl, contentLeft, contentRight) {
    if (!containerEl) return;
    var containerPadding = Math.floor(containerEl.clientHeight / 1.6);
    if (contentLeft) {
        var contentLeftEl = contentLeft.dom;
        containerEl.style.paddingLeft = $68113dfa49ce8411$var$shouldAddPadding(contentLeftEl) ? "".concat(contentLeftEl.clientWidth + containerPadding, "px") : "";
    } else containerEl.style.paddingLeft = "";
    if (contentRight) {
        var contentRightEl = contentRight.dom;
        containerEl.style.paddingRight = $68113dfa49ce8411$var$shouldAddPadding(contentRightEl) ? "".concat(contentRightEl.clientWidth + containerPadding, "px") : "";
    } else containerEl.style.paddingRight = "";
}
function $68113dfa49ce8411$var$shouldAddPadding(element) {
    return element && !element.classList.contains((0, $560ae065107eea8c$export$4dbe3495bda74f11).ICON) && !element.classList.contains((0, $560ae065107eea8c$export$4dbe3495bda74f11).SPINNER) && !element.classList.contains((0, $560ae065107eea8c$export$4dbe3495bda74f11).BUTTON_ICON);
}
function $68113dfa49ce8411$export$c8733ae29fb53302(item) {
    return item == null || item === "" || item === false;
}



var $9da61e952759bc27$export$ca6a3753167de7aa = /** @class */ function() {
    function AbstractComponent() {
        var _this = this;
        this.timeoutStack = [];
        this.attrs = {};
        this.setTimeout = function(callback, timeout) {
            var handle = window.setTimeout(callback, timeout);
            _this.timeoutStack.push(handle);
            return function() {
                return window.clearTimeout(handle);
            };
        };
        this.clearTimeouts = function() {
            if (_this.timeoutStack.length) {
                _this.timeoutStack.map(function(timeout) {
                    return clearTimeout(timeout);
                });
                _this.timeoutStack = [];
            }
        };
    }
    AbstractComponent.prototype.oninit = function(vnode) {
        vnode.attrs = vnode.attrs || {};
        this.setAttrs(vnode);
    };
    AbstractComponent.prototype.onbeforeupdate = function(vnode, prev) {
        this.setAttrs(vnode);
        this.prevAttrs = prev.attrs;
    };
    AbstractComponent.prototype.setAttrs = function(vnode) {
        vnode.attrs = this.getAttrs(vnode.attrs);
        this.attrs = vnode.attrs;
    };
    AbstractComponent.prototype.getAttrs = function(attrs) {
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.getDefaultAttrs()), attrs);
    };
    return AbstractComponent;
}();











/* tslint:disable */ var $20a11462b9e5d0d1$export$2e2bcd8739ae039 = {
    "activity": '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
    "airplay": '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
    "alert-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
    "alert-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
    "alert-triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
    "align-center": '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
    "align-justify": '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
    "align-left": '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
    "align-right": '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
    "anchor": '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
    "aperture": '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
    "archive": '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
    "arrow-down-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
    "arrow-down-left": '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
    "arrow-down-right": '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
    "arrow-down": '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
    "arrow-left-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
    "arrow-left": '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
    "arrow-right-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
    "arrow-right": '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
    "arrow-up-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
    "arrow-up-left": '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
    "arrow-up-right": '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
    "arrow-up": '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
    "at-sign": '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
    "award": '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
    "bar-chart-2": '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
    "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
    "battery-charging": '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
    "battery": '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
    "bell-off": '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "bell": '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
    "bluetooth": '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
    "bold": '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
    "book-open": '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
    "book": '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
    "bookmark": '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
    "box": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "briefcase": '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
    "calendar": '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
    "camera-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
    "camera": '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
    "cast": '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
    "check-circle": '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
    "check-square": '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
    "check": '<polyline points="20 6 9 17 4 12"></polyline>',
    "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>',
    "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>',
    "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>',
    "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>',
    "chevrons-down": '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
    "chevrons-left": '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
    "chevrons-right": '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
    "chevrons-up": '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
    "chrome": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
    "circle": '<circle cx="12" cy="12" r="10"></circle>',
    "clipboard": '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
    "clock": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
    "cloud-drizzle": '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
    "cloud-lightning": '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
    "cloud-off": '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "cloud-rain": '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
    "cloud-snow": '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
    "cloud": '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
    "code": '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
    "codepen": '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
    "codesandbox": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "coffee": '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
    "columns": '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
    "command": '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
    "compass": '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
    "copy": '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
    "corner-down-left": '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
    "corner-down-right": '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
    "corner-left-down": '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
    "corner-left-up": '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
    "corner-right-down": '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
    "corner-right-up": '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
    "corner-up-left": '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
    "corner-up-right": '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
    "cpu": '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
    "credit-card": '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
    "crop": '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
    "crosshair": '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
    "database": '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
    "delete": '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
    "disc": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
    "divide-circle": '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
    "divide-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
    "divide": '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
    "dollar-sign": '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
    "download-cloud": '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
    "download": '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
    "dribbble": '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
    "droplet": '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
    "edit-2": '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
    "edit-3": '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
    "edit": '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
    "external-link": '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
    "eye-off": '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "eye": '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
    "facebook": '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
    "fast-forward": '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
    "feather": '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
    "figma": '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
    "file-minus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
    "file-plus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
    "file-text": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
    "file": '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
    "film": '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
    "filter": '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
    "flag": '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
    "folder-minus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
    "folder-plus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
    "folder": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
    "framer": '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
    "frown": '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "gift": '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
    "git-branch": '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
    "git-commit": '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
    "git-merge": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
    "git-pull-request": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
    "github": '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
    "gitlab": '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
    "globe": '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
    "grid": '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
    "hard-drive": '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
    "hash": '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
    "headphones": '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
    "heart": '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
    "help-circle": '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
    "hexagon": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
    "home": '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
    "image": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
    "inbox": '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
    "info": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
    "instagram": '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
    "italic": '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
    "key": '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
    "layers": '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
    "layout": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
    "life-buoy": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
    "link-2": '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
    "link": '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
    "linkedin": '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
    "list": '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
    "loader": '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
    "lock": '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
    "log-in": '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
    "log-out": '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
    "mail": '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
    "map-pin": '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
    "map": '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
    "maximize-2": '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
    "maximize": '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
    "meh": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "menu": '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
    "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
    "message-square": '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
    "mic-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
    "mic": '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
    "minimize-2": '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
    "minimize": '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
    "minus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
    "minus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
    "minus": '<line x1="5" y1="12" x2="19" y2="12"></line>',
    "monitor": '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
    "moon": '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
    "more-horizontal": '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
    "more-vertical": '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
    "mouse-pointer": '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
    "move": '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
    "music": '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
    "navigation-2": '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
    "navigation": '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
    "octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
    "package": '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "paperclip": '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
    "pause-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
    "pause": '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
    "pen-tool": '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
    "percent": '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
    "phone-call": '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-forwarded": '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-incoming": '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-missed": '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-off": '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
    "phone-outgoing": '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone": '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "pie-chart": '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
    "play-circle": '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
    "play": '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
    "plus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
    "plus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
    "plus": '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
    "pocket": '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
    "power": '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
    "printer": '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
    "radio": '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
    "refresh-ccw": '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
    "refresh-cw": '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
    "repeat": '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
    "rewind": '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
    "rotate-ccw": '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
    "rotate-cw": '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
    "rss": '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
    "save": '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
    "scissors": '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
    "search": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
    "send": '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
    "server": '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
    "settings": '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
    "share-2": '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
    "share": '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
    "shield-off": '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "shield": '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
    "shopping-bag": '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
    "shopping-cart": '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
    "shuffle": '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
    "sidebar": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
    "skip-back": '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
    "skip-forward": '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
    "slack": '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
    "slash": '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
    "sliders": '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
    "smartphone": '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
    "smile": '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "speaker": '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
    "square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
    "star": '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
    "stop-circle": '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
    "sun": '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
    "sunrise": '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
    "sunset": '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
    "table": '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path>',
    "tablet": '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
    "tag": '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
    "target": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
    "terminal": '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
    "thermometer": '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
    "thumbs-down": '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
    "thumbs-up": '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
    "toggle-left": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
    "toggle-right": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
    "tool": '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
    "trash-2": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
    "trash": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
    "trello": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
    "trending-down": '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
    "trending-up": '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
    "triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
    "truck": '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
    "tv": '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
    "twitch": '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
    "twitter": '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
    "type": '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
    "umbrella": '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
    "underline": '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
    "unlock": '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
    "upload-cloud": '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
    "upload": '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
    "user-check": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
    "user-minus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
    "user-plus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
    "user-x": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
    "user": '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
    "users": '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
    "video-off": '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "video": '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
    "voicemail": '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
    "volume-1": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
    "volume-2": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
    "volume-x": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
    "volume": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
    "watch": '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
    "wifi-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
    "wifi": '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
    "wind": '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
    "x-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
    "x-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
    "x-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
    "x": '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
    "youtube": '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
    "zap-off": '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
    "zap": '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
    "zoom-in": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
    "zoom-out": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>'
};


var $cecad194b10e0134$export$f04a61298a47a40f = /** @class */ function() {
    function Icon() {}
    Icon.prototype.view = function(_a) {
        var attrs = _a.attrs;
        var className = attrs.class, intent = attrs.intent, name = attrs.name, onclick = attrs.onclick, size = attrs.size, htmlAttrs = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(attrs, [
            "class",
            "intent",
            "name",
            "onclick",
            "size"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).ICON, "".concat((0, $560ae065107eea8c$export$4dbe3495bda74f11).ICON, "-").concat(name), intent && "cui-".concat(intent), size && "cui-".concat(size), onclick && (0, $560ae065107eea8c$export$4dbe3495bda74f11).ICON_ACTION, className);
        var svg = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust("<svg viewBox='0 0 24 24'>".concat((0, $20a11462b9e5d0d1$export$2e2bcd8739ae039)[name], "</svg>"));
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, htmlAttrs), {
            class: classes,
            onclick: onclick
        }), svg);
    };
    return Icon;
}();

var $792c6f1bb85322f7$exports = {};

$parcel$export($792c6f1bb85322f7$exports, "ACTIVITY", () => $792c6f1bb85322f7$export$33eb309289062be7);
$parcel$export($792c6f1bb85322f7$exports, "AIRPLAY", () => $792c6f1bb85322f7$export$96fb28b291d9eefa);
$parcel$export($792c6f1bb85322f7$exports, "ALERT_CIRCLE", () => $792c6f1bb85322f7$export$f5e9b024d089ea84);
$parcel$export($792c6f1bb85322f7$exports, "ALERT_OCTAGON", () => $792c6f1bb85322f7$export$2dcbb90a00fa676f);
$parcel$export($792c6f1bb85322f7$exports, "ALERT_TRIANGLE", () => $792c6f1bb85322f7$export$8b40992ab7adada6);
$parcel$export($792c6f1bb85322f7$exports, "ALIGN_CENTER", () => $792c6f1bb85322f7$export$3ea9e188ab01c845);
$parcel$export($792c6f1bb85322f7$exports, "ALIGN_JUSTIFY", () => $792c6f1bb85322f7$export$2420f2030c2aefcf);
$parcel$export($792c6f1bb85322f7$exports, "ALIGN_LEFT", () => $792c6f1bb85322f7$export$7895aadd1956b1c7);
$parcel$export($792c6f1bb85322f7$exports, "ALIGN_RIGHT", () => $792c6f1bb85322f7$export$f1299af03a3c605a);
$parcel$export($792c6f1bb85322f7$exports, "ANCHOR", () => $792c6f1bb85322f7$export$2577073a94e6b433);
$parcel$export($792c6f1bb85322f7$exports, "APERTURE", () => $792c6f1bb85322f7$export$e07990d13d62a4c5);
$parcel$export($792c6f1bb85322f7$exports, "ARCHIVE", () => $792c6f1bb85322f7$export$a7c1ec142e70d69d);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_DOWN_CIRCLE", () => $792c6f1bb85322f7$export$8faa0bfb783e4f95);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_DOWN_LEFT", () => $792c6f1bb85322f7$export$d6b976886b9bb938);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_DOWN_RIGHT", () => $792c6f1bb85322f7$export$fd0e719468a31e9f);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_DOWN", () => $792c6f1bb85322f7$export$59f214baefff6196);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_LEFT_CIRCLE", () => $792c6f1bb85322f7$export$3b80bfa1f51653e6);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_LEFT", () => $792c6f1bb85322f7$export$8d4f84cc5dc5fc15);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_RIGHT_CIRCLE", () => $792c6f1bb85322f7$export$c555aea97853be67);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_RIGHT", () => $792c6f1bb85322f7$export$e9510a4613bb01df);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_UP_CIRCLE", () => $792c6f1bb85322f7$export$3102bf741e6e883d);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_UP_LEFT", () => $792c6f1bb85322f7$export$c840fb87f7cd43cd);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_UP_RIGHT", () => $792c6f1bb85322f7$export$9efbd9847f714012);
$parcel$export($792c6f1bb85322f7$exports, "ARROW_UP", () => $792c6f1bb85322f7$export$8188339dbe6c99c4);
$parcel$export($792c6f1bb85322f7$exports, "AT_SIGN", () => $792c6f1bb85322f7$export$5da71d022bae01b1);
$parcel$export($792c6f1bb85322f7$exports, "AWARD", () => $792c6f1bb85322f7$export$534b560abc2bb11d);
$parcel$export($792c6f1bb85322f7$exports, "BAR_CHART_2", () => $792c6f1bb85322f7$export$d9c3752d69e5e356);
$parcel$export($792c6f1bb85322f7$exports, "BAR_CHART", () => $792c6f1bb85322f7$export$2202d1df9575294c);
$parcel$export($792c6f1bb85322f7$exports, "BATTERY_CHARGING", () => $792c6f1bb85322f7$export$22f257c25260f09c);
$parcel$export($792c6f1bb85322f7$exports, "BATTERY", () => $792c6f1bb85322f7$export$1a7b790285c84ca3);
$parcel$export($792c6f1bb85322f7$exports, "BELL_OFF", () => $792c6f1bb85322f7$export$bd5b6944c36df62d);
$parcel$export($792c6f1bb85322f7$exports, "BELL", () => $792c6f1bb85322f7$export$f01c6ff914c49906);
$parcel$export($792c6f1bb85322f7$exports, "BLUETOOTH", () => $792c6f1bb85322f7$export$6781fbe3ae82070a);
$parcel$export($792c6f1bb85322f7$exports, "BOLD", () => $792c6f1bb85322f7$export$c1286c4c2a7c066);
$parcel$export($792c6f1bb85322f7$exports, "BOOK_OPEN", () => $792c6f1bb85322f7$export$8cd74ce6bae0314);
$parcel$export($792c6f1bb85322f7$exports, "BOOK", () => $792c6f1bb85322f7$export$bbdb19d3986a2390);
$parcel$export($792c6f1bb85322f7$exports, "BOOKMARK", () => $792c6f1bb85322f7$export$865a16a14f6d3268);
$parcel$export($792c6f1bb85322f7$exports, "BOX", () => $792c6f1bb85322f7$export$98e6811b31774aaa);
$parcel$export($792c6f1bb85322f7$exports, "BRIEFCASE", () => $792c6f1bb85322f7$export$3bf9df5d61e98b9a);
$parcel$export($792c6f1bb85322f7$exports, "CALENDAR", () => $792c6f1bb85322f7$export$7d65e474be175151);
$parcel$export($792c6f1bb85322f7$exports, "CAMERA_OFF", () => $792c6f1bb85322f7$export$a73d59aca32277d4);
$parcel$export($792c6f1bb85322f7$exports, "CAMERA", () => $792c6f1bb85322f7$export$86703463cbdc13c0);
$parcel$export($792c6f1bb85322f7$exports, "CAST", () => $792c6f1bb85322f7$export$32e24be20223d4c1);
$parcel$export($792c6f1bb85322f7$exports, "CHECK_CIRCLE", () => $792c6f1bb85322f7$export$c44dea1357e31512);
$parcel$export($792c6f1bb85322f7$exports, "CHECK_SQUARE", () => $792c6f1bb85322f7$export$2f78c72e5aba3d71);
$parcel$export($792c6f1bb85322f7$exports, "CHECK", () => $792c6f1bb85322f7$export$c953d1cd180adfae);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRON_DOWN", () => $792c6f1bb85322f7$export$f905c6094a0f672);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRON_LEFT", () => $792c6f1bb85322f7$export$c0007d962b255231);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRON_RIGHT", () => $792c6f1bb85322f7$export$dac98cecf7b6366);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRON_UP", () => $792c6f1bb85322f7$export$d503df0eed5c9169);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRONS_DOWN", () => $792c6f1bb85322f7$export$7477b66f96c3cbb2);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRONS_LEFT", () => $792c6f1bb85322f7$export$c3c87597fecab492);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRONS_RIGHT", () => $792c6f1bb85322f7$export$ff3d2c531020c017);
$parcel$export($792c6f1bb85322f7$exports, "CHEVRONS_UP", () => $792c6f1bb85322f7$export$cf9398fb008560fe);
$parcel$export($792c6f1bb85322f7$exports, "CHROME", () => $792c6f1bb85322f7$export$882c3be734f84f58);
$parcel$export($792c6f1bb85322f7$exports, "CIRCLE", () => $792c6f1bb85322f7$export$2b4cb8204be4ae5e);
$parcel$export($792c6f1bb85322f7$exports, "CLIPBOARD", () => $792c6f1bb85322f7$export$4e31d82ea0b583e4);
$parcel$export($792c6f1bb85322f7$exports, "CLOCK", () => $792c6f1bb85322f7$export$5edb9d9e4caf1353);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD_DRIZZLE", () => $792c6f1bb85322f7$export$3f8aa14fc7e8ccf3);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD_LIGHTNING", () => $792c6f1bb85322f7$export$3b479bcdf2f4e44b);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD_OFF", () => $792c6f1bb85322f7$export$b8d31db27efaf164);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD_RAIN", () => $792c6f1bb85322f7$export$947ab78ead319c84);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD_SNOW", () => $792c6f1bb85322f7$export$64a0e2ec51f02eac);
$parcel$export($792c6f1bb85322f7$exports, "CLOUD", () => $792c6f1bb85322f7$export$428c0af80a7329cd);
$parcel$export($792c6f1bb85322f7$exports, "CODE", () => $792c6f1bb85322f7$export$ec5856072852bd7f);
$parcel$export($792c6f1bb85322f7$exports, "CODEPEN", () => $792c6f1bb85322f7$export$755f8b1d570f7f4a);
$parcel$export($792c6f1bb85322f7$exports, "CODESANDBOX", () => $792c6f1bb85322f7$export$b00f5b211a823c24);
$parcel$export($792c6f1bb85322f7$exports, "COFFEE", () => $792c6f1bb85322f7$export$61d5289867e4f305);
$parcel$export($792c6f1bb85322f7$exports, "COLUMNS", () => $792c6f1bb85322f7$export$6a6dcc7e725abed4);
$parcel$export($792c6f1bb85322f7$exports, "COMMAND", () => $792c6f1bb85322f7$export$671af8f385981731);
$parcel$export($792c6f1bb85322f7$exports, "COMPASS", () => $792c6f1bb85322f7$export$d5e9b613bc4c47f);
$parcel$export($792c6f1bb85322f7$exports, "COPY", () => $792c6f1bb85322f7$export$92f9e1ed9114d3a6);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_DOWN_LEFT", () => $792c6f1bb85322f7$export$538eb2a283c0f17f);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_DOWN_RIGHT", () => $792c6f1bb85322f7$export$368bdf0dd1b4f2a7);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_LEFT_DOWN", () => $792c6f1bb85322f7$export$b9c570b1cd012e0a);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_LEFT_UP", () => $792c6f1bb85322f7$export$6294dac9279a615a);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_RIGHT_DOWN", () => $792c6f1bb85322f7$export$c78c22e4590cff9f);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_RIGHT_UP", () => $792c6f1bb85322f7$export$2bc12423e8ab4562);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_UP_LEFT", () => $792c6f1bb85322f7$export$8c6de84b16e0bc74);
$parcel$export($792c6f1bb85322f7$exports, "CORNER_UP_RIGHT", () => $792c6f1bb85322f7$export$c1944a58b59f2e63);
$parcel$export($792c6f1bb85322f7$exports, "CPU", () => $792c6f1bb85322f7$export$5ebf4cde340e6028);
$parcel$export($792c6f1bb85322f7$exports, "CREDIT_CARD", () => $792c6f1bb85322f7$export$dcfa992d78d44a92);
$parcel$export($792c6f1bb85322f7$exports, "CROP", () => $792c6f1bb85322f7$export$a07a7de5efb26195);
$parcel$export($792c6f1bb85322f7$exports, "CROSSHAIR", () => $792c6f1bb85322f7$export$d7ca88fc6cbcb4e1);
$parcel$export($792c6f1bb85322f7$exports, "DATABASE", () => $792c6f1bb85322f7$export$931b0c46b95fd31e);
$parcel$export($792c6f1bb85322f7$exports, "DELETE", () => $792c6f1bb85322f7$export$4bd2facc4a3e6aa1);
$parcel$export($792c6f1bb85322f7$exports, "DISC", () => $792c6f1bb85322f7$export$174c38d98ccdc6e4);
$parcel$export($792c6f1bb85322f7$exports, "DIVIDE_CIRCLE", () => $792c6f1bb85322f7$export$5f59d0cba123a7a6);
$parcel$export($792c6f1bb85322f7$exports, "DIVIDE_SQUARE", () => $792c6f1bb85322f7$export$184e21bbaf627886);
$parcel$export($792c6f1bb85322f7$exports, "DIVIDE", () => $792c6f1bb85322f7$export$480bc6cd31f42a68);
$parcel$export($792c6f1bb85322f7$exports, "DOLLAR_SIGN", () => $792c6f1bb85322f7$export$20bbf99b7f7af07);
$parcel$export($792c6f1bb85322f7$exports, "DOWNLOAD_CLOUD", () => $792c6f1bb85322f7$export$bc7b79dab261a61c);
$parcel$export($792c6f1bb85322f7$exports, "DOWNLOAD", () => $792c6f1bb85322f7$export$d028451e5fd5dfd3);
$parcel$export($792c6f1bb85322f7$exports, "DRIBBBLE", () => $792c6f1bb85322f7$export$96afce72bc67f90b);
$parcel$export($792c6f1bb85322f7$exports, "DROPLET", () => $792c6f1bb85322f7$export$ab7389fabcc55c20);
$parcel$export($792c6f1bb85322f7$exports, "EDIT_2", () => $792c6f1bb85322f7$export$8690efe8b4d0bbd0);
$parcel$export($792c6f1bb85322f7$exports, "EDIT_3", () => $792c6f1bb85322f7$export$f91685a2bf37bd13);
$parcel$export($792c6f1bb85322f7$exports, "EDIT", () => $792c6f1bb85322f7$export$250171a898bf7ef);
$parcel$export($792c6f1bb85322f7$exports, "EXTERNAL_LINK", () => $792c6f1bb85322f7$export$462971122ed9eae3);
$parcel$export($792c6f1bb85322f7$exports, "EYE_OFF", () => $792c6f1bb85322f7$export$241e2d72fa0574fa);
$parcel$export($792c6f1bb85322f7$exports, "EYE", () => $792c6f1bb85322f7$export$4c4520429be8c63);
$parcel$export($792c6f1bb85322f7$exports, "FACEBOOK", () => $792c6f1bb85322f7$export$99ed96e5d534c6be);
$parcel$export($792c6f1bb85322f7$exports, "FAST_FORWARD", () => $792c6f1bb85322f7$export$e305fc85d2cb6150);
$parcel$export($792c6f1bb85322f7$exports, "FEATHER", () => $792c6f1bb85322f7$export$421b42f57a9b4f2d);
$parcel$export($792c6f1bb85322f7$exports, "FIGMA", () => $792c6f1bb85322f7$export$91fa8f2d7e3174cc);
$parcel$export($792c6f1bb85322f7$exports, "FILE_MINUS", () => $792c6f1bb85322f7$export$b80ffe37949e3d0);
$parcel$export($792c6f1bb85322f7$exports, "FILE_PLUS", () => $792c6f1bb85322f7$export$acec4aebbeb107b0);
$parcel$export($792c6f1bb85322f7$exports, "FILE_TEXT", () => $792c6f1bb85322f7$export$bf7255ba41ca7f46);
$parcel$export($792c6f1bb85322f7$exports, "FILE", () => $792c6f1bb85322f7$export$1802dbfd31b58482);
$parcel$export($792c6f1bb85322f7$exports, "FILM", () => $792c6f1bb85322f7$export$ef519c83bf380b6);
$parcel$export($792c6f1bb85322f7$exports, "FILTER", () => $792c6f1bb85322f7$export$c1c49903035a02df);
$parcel$export($792c6f1bb85322f7$exports, "FLAG", () => $792c6f1bb85322f7$export$3a077bb7820dc6e4);
$parcel$export($792c6f1bb85322f7$exports, "FOLDER_MINUS", () => $792c6f1bb85322f7$export$94f12c8d79f1108b);
$parcel$export($792c6f1bb85322f7$exports, "FOLDER_PLUS", () => $792c6f1bb85322f7$export$1567b66611c1716a);
$parcel$export($792c6f1bb85322f7$exports, "FOLDER", () => $792c6f1bb85322f7$export$d31d8fac97169a4b);
$parcel$export($792c6f1bb85322f7$exports, "FRAMER", () => $792c6f1bb85322f7$export$44281146b54c1f30);
$parcel$export($792c6f1bb85322f7$exports, "FROWN", () => $792c6f1bb85322f7$export$dd1cee8b45032547);
$parcel$export($792c6f1bb85322f7$exports, "GIFT", () => $792c6f1bb85322f7$export$b70c28f717210d81);
$parcel$export($792c6f1bb85322f7$exports, "GIT_BRANCH", () => $792c6f1bb85322f7$export$512554f3e5add99);
$parcel$export($792c6f1bb85322f7$exports, "GIT_COMMIT", () => $792c6f1bb85322f7$export$95b7e707a15d4f18);
$parcel$export($792c6f1bb85322f7$exports, "GIT_MERGE", () => $792c6f1bb85322f7$export$9ac7ef47e370fd07);
$parcel$export($792c6f1bb85322f7$exports, "GIT_PULL_REQUEST", () => $792c6f1bb85322f7$export$4c07773c7a8ac052);
$parcel$export($792c6f1bb85322f7$exports, "GITHUB", () => $792c6f1bb85322f7$export$8606c40cc696b7b);
$parcel$export($792c6f1bb85322f7$exports, "GITLAB", () => $792c6f1bb85322f7$export$b54ecf54ae9ea39e);
$parcel$export($792c6f1bb85322f7$exports, "GLOBE", () => $792c6f1bb85322f7$export$953a3f3bd659178f);
$parcel$export($792c6f1bb85322f7$exports, "GRID", () => $792c6f1bb85322f7$export$e2b0b9a5e613f348);
$parcel$export($792c6f1bb85322f7$exports, "HARD_DRIVE", () => $792c6f1bb85322f7$export$d361398ba64f04da);
$parcel$export($792c6f1bb85322f7$exports, "HASH", () => $792c6f1bb85322f7$export$ef3af5c7f06a9d78);
$parcel$export($792c6f1bb85322f7$exports, "HEADPHONES", () => $792c6f1bb85322f7$export$e793de575197f608);
$parcel$export($792c6f1bb85322f7$exports, "HEART", () => $792c6f1bb85322f7$export$b251cadde902f66f);
$parcel$export($792c6f1bb85322f7$exports, "HELP_CIRCLE", () => $792c6f1bb85322f7$export$266524074db14b0);
$parcel$export($792c6f1bb85322f7$exports, "HEXAGON", () => $792c6f1bb85322f7$export$78eca3acea1dc2f0);
$parcel$export($792c6f1bb85322f7$exports, "HOME", () => $792c6f1bb85322f7$export$a7c5707626fc90f);
$parcel$export($792c6f1bb85322f7$exports, "IMAGE", () => $792c6f1bb85322f7$export$74f94c628b84d921);
$parcel$export($792c6f1bb85322f7$exports, "INBOX", () => $792c6f1bb85322f7$export$ef2c1d1ceb851b71);
$parcel$export($792c6f1bb85322f7$exports, "INFO", () => $792c6f1bb85322f7$export$7ecad81ba40c4d73);
$parcel$export($792c6f1bb85322f7$exports, "INSTAGRAM", () => $792c6f1bb85322f7$export$a5d05c34e9e9365e);
$parcel$export($792c6f1bb85322f7$exports, "ITALIC", () => $792c6f1bb85322f7$export$9eeef2c439db41e);
$parcel$export($792c6f1bb85322f7$exports, "KEY", () => $792c6f1bb85322f7$export$7167c830cefcb6b5);
$parcel$export($792c6f1bb85322f7$exports, "LAYERS", () => $792c6f1bb85322f7$export$fdca3ba65b5cceec);
$parcel$export($792c6f1bb85322f7$exports, "LAYOUT", () => $792c6f1bb85322f7$export$78ca07932ec5b059);
$parcel$export($792c6f1bb85322f7$exports, "LIFE_BUOY", () => $792c6f1bb85322f7$export$4e00ab2a5773b3fa);
$parcel$export($792c6f1bb85322f7$exports, "LINK_2", () => $792c6f1bb85322f7$export$e1caedbba7ac7882);
$parcel$export($792c6f1bb85322f7$exports, "LINK", () => $792c6f1bb85322f7$export$b395009ca7f092c7);
$parcel$export($792c6f1bb85322f7$exports, "LINKEDIN", () => $792c6f1bb85322f7$export$19dfffc92f62eadd);
$parcel$export($792c6f1bb85322f7$exports, "LIST", () => $792c6f1bb85322f7$export$84cc8e12a434d4e);
$parcel$export($792c6f1bb85322f7$exports, "LOADER", () => $792c6f1bb85322f7$export$5be546ac84d180d1);
$parcel$export($792c6f1bb85322f7$exports, "LOCK", () => $792c6f1bb85322f7$export$9227a1a65abc0f40);
$parcel$export($792c6f1bb85322f7$exports, "LOG_IN", () => $792c6f1bb85322f7$export$46dbfbdf99745111);
$parcel$export($792c6f1bb85322f7$exports, "LOG_OUT", () => $792c6f1bb85322f7$export$cb307dad255adf47);
$parcel$export($792c6f1bb85322f7$exports, "MAIL", () => $792c6f1bb85322f7$export$afb8737f820af419);
$parcel$export($792c6f1bb85322f7$exports, "MAP_PIN", () => $792c6f1bb85322f7$export$b9569b2b59420e1f);
$parcel$export($792c6f1bb85322f7$exports, "MAP", () => $792c6f1bb85322f7$export$ce970371e0e850bc);
$parcel$export($792c6f1bb85322f7$exports, "MAXIMIZE_2", () => $792c6f1bb85322f7$export$a4b99907bf04046);
$parcel$export($792c6f1bb85322f7$exports, "MAXIMIZE", () => $792c6f1bb85322f7$export$9c81eee3ff1dca2f);
$parcel$export($792c6f1bb85322f7$exports, "MEH", () => $792c6f1bb85322f7$export$26865d771eba0c03);
$parcel$export($792c6f1bb85322f7$exports, "MENU", () => $792c6f1bb85322f7$export$4f072ecaef317163);
$parcel$export($792c6f1bb85322f7$exports, "MESSAGE_CIRCLE", () => $792c6f1bb85322f7$export$f2d44f3f4b6f6e85);
$parcel$export($792c6f1bb85322f7$exports, "MESSAGE_SQUARE", () => $792c6f1bb85322f7$export$290c5e392ced0792);
$parcel$export($792c6f1bb85322f7$exports, "MIC_OFF", () => $792c6f1bb85322f7$export$2663e8dd4f2868f9);
$parcel$export($792c6f1bb85322f7$exports, "MIC", () => $792c6f1bb85322f7$export$ecf8569ec6073df0);
$parcel$export($792c6f1bb85322f7$exports, "MINIMIZE_2", () => $792c6f1bb85322f7$export$61f4ff57f4699714);
$parcel$export($792c6f1bb85322f7$exports, "MINIMIZE", () => $792c6f1bb85322f7$export$86f1dcbefc47d0e5);
$parcel$export($792c6f1bb85322f7$exports, "MINUS_CIRCLE", () => $792c6f1bb85322f7$export$d7b7fe2e4cbf1aca);
$parcel$export($792c6f1bb85322f7$exports, "MINUS_SQUARE", () => $792c6f1bb85322f7$export$d184c26d707a4f62);
$parcel$export($792c6f1bb85322f7$exports, "MINUS", () => $792c6f1bb85322f7$export$3fb013b4db9894a1);
$parcel$export($792c6f1bb85322f7$exports, "MONITOR", () => $792c6f1bb85322f7$export$a0d487677f40f400);
$parcel$export($792c6f1bb85322f7$exports, "MOON", () => $792c6f1bb85322f7$export$53f107bf4efd5fa6);
$parcel$export($792c6f1bb85322f7$exports, "MORE_HORIZONTAL", () => $792c6f1bb85322f7$export$b6e4da5b3e5efece);
$parcel$export($792c6f1bb85322f7$exports, "MORE_VERTICAL", () => $792c6f1bb85322f7$export$9a4dfd4e35a8c23f);
$parcel$export($792c6f1bb85322f7$exports, "MOUSE_POINTER", () => $792c6f1bb85322f7$export$9ab771e4c9886201);
$parcel$export($792c6f1bb85322f7$exports, "MOVE", () => $792c6f1bb85322f7$export$346f08c1f0d0fe41);
$parcel$export($792c6f1bb85322f7$exports, "MUSIC", () => $792c6f1bb85322f7$export$cb2ba035ac68bae7);
$parcel$export($792c6f1bb85322f7$exports, "NAVIGATION_2", () => $792c6f1bb85322f7$export$34cdb5aa3a7fa807);
$parcel$export($792c6f1bb85322f7$exports, "NAVIGATION", () => $792c6f1bb85322f7$export$f52dcf7131a7f04);
$parcel$export($792c6f1bb85322f7$exports, "OCTAGON", () => $792c6f1bb85322f7$export$727c2f9cd5e103a6);
$parcel$export($792c6f1bb85322f7$exports, "PACKAGE", () => $792c6f1bb85322f7$export$e77742f4ecbcf7fe);
$parcel$export($792c6f1bb85322f7$exports, "PAPERCLIP", () => $792c6f1bb85322f7$export$8d924f5dc2e0b388);
$parcel$export($792c6f1bb85322f7$exports, "PAUSE_CIRCLE", () => $792c6f1bb85322f7$export$626c04e8e475793f);
$parcel$export($792c6f1bb85322f7$exports, "PAUSE", () => $792c6f1bb85322f7$export$dd1033c27a16bbd3);
$parcel$export($792c6f1bb85322f7$exports, "PEN_TOOL", () => $792c6f1bb85322f7$export$2978d516d7c0a210);
$parcel$export($792c6f1bb85322f7$exports, "PERCENT", () => $792c6f1bb85322f7$export$cd71365b35005b55);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_CALL", () => $792c6f1bb85322f7$export$9edbe31fe55ee4e7);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_FORWARDED", () => $792c6f1bb85322f7$export$8d43fcf7039d29c4);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_INCOMING", () => $792c6f1bb85322f7$export$7874a35404fe72b8);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_MISSED", () => $792c6f1bb85322f7$export$8ac7744006702f7c);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_OFF", () => $792c6f1bb85322f7$export$3f3a86bf1e3d991a);
$parcel$export($792c6f1bb85322f7$exports, "PHONE_OUTGOING", () => $792c6f1bb85322f7$export$77bca9cffb34ac49);
$parcel$export($792c6f1bb85322f7$exports, "PHONE", () => $792c6f1bb85322f7$export$a44129614aa6afd6);
$parcel$export($792c6f1bb85322f7$exports, "PIE_CHART", () => $792c6f1bb85322f7$export$a33a57747ca85497);
$parcel$export($792c6f1bb85322f7$exports, "PLAY_CIRCLE", () => $792c6f1bb85322f7$export$c81727f4e85dae44);
$parcel$export($792c6f1bb85322f7$exports, "PLAY", () => $792c6f1bb85322f7$export$2a0fc68d197e0118);
$parcel$export($792c6f1bb85322f7$exports, "PLUS_CIRCLE", () => $792c6f1bb85322f7$export$63fd9a871098f71c);
$parcel$export($792c6f1bb85322f7$exports, "PLUS_SQUARE", () => $792c6f1bb85322f7$export$a112d3c191161758);
$parcel$export($792c6f1bb85322f7$exports, "PLUS", () => $792c6f1bb85322f7$export$898f613ed2bbf29a);
$parcel$export($792c6f1bb85322f7$exports, "POCKET", () => $792c6f1bb85322f7$export$7e40581c97e2612);
$parcel$export($792c6f1bb85322f7$exports, "POWER", () => $792c6f1bb85322f7$export$be706c8e2fc01f1e);
$parcel$export($792c6f1bb85322f7$exports, "PRINTER", () => $792c6f1bb85322f7$export$50fba2372c27df7a);
$parcel$export($792c6f1bb85322f7$exports, "RADIO", () => $792c6f1bb85322f7$export$f0fd3c01e562401e);
$parcel$export($792c6f1bb85322f7$exports, "REFRESH_CCW", () => $792c6f1bb85322f7$export$8e45f8904a9eb86f);
$parcel$export($792c6f1bb85322f7$exports, "REFRESH_CW", () => $792c6f1bb85322f7$export$3c32121a106d496a);
$parcel$export($792c6f1bb85322f7$exports, "REPEAT", () => $792c6f1bb85322f7$export$2c73c002ec1b27c9);
$parcel$export($792c6f1bb85322f7$exports, "REWIND", () => $792c6f1bb85322f7$export$3af34312bc4883fe);
$parcel$export($792c6f1bb85322f7$exports, "ROTATE_CCW", () => $792c6f1bb85322f7$export$841ab4ec5b5d6b41);
$parcel$export($792c6f1bb85322f7$exports, "ROTATE_CW", () => $792c6f1bb85322f7$export$b37449a87c0a8a66);
$parcel$export($792c6f1bb85322f7$exports, "RSS", () => $792c6f1bb85322f7$export$5ac7b4a51c1c95db);
$parcel$export($792c6f1bb85322f7$exports, "SAVE", () => $792c6f1bb85322f7$export$f9ec4afc4535638b);
$parcel$export($792c6f1bb85322f7$exports, "SCISSORS", () => $792c6f1bb85322f7$export$4108bdb267c3b6c);
$parcel$export($792c6f1bb85322f7$exports, "SEARCH", () => $792c6f1bb85322f7$export$a6b9aaee40d49fd0);
$parcel$export($792c6f1bb85322f7$exports, "SEND", () => $792c6f1bb85322f7$export$1d4af0e360e5c2f9);
$parcel$export($792c6f1bb85322f7$exports, "SERVER", () => $792c6f1bb85322f7$export$7fc2afdd98086cb1);
$parcel$export($792c6f1bb85322f7$exports, "SETTINGS", () => $792c6f1bb85322f7$export$9605fc0d6b1fa63d);
$parcel$export($792c6f1bb85322f7$exports, "SHARE_2", () => $792c6f1bb85322f7$export$5a5b643696270781);
$parcel$export($792c6f1bb85322f7$exports, "SHARE", () => $792c6f1bb85322f7$export$286b3b21a32009b0);
$parcel$export($792c6f1bb85322f7$exports, "SHIELD_OFF", () => $792c6f1bb85322f7$export$554f2f5f49cfd9b6);
$parcel$export($792c6f1bb85322f7$exports, "SHIELD", () => $792c6f1bb85322f7$export$e3525cafdbe42364);
$parcel$export($792c6f1bb85322f7$exports, "SHOPPING_BAG", () => $792c6f1bb85322f7$export$24a7142190733466);
$parcel$export($792c6f1bb85322f7$exports, "SHOPPING_CART", () => $792c6f1bb85322f7$export$51fa6a60df55ad62);
$parcel$export($792c6f1bb85322f7$exports, "SHUFFLE", () => $792c6f1bb85322f7$export$8420b0cf696e971d);
$parcel$export($792c6f1bb85322f7$exports, "SIDEBAR", () => $792c6f1bb85322f7$export$2ee9e5a3556c1e43);
$parcel$export($792c6f1bb85322f7$exports, "SKIP_BACK", () => $792c6f1bb85322f7$export$d341f015bb0cfe2d);
$parcel$export($792c6f1bb85322f7$exports, "SKIP_FORWARD", () => $792c6f1bb85322f7$export$557ff8df21a13ece);
$parcel$export($792c6f1bb85322f7$exports, "SLACK", () => $792c6f1bb85322f7$export$f1d97c73367642d8);
$parcel$export($792c6f1bb85322f7$exports, "SLASH", () => $792c6f1bb85322f7$export$98238152dfccf046);
$parcel$export($792c6f1bb85322f7$exports, "SLIDERS", () => $792c6f1bb85322f7$export$725d301b7edf949a);
$parcel$export($792c6f1bb85322f7$exports, "SMARTPHONE", () => $792c6f1bb85322f7$export$e7c7aa8b8581c21b);
$parcel$export($792c6f1bb85322f7$exports, "SMILE", () => $792c6f1bb85322f7$export$7c66f5a7b309d620);
$parcel$export($792c6f1bb85322f7$exports, "SPEAKER", () => $792c6f1bb85322f7$export$8f7d843b9aace1ee);
$parcel$export($792c6f1bb85322f7$exports, "SQUARE", () => $792c6f1bb85322f7$export$b3f6956f963758ad);
$parcel$export($792c6f1bb85322f7$exports, "STAR", () => $792c6f1bb85322f7$export$54408be40394d82a);
$parcel$export($792c6f1bb85322f7$exports, "STOP_CIRCLE", () => $792c6f1bb85322f7$export$c79cc09643248eeb);
$parcel$export($792c6f1bb85322f7$exports, "SUN", () => $792c6f1bb85322f7$export$b0483b844167706f);
$parcel$export($792c6f1bb85322f7$exports, "SUNRISE", () => $792c6f1bb85322f7$export$675fe0ed743a3b5);
$parcel$export($792c6f1bb85322f7$exports, "SUNSET", () => $792c6f1bb85322f7$export$1ec997190f8239d2);
$parcel$export($792c6f1bb85322f7$exports, "TABLE", () => $792c6f1bb85322f7$export$88a597d0c7ae97b);
$parcel$export($792c6f1bb85322f7$exports, "TABLET", () => $792c6f1bb85322f7$export$ab36f5c8db36b379);
$parcel$export($792c6f1bb85322f7$exports, "TAG", () => $792c6f1bb85322f7$export$2680f340d0781853);
$parcel$export($792c6f1bb85322f7$exports, "TARGET", () => $792c6f1bb85322f7$export$9cb8e7b38dc3cece);
$parcel$export($792c6f1bb85322f7$exports, "TERMINAL", () => $792c6f1bb85322f7$export$7d80210a20f8f3d1);
$parcel$export($792c6f1bb85322f7$exports, "THERMOMETER", () => $792c6f1bb85322f7$export$34ea19fe51ab1c1c);
$parcel$export($792c6f1bb85322f7$exports, "THUMBS_DOWN", () => $792c6f1bb85322f7$export$353596a6bc0be512);
$parcel$export($792c6f1bb85322f7$exports, "THUMBS_UP", () => $792c6f1bb85322f7$export$f6ac9ec5800238fa);
$parcel$export($792c6f1bb85322f7$exports, "TOGGLE_LEFT", () => $792c6f1bb85322f7$export$48737ef57d2525b8);
$parcel$export($792c6f1bb85322f7$exports, "TOGGLE_RIGHT", () => $792c6f1bb85322f7$export$4aa9659d76022fe3);
$parcel$export($792c6f1bb85322f7$exports, "TOOL", () => $792c6f1bb85322f7$export$99630d895d68527c);
$parcel$export($792c6f1bb85322f7$exports, "TRASH_2", () => $792c6f1bb85322f7$export$195e7e5c49b3bfbc);
$parcel$export($792c6f1bb85322f7$exports, "TRASH", () => $792c6f1bb85322f7$export$2b848a0670941e75);
$parcel$export($792c6f1bb85322f7$exports, "TRELLO", () => $792c6f1bb85322f7$export$9c95d39d8f488b22);
$parcel$export($792c6f1bb85322f7$exports, "TRENDING_DOWN", () => $792c6f1bb85322f7$export$dd09982822210aa2);
$parcel$export($792c6f1bb85322f7$exports, "TRENDING_UP", () => $792c6f1bb85322f7$export$ec015fdea1dd0a2c);
$parcel$export($792c6f1bb85322f7$exports, "TRIANGLE", () => $792c6f1bb85322f7$export$fbfd5bfcb4fb3235);
$parcel$export($792c6f1bb85322f7$exports, "TRUCK", () => $792c6f1bb85322f7$export$7d6bc2dd6157173a);
$parcel$export($792c6f1bb85322f7$exports, "TV", () => $792c6f1bb85322f7$export$9e799ed47e538f9d);
$parcel$export($792c6f1bb85322f7$exports, "TWITCH", () => $792c6f1bb85322f7$export$b5015269503eb8d2);
$parcel$export($792c6f1bb85322f7$exports, "TWITTER", () => $792c6f1bb85322f7$export$4d774a8611f47fd1);
$parcel$export($792c6f1bb85322f7$exports, "TYPE", () => $792c6f1bb85322f7$export$b87f371cbc396fcf);
$parcel$export($792c6f1bb85322f7$exports, "UMBRELLA", () => $792c6f1bb85322f7$export$a12eb916a13d6f09);
$parcel$export($792c6f1bb85322f7$exports, "UNDERLINE", () => $792c6f1bb85322f7$export$b5049a01c66d2d23);
$parcel$export($792c6f1bb85322f7$exports, "UNLOCK", () => $792c6f1bb85322f7$export$81c5e18fd95994a5);
$parcel$export($792c6f1bb85322f7$exports, "UPLOAD_CLOUD", () => $792c6f1bb85322f7$export$f4c4e2c9bf2ce533);
$parcel$export($792c6f1bb85322f7$exports, "UPLOAD", () => $792c6f1bb85322f7$export$3d3a8cdcec4c3758);
$parcel$export($792c6f1bb85322f7$exports, "USER_CHECK", () => $792c6f1bb85322f7$export$693d856f28a21c4f);
$parcel$export($792c6f1bb85322f7$exports, "USER_MINUS", () => $792c6f1bb85322f7$export$6c25127c5c008da6);
$parcel$export($792c6f1bb85322f7$exports, "USER_PLUS", () => $792c6f1bb85322f7$export$ce7af89d5d43b0b5);
$parcel$export($792c6f1bb85322f7$exports, "USER_X", () => $792c6f1bb85322f7$export$9a568e121de312c4);
$parcel$export($792c6f1bb85322f7$exports, "USER", () => $792c6f1bb85322f7$export$ff09b90989b21a8);
$parcel$export($792c6f1bb85322f7$exports, "USERS", () => $792c6f1bb85322f7$export$5a898dd3a28f57e9);
$parcel$export($792c6f1bb85322f7$exports, "VIDEO_OFF", () => $792c6f1bb85322f7$export$78d001ec5399d989);
$parcel$export($792c6f1bb85322f7$exports, "VIDEO", () => $792c6f1bb85322f7$export$f3657d8d6be09c14);
$parcel$export($792c6f1bb85322f7$exports, "VOICEMAIL", () => $792c6f1bb85322f7$export$f6c2d9104388354);
$parcel$export($792c6f1bb85322f7$exports, "VOLUME_1", () => $792c6f1bb85322f7$export$b6a66ad0c162130c);
$parcel$export($792c6f1bb85322f7$exports, "VOLUME_2", () => $792c6f1bb85322f7$export$11aef5044aba4f27);
$parcel$export($792c6f1bb85322f7$exports, "VOLUME_X", () => $792c6f1bb85322f7$export$3e8aae031e23729e);
$parcel$export($792c6f1bb85322f7$exports, "VOLUME", () => $792c6f1bb85322f7$export$46cbe0a500d5437b);
$parcel$export($792c6f1bb85322f7$exports, "WATCH", () => $792c6f1bb85322f7$export$50a178f7977eed37);
$parcel$export($792c6f1bb85322f7$exports, "WIFI_OFF", () => $792c6f1bb85322f7$export$2cf378bbeec0f1a0);
$parcel$export($792c6f1bb85322f7$exports, "WIFI", () => $792c6f1bb85322f7$export$d1680d626f929545);
$parcel$export($792c6f1bb85322f7$exports, "WIND", () => $792c6f1bb85322f7$export$283c3876d9630f38);
$parcel$export($792c6f1bb85322f7$exports, "X_CIRCLE", () => $792c6f1bb85322f7$export$2c41f6f5814366a2);
$parcel$export($792c6f1bb85322f7$exports, "X_OCTAGON", () => $792c6f1bb85322f7$export$8a093f244501728a);
$parcel$export($792c6f1bb85322f7$exports, "X_SQUARE", () => $792c6f1bb85322f7$export$37a1b2556082a0bb);
$parcel$export($792c6f1bb85322f7$exports, "X", () => $792c6f1bb85322f7$export$78acf4525d8a74c4);
$parcel$export($792c6f1bb85322f7$exports, "YOUTUBE", () => $792c6f1bb85322f7$export$b365bc2753a5cb04);
$parcel$export($792c6f1bb85322f7$exports, "ZAP_OFF", () => $792c6f1bb85322f7$export$af856cffd8f64cfa);
$parcel$export($792c6f1bb85322f7$exports, "ZAP", () => $792c6f1bb85322f7$export$558e7b41a81b2885);
$parcel$export($792c6f1bb85322f7$exports, "ZOOM_IN", () => $792c6f1bb85322f7$export$db681cc2ef83e91f);
$parcel$export($792c6f1bb85322f7$exports, "ZOOM_OUT", () => $792c6f1bb85322f7$export$63ea321ad91823a7);
/* tslint:disable */ var $792c6f1bb85322f7$export$33eb309289062be7 = "activity";
var $792c6f1bb85322f7$export$96fb28b291d9eefa = "airplay";
var $792c6f1bb85322f7$export$f5e9b024d089ea84 = "alert-circle";
var $792c6f1bb85322f7$export$2dcbb90a00fa676f = "alert-octagon";
var $792c6f1bb85322f7$export$8b40992ab7adada6 = "alert-triangle";
var $792c6f1bb85322f7$export$3ea9e188ab01c845 = "align-center";
var $792c6f1bb85322f7$export$2420f2030c2aefcf = "align-justify";
var $792c6f1bb85322f7$export$7895aadd1956b1c7 = "align-left";
var $792c6f1bb85322f7$export$f1299af03a3c605a = "align-right";
var $792c6f1bb85322f7$export$2577073a94e6b433 = "anchor";
var $792c6f1bb85322f7$export$e07990d13d62a4c5 = "aperture";
var $792c6f1bb85322f7$export$a7c1ec142e70d69d = "archive";
var $792c6f1bb85322f7$export$8faa0bfb783e4f95 = "arrow-down-circle";
var $792c6f1bb85322f7$export$d6b976886b9bb938 = "arrow-down-left";
var $792c6f1bb85322f7$export$fd0e719468a31e9f = "arrow-down-right";
var $792c6f1bb85322f7$export$59f214baefff6196 = "arrow-down";
var $792c6f1bb85322f7$export$3b80bfa1f51653e6 = "arrow-left-circle";
var $792c6f1bb85322f7$export$8d4f84cc5dc5fc15 = "arrow-left";
var $792c6f1bb85322f7$export$c555aea97853be67 = "arrow-right-circle";
var $792c6f1bb85322f7$export$e9510a4613bb01df = "arrow-right";
var $792c6f1bb85322f7$export$3102bf741e6e883d = "arrow-up-circle";
var $792c6f1bb85322f7$export$c840fb87f7cd43cd = "arrow-up-left";
var $792c6f1bb85322f7$export$9efbd9847f714012 = "arrow-up-right";
var $792c6f1bb85322f7$export$8188339dbe6c99c4 = "arrow-up";
var $792c6f1bb85322f7$export$5da71d022bae01b1 = "at-sign";
var $792c6f1bb85322f7$export$534b560abc2bb11d = "award";
var $792c6f1bb85322f7$export$d9c3752d69e5e356 = "bar-chart-2";
var $792c6f1bb85322f7$export$2202d1df9575294c = "bar-chart";
var $792c6f1bb85322f7$export$22f257c25260f09c = "battery-charging";
var $792c6f1bb85322f7$export$1a7b790285c84ca3 = "battery";
var $792c6f1bb85322f7$export$bd5b6944c36df62d = "bell-off";
var $792c6f1bb85322f7$export$f01c6ff914c49906 = "bell";
var $792c6f1bb85322f7$export$6781fbe3ae82070a = "bluetooth";
var $792c6f1bb85322f7$export$c1286c4c2a7c066 = "bold";
var $792c6f1bb85322f7$export$8cd74ce6bae0314 = "book-open";
var $792c6f1bb85322f7$export$bbdb19d3986a2390 = "book";
var $792c6f1bb85322f7$export$865a16a14f6d3268 = "bookmark";
var $792c6f1bb85322f7$export$98e6811b31774aaa = "box";
var $792c6f1bb85322f7$export$3bf9df5d61e98b9a = "briefcase";
var $792c6f1bb85322f7$export$7d65e474be175151 = "calendar";
var $792c6f1bb85322f7$export$a73d59aca32277d4 = "camera-off";
var $792c6f1bb85322f7$export$86703463cbdc13c0 = "camera";
var $792c6f1bb85322f7$export$32e24be20223d4c1 = "cast";
var $792c6f1bb85322f7$export$c44dea1357e31512 = "check-circle";
var $792c6f1bb85322f7$export$2f78c72e5aba3d71 = "check-square";
var $792c6f1bb85322f7$export$c953d1cd180adfae = "check";
var $792c6f1bb85322f7$export$f905c6094a0f672 = "chevron-down";
var $792c6f1bb85322f7$export$c0007d962b255231 = "chevron-left";
var $792c6f1bb85322f7$export$dac98cecf7b6366 = "chevron-right";
var $792c6f1bb85322f7$export$d503df0eed5c9169 = "chevron-up";
var $792c6f1bb85322f7$export$7477b66f96c3cbb2 = "chevrons-down";
var $792c6f1bb85322f7$export$c3c87597fecab492 = "chevrons-left";
var $792c6f1bb85322f7$export$ff3d2c531020c017 = "chevrons-right";
var $792c6f1bb85322f7$export$cf9398fb008560fe = "chevrons-up";
var $792c6f1bb85322f7$export$882c3be734f84f58 = "chrome";
var $792c6f1bb85322f7$export$2b4cb8204be4ae5e = "circle";
var $792c6f1bb85322f7$export$4e31d82ea0b583e4 = "clipboard";
var $792c6f1bb85322f7$export$5edb9d9e4caf1353 = "clock";
var $792c6f1bb85322f7$export$3f8aa14fc7e8ccf3 = "cloud-drizzle";
var $792c6f1bb85322f7$export$3b479bcdf2f4e44b = "cloud-lightning";
var $792c6f1bb85322f7$export$b8d31db27efaf164 = "cloud-off";
var $792c6f1bb85322f7$export$947ab78ead319c84 = "cloud-rain";
var $792c6f1bb85322f7$export$64a0e2ec51f02eac = "cloud-snow";
var $792c6f1bb85322f7$export$428c0af80a7329cd = "cloud";
var $792c6f1bb85322f7$export$ec5856072852bd7f = "code";
var $792c6f1bb85322f7$export$755f8b1d570f7f4a = "codepen";
var $792c6f1bb85322f7$export$b00f5b211a823c24 = "codesandbox";
var $792c6f1bb85322f7$export$61d5289867e4f305 = "coffee";
var $792c6f1bb85322f7$export$6a6dcc7e725abed4 = "columns";
var $792c6f1bb85322f7$export$671af8f385981731 = "command";
var $792c6f1bb85322f7$export$d5e9b613bc4c47f = "compass";
var $792c6f1bb85322f7$export$92f9e1ed9114d3a6 = "copy";
var $792c6f1bb85322f7$export$538eb2a283c0f17f = "corner-down-left";
var $792c6f1bb85322f7$export$368bdf0dd1b4f2a7 = "corner-down-right";
var $792c6f1bb85322f7$export$b9c570b1cd012e0a = "corner-left-down";
var $792c6f1bb85322f7$export$6294dac9279a615a = "corner-left-up";
var $792c6f1bb85322f7$export$c78c22e4590cff9f = "corner-right-down";
var $792c6f1bb85322f7$export$2bc12423e8ab4562 = "corner-right-up";
var $792c6f1bb85322f7$export$8c6de84b16e0bc74 = "corner-up-left";
var $792c6f1bb85322f7$export$c1944a58b59f2e63 = "corner-up-right";
var $792c6f1bb85322f7$export$5ebf4cde340e6028 = "cpu";
var $792c6f1bb85322f7$export$dcfa992d78d44a92 = "credit-card";
var $792c6f1bb85322f7$export$a07a7de5efb26195 = "crop";
var $792c6f1bb85322f7$export$d7ca88fc6cbcb4e1 = "crosshair";
var $792c6f1bb85322f7$export$931b0c46b95fd31e = "database";
var $792c6f1bb85322f7$export$4bd2facc4a3e6aa1 = "delete";
var $792c6f1bb85322f7$export$174c38d98ccdc6e4 = "disc";
var $792c6f1bb85322f7$export$5f59d0cba123a7a6 = "divide-circle";
var $792c6f1bb85322f7$export$184e21bbaf627886 = "divide-square";
var $792c6f1bb85322f7$export$480bc6cd31f42a68 = "divide";
var $792c6f1bb85322f7$export$20bbf99b7f7af07 = "dollar-sign";
var $792c6f1bb85322f7$export$bc7b79dab261a61c = "download-cloud";
var $792c6f1bb85322f7$export$d028451e5fd5dfd3 = "download";
var $792c6f1bb85322f7$export$96afce72bc67f90b = "dribbble";
var $792c6f1bb85322f7$export$ab7389fabcc55c20 = "droplet";
var $792c6f1bb85322f7$export$8690efe8b4d0bbd0 = "edit-2";
var $792c6f1bb85322f7$export$f91685a2bf37bd13 = "edit-3";
var $792c6f1bb85322f7$export$250171a898bf7ef = "edit";
var $792c6f1bb85322f7$export$462971122ed9eae3 = "external-link";
var $792c6f1bb85322f7$export$241e2d72fa0574fa = "eye-off";
var $792c6f1bb85322f7$export$4c4520429be8c63 = "eye";
var $792c6f1bb85322f7$export$99ed96e5d534c6be = "facebook";
var $792c6f1bb85322f7$export$e305fc85d2cb6150 = "fast-forward";
var $792c6f1bb85322f7$export$421b42f57a9b4f2d = "feather";
var $792c6f1bb85322f7$export$91fa8f2d7e3174cc = "figma";
var $792c6f1bb85322f7$export$b80ffe37949e3d0 = "file-minus";
var $792c6f1bb85322f7$export$acec4aebbeb107b0 = "file-plus";
var $792c6f1bb85322f7$export$bf7255ba41ca7f46 = "file-text";
var $792c6f1bb85322f7$export$1802dbfd31b58482 = "file";
var $792c6f1bb85322f7$export$ef519c83bf380b6 = "film";
var $792c6f1bb85322f7$export$c1c49903035a02df = "filter";
var $792c6f1bb85322f7$export$3a077bb7820dc6e4 = "flag";
var $792c6f1bb85322f7$export$94f12c8d79f1108b = "folder-minus";
var $792c6f1bb85322f7$export$1567b66611c1716a = "folder-plus";
var $792c6f1bb85322f7$export$d31d8fac97169a4b = "folder";
var $792c6f1bb85322f7$export$44281146b54c1f30 = "framer";
var $792c6f1bb85322f7$export$dd1cee8b45032547 = "frown";
var $792c6f1bb85322f7$export$b70c28f717210d81 = "gift";
var $792c6f1bb85322f7$export$512554f3e5add99 = "git-branch";
var $792c6f1bb85322f7$export$95b7e707a15d4f18 = "git-commit";
var $792c6f1bb85322f7$export$9ac7ef47e370fd07 = "git-merge";
var $792c6f1bb85322f7$export$4c07773c7a8ac052 = "git-pull-request";
var $792c6f1bb85322f7$export$8606c40cc696b7b = "github";
var $792c6f1bb85322f7$export$b54ecf54ae9ea39e = "gitlab";
var $792c6f1bb85322f7$export$953a3f3bd659178f = "globe";
var $792c6f1bb85322f7$export$e2b0b9a5e613f348 = "grid";
var $792c6f1bb85322f7$export$d361398ba64f04da = "hard-drive";
var $792c6f1bb85322f7$export$ef3af5c7f06a9d78 = "hash";
var $792c6f1bb85322f7$export$e793de575197f608 = "headphones";
var $792c6f1bb85322f7$export$b251cadde902f66f = "heart";
var $792c6f1bb85322f7$export$266524074db14b0 = "help-circle";
var $792c6f1bb85322f7$export$78eca3acea1dc2f0 = "hexagon";
var $792c6f1bb85322f7$export$a7c5707626fc90f = "home";
var $792c6f1bb85322f7$export$74f94c628b84d921 = "image";
var $792c6f1bb85322f7$export$ef2c1d1ceb851b71 = "inbox";
var $792c6f1bb85322f7$export$7ecad81ba40c4d73 = "info";
var $792c6f1bb85322f7$export$a5d05c34e9e9365e = "instagram";
var $792c6f1bb85322f7$export$9eeef2c439db41e = "italic";
var $792c6f1bb85322f7$export$7167c830cefcb6b5 = "key";
var $792c6f1bb85322f7$export$fdca3ba65b5cceec = "layers";
var $792c6f1bb85322f7$export$78ca07932ec5b059 = "layout";
var $792c6f1bb85322f7$export$4e00ab2a5773b3fa = "life-buoy";
var $792c6f1bb85322f7$export$e1caedbba7ac7882 = "link-2";
var $792c6f1bb85322f7$export$b395009ca7f092c7 = "link";
var $792c6f1bb85322f7$export$19dfffc92f62eadd = "linkedin";
var $792c6f1bb85322f7$export$84cc8e12a434d4e = "list";
var $792c6f1bb85322f7$export$5be546ac84d180d1 = "loader";
var $792c6f1bb85322f7$export$9227a1a65abc0f40 = "lock";
var $792c6f1bb85322f7$export$46dbfbdf99745111 = "log-in";
var $792c6f1bb85322f7$export$cb307dad255adf47 = "log-out";
var $792c6f1bb85322f7$export$afb8737f820af419 = "mail";
var $792c6f1bb85322f7$export$b9569b2b59420e1f = "map-pin";
var $792c6f1bb85322f7$export$ce970371e0e850bc = "map";
var $792c6f1bb85322f7$export$a4b99907bf04046 = "maximize-2";
var $792c6f1bb85322f7$export$9c81eee3ff1dca2f = "maximize";
var $792c6f1bb85322f7$export$26865d771eba0c03 = "meh";
var $792c6f1bb85322f7$export$4f072ecaef317163 = "menu";
var $792c6f1bb85322f7$export$f2d44f3f4b6f6e85 = "message-circle";
var $792c6f1bb85322f7$export$290c5e392ced0792 = "message-square";
var $792c6f1bb85322f7$export$2663e8dd4f2868f9 = "mic-off";
var $792c6f1bb85322f7$export$ecf8569ec6073df0 = "mic";
var $792c6f1bb85322f7$export$61f4ff57f4699714 = "minimize-2";
var $792c6f1bb85322f7$export$86f1dcbefc47d0e5 = "minimize";
var $792c6f1bb85322f7$export$d7b7fe2e4cbf1aca = "minus-circle";
var $792c6f1bb85322f7$export$d184c26d707a4f62 = "minus-square";
var $792c6f1bb85322f7$export$3fb013b4db9894a1 = "minus";
var $792c6f1bb85322f7$export$a0d487677f40f400 = "monitor";
var $792c6f1bb85322f7$export$53f107bf4efd5fa6 = "moon";
var $792c6f1bb85322f7$export$b6e4da5b3e5efece = "more-horizontal";
var $792c6f1bb85322f7$export$9a4dfd4e35a8c23f = "more-vertical";
var $792c6f1bb85322f7$export$9ab771e4c9886201 = "mouse-pointer";
var $792c6f1bb85322f7$export$346f08c1f0d0fe41 = "move";
var $792c6f1bb85322f7$export$cb2ba035ac68bae7 = "music";
var $792c6f1bb85322f7$export$34cdb5aa3a7fa807 = "navigation-2";
var $792c6f1bb85322f7$export$f52dcf7131a7f04 = "navigation";
var $792c6f1bb85322f7$export$727c2f9cd5e103a6 = "octagon";
var $792c6f1bb85322f7$export$e77742f4ecbcf7fe = "package";
var $792c6f1bb85322f7$export$8d924f5dc2e0b388 = "paperclip";
var $792c6f1bb85322f7$export$626c04e8e475793f = "pause-circle";
var $792c6f1bb85322f7$export$dd1033c27a16bbd3 = "pause";
var $792c6f1bb85322f7$export$2978d516d7c0a210 = "pen-tool";
var $792c6f1bb85322f7$export$cd71365b35005b55 = "percent";
var $792c6f1bb85322f7$export$9edbe31fe55ee4e7 = "phone-call";
var $792c6f1bb85322f7$export$8d43fcf7039d29c4 = "phone-forwarded";
var $792c6f1bb85322f7$export$7874a35404fe72b8 = "phone-incoming";
var $792c6f1bb85322f7$export$8ac7744006702f7c = "phone-missed";
var $792c6f1bb85322f7$export$3f3a86bf1e3d991a = "phone-off";
var $792c6f1bb85322f7$export$77bca9cffb34ac49 = "phone-outgoing";
var $792c6f1bb85322f7$export$a44129614aa6afd6 = "phone";
var $792c6f1bb85322f7$export$a33a57747ca85497 = "pie-chart";
var $792c6f1bb85322f7$export$c81727f4e85dae44 = "play-circle";
var $792c6f1bb85322f7$export$2a0fc68d197e0118 = "play";
var $792c6f1bb85322f7$export$63fd9a871098f71c = "plus-circle";
var $792c6f1bb85322f7$export$a112d3c191161758 = "plus-square";
var $792c6f1bb85322f7$export$898f613ed2bbf29a = "plus";
var $792c6f1bb85322f7$export$7e40581c97e2612 = "pocket";
var $792c6f1bb85322f7$export$be706c8e2fc01f1e = "power";
var $792c6f1bb85322f7$export$50fba2372c27df7a = "printer";
var $792c6f1bb85322f7$export$f0fd3c01e562401e = "radio";
var $792c6f1bb85322f7$export$8e45f8904a9eb86f = "refresh-ccw";
var $792c6f1bb85322f7$export$3c32121a106d496a = "refresh-cw";
var $792c6f1bb85322f7$export$2c73c002ec1b27c9 = "repeat";
var $792c6f1bb85322f7$export$3af34312bc4883fe = "rewind";
var $792c6f1bb85322f7$export$841ab4ec5b5d6b41 = "rotate-ccw";
var $792c6f1bb85322f7$export$b37449a87c0a8a66 = "rotate-cw";
var $792c6f1bb85322f7$export$5ac7b4a51c1c95db = "rss";
var $792c6f1bb85322f7$export$f9ec4afc4535638b = "save";
var $792c6f1bb85322f7$export$4108bdb267c3b6c = "scissors";
var $792c6f1bb85322f7$export$a6b9aaee40d49fd0 = "search";
var $792c6f1bb85322f7$export$1d4af0e360e5c2f9 = "send";
var $792c6f1bb85322f7$export$7fc2afdd98086cb1 = "server";
var $792c6f1bb85322f7$export$9605fc0d6b1fa63d = "settings";
var $792c6f1bb85322f7$export$5a5b643696270781 = "share-2";
var $792c6f1bb85322f7$export$286b3b21a32009b0 = "share";
var $792c6f1bb85322f7$export$554f2f5f49cfd9b6 = "shield-off";
var $792c6f1bb85322f7$export$e3525cafdbe42364 = "shield";
var $792c6f1bb85322f7$export$24a7142190733466 = "shopping-bag";
var $792c6f1bb85322f7$export$51fa6a60df55ad62 = "shopping-cart";
var $792c6f1bb85322f7$export$8420b0cf696e971d = "shuffle";
var $792c6f1bb85322f7$export$2ee9e5a3556c1e43 = "sidebar";
var $792c6f1bb85322f7$export$d341f015bb0cfe2d = "skip-back";
var $792c6f1bb85322f7$export$557ff8df21a13ece = "skip-forward";
var $792c6f1bb85322f7$export$f1d97c73367642d8 = "slack";
var $792c6f1bb85322f7$export$98238152dfccf046 = "slash";
var $792c6f1bb85322f7$export$725d301b7edf949a = "sliders";
var $792c6f1bb85322f7$export$e7c7aa8b8581c21b = "smartphone";
var $792c6f1bb85322f7$export$7c66f5a7b309d620 = "smile";
var $792c6f1bb85322f7$export$8f7d843b9aace1ee = "speaker";
var $792c6f1bb85322f7$export$b3f6956f963758ad = "square";
var $792c6f1bb85322f7$export$54408be40394d82a = "star";
var $792c6f1bb85322f7$export$c79cc09643248eeb = "stop-circle";
var $792c6f1bb85322f7$export$b0483b844167706f = "sun";
var $792c6f1bb85322f7$export$675fe0ed743a3b5 = "sunrise";
var $792c6f1bb85322f7$export$1ec997190f8239d2 = "sunset";
var $792c6f1bb85322f7$export$88a597d0c7ae97b = "table";
var $792c6f1bb85322f7$export$ab36f5c8db36b379 = "tablet";
var $792c6f1bb85322f7$export$2680f340d0781853 = "tag";
var $792c6f1bb85322f7$export$9cb8e7b38dc3cece = "target";
var $792c6f1bb85322f7$export$7d80210a20f8f3d1 = "terminal";
var $792c6f1bb85322f7$export$34ea19fe51ab1c1c = "thermometer";
var $792c6f1bb85322f7$export$353596a6bc0be512 = "thumbs-down";
var $792c6f1bb85322f7$export$f6ac9ec5800238fa = "thumbs-up";
var $792c6f1bb85322f7$export$48737ef57d2525b8 = "toggle-left";
var $792c6f1bb85322f7$export$4aa9659d76022fe3 = "toggle-right";
var $792c6f1bb85322f7$export$99630d895d68527c = "tool";
var $792c6f1bb85322f7$export$195e7e5c49b3bfbc = "trash-2";
var $792c6f1bb85322f7$export$2b848a0670941e75 = "trash";
var $792c6f1bb85322f7$export$9c95d39d8f488b22 = "trello";
var $792c6f1bb85322f7$export$dd09982822210aa2 = "trending-down";
var $792c6f1bb85322f7$export$ec015fdea1dd0a2c = "trending-up";
var $792c6f1bb85322f7$export$fbfd5bfcb4fb3235 = "triangle";
var $792c6f1bb85322f7$export$7d6bc2dd6157173a = "truck";
var $792c6f1bb85322f7$export$9e799ed47e538f9d = "tv";
var $792c6f1bb85322f7$export$b5015269503eb8d2 = "twitch";
var $792c6f1bb85322f7$export$4d774a8611f47fd1 = "twitter";
var $792c6f1bb85322f7$export$b87f371cbc396fcf = "type";
var $792c6f1bb85322f7$export$a12eb916a13d6f09 = "umbrella";
var $792c6f1bb85322f7$export$b5049a01c66d2d23 = "underline";
var $792c6f1bb85322f7$export$81c5e18fd95994a5 = "unlock";
var $792c6f1bb85322f7$export$f4c4e2c9bf2ce533 = "upload-cloud";
var $792c6f1bb85322f7$export$3d3a8cdcec4c3758 = "upload";
var $792c6f1bb85322f7$export$693d856f28a21c4f = "user-check";
var $792c6f1bb85322f7$export$6c25127c5c008da6 = "user-minus";
var $792c6f1bb85322f7$export$ce7af89d5d43b0b5 = "user-plus";
var $792c6f1bb85322f7$export$9a568e121de312c4 = "user-x";
var $792c6f1bb85322f7$export$ff09b90989b21a8 = "user";
var $792c6f1bb85322f7$export$5a898dd3a28f57e9 = "users";
var $792c6f1bb85322f7$export$78d001ec5399d989 = "video-off";
var $792c6f1bb85322f7$export$f3657d8d6be09c14 = "video";
var $792c6f1bb85322f7$export$f6c2d9104388354 = "voicemail";
var $792c6f1bb85322f7$export$b6a66ad0c162130c = "volume-1";
var $792c6f1bb85322f7$export$11aef5044aba4f27 = "volume-2";
var $792c6f1bb85322f7$export$3e8aae031e23729e = "volume-x";
var $792c6f1bb85322f7$export$46cbe0a500d5437b = "volume";
var $792c6f1bb85322f7$export$50a178f7977eed37 = "watch";
var $792c6f1bb85322f7$export$2cf378bbeec0f1a0 = "wifi-off";
var $792c6f1bb85322f7$export$d1680d626f929545 = "wifi";
var $792c6f1bb85322f7$export$283c3876d9630f38 = "wind";
var $792c6f1bb85322f7$export$2c41f6f5814366a2 = "x-circle";
var $792c6f1bb85322f7$export$8a093f244501728a = "x-octagon";
var $792c6f1bb85322f7$export$37a1b2556082a0bb = "x-square";
var $792c6f1bb85322f7$export$78acf4525d8a74c4 = "x";
var $792c6f1bb85322f7$export$b365bc2753a5cb04 = "youtube";
var $792c6f1bb85322f7$export$af856cffd8f64cfa = "zap-off";
var $792c6f1bb85322f7$export$558e7b41a81b2885 = "zap";
var $792c6f1bb85322f7$export$db681cc2ef83e91f = "zoom-in";
var $792c6f1bb85322f7$export$63ea321ad91823a7 = "zoom-out";


var $c198384e79e1bb6f$export$8d8dc7d5f743331b = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCloseClick = function() {
            _this.triggerDismiss(false);
        };
        _this.startTimeout = function() {
            var timeout = _this.attrs.timeout;
            if (timeout > 0) _this.setTimeout(function() {
                return _this.triggerDismiss(true);
            }, timeout);
        };
        return _this;
    }
    Toast.prototype.getDefaultAttrs = function() {
        return {
            timeout: 3000
        };
    };
    Toast.prototype.oncreate = function() {
        this.startTimeout();
    };
    Toast.prototype.onbeforeupdate = function(vnode, prev) {
        _super.prototype.onbeforeupdate.call(this, vnode, prev);
        if (prev.attrs.timeout <= 0 && vnode.attrs.timeout > 0) this.startTimeout();
        else if (prev.attrs.timeout > 0 && vnode.attrs.timeout <= 0) this.clearTimeouts();
        else if (vnode.attrs.timeout !== prev.attrs.timeout) {
            this.clearTimeouts();
            this.startTimeout();
        }
    };
    Toast.prototype.view = function() {
        var _a = this.attrs, className = _a.class, intent = _a.intent, size = _a.size, icon = _a.icon, message = _a.message, htmlAttrs = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "class",
            "intent",
            "size",
            "icon",
            "message"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).TOAST, intent && "cui-".concat(intent), size && "cui-".concat(size), className);
        var content = [
            icon && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $cecad194b10e0134$export$f04a61298a47a40f), {
                name: icon
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".".concat((0, $560ae065107eea8c$export$4dbe3495bda74f11).TOAST_MESSAGE), message),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $cecad194b10e0134$export$f04a61298a47a40f), {
                name: (0, $792c6f1bb85322f7$exports).X,
                onclick: this.handleCloseClick
            })
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            class: classes,
            onblur: this.startTimeout,
            onfocus: this.clearTimeouts,
            onmouseenter: this.clearTimeouts,
            onmouseleave: this.startTimeout
        }, htmlAttrs), {
            tabindex: 0
        }), content);
    };
    Toast.prototype.onremove = function() {
        this.clearTimeouts();
    };
    Toast.prototype.triggerDismiss = function(didTimeoutExpire) {
        (0, $68113dfa49ce8411$export$175e60bb96229ece)(this.attrs.onDismiss, this.attrs.key, didTimeoutExpire);
        this.clearTimeouts();
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    };
    return Toast;
}((0, $9da61e952759bc27$export$ca6a3753167de7aa));





var $d1d62ecbb8386812$export$4b0075e5ea5e1f26 = {
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    ESCAPE: 27,
    SPACE: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};






var $f6cb3d5ec54cf5be$export$602eac185826482c = /** @class */ function() {
    function Portal() {}
    Portal.prototype.oncreate = function(_a) {
        var attrs = _a.attrs, children = _a.children;
        var rootElement = document.createElement("div");
        var container = attrs.container || document.body;
        container.appendChild(rootElement);
        this.rootElement = rootElement;
        this.setStyles(attrs);
        this.content = {
            view: function() {
                return children;
            }
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount(this.rootElement, this.content);
        (0, $68113dfa49ce8411$export$175e60bb96229ece)(attrs.onContentMount, rootElement);
    };
    Portal.prototype.onupdate = function(_a) {
        var attrs = _a.attrs;
        this.setStyles(attrs);
    };
    Portal.prototype.onbeforeupdate = function(_a) {
        var children = _a.children;
        if (!this.content) return false;
        this.content.view = function() {
            return children;
        };
    };
    Portal.prototype.onremove = function(_a) {
        var attrs = _a.attrs;
        var container = attrs.container || document.body;
        if (container.contains(this.rootElement)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount(this.rootElement, null);
            container.removeChild(this.rootElement);
        }
    };
    Portal.prototype.view = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).fragment({}, "");
    };
    Portal.prototype.setStyles = function(attrs) {
        this.rootElement.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).PORTAL, attrs.class);
        this.rootElement.style.cssText = "";
        if (attrs.style) Object.assign(this.rootElement.style, (0, $68113dfa49ce8411$export$8756898546458274)(attrs.style));
    };
    return Portal;
}();


var $f5477a7def05ab0f$var$TransitionManager = /** @class */ function() {
    function TransitionManager() {
        /** Whether transitions are active */ this.isEnabled = true;
    }
    /** Enable all transitions */ TransitionManager.prototype.enable = function() {
        this.isEnabled = true;
    };
    /** Disable all transitions */ TransitionManager.prototype.disable = function() {
        return this.isEnabled = false;
    };
    return TransitionManager;
}();
var $f5477a7def05ab0f$export$2e2bcd8739ae039 = new $f5477a7def05ab0f$var$TransitionManager();


var $e82e0ef2905407c2$var$instanceCounter = 0;
var $e82e0ef2905407c2$export$c6fdb837b070b4ff = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = $e82e0ef2905407c2$var$instanceCounter++;
        _this.shouldRender = false;
        _this.onContainerCreate = function(_a) {
            var dom = _a.dom;
            if (_this.shouldRender) _this.handleOpen(dom);
        };
        _this.onContainerUpdate = function(_a) {
            var dom = _a.dom;
            var isOpen = _this.attrs.isOpen;
            var wasOpen = _this.prevAttrs.isOpen;
            if (isOpen && !wasOpen) _this.handleOpen(dom);
            else if (!isOpen && wasOpen) _this.handleClose();
        };
        _this.handleBackdropMouseDown = function(e) {
            var _a = _this.attrs, closeOnOutsideClick = _a.closeOnOutsideClick, onClose = _a.onClose;
            if (closeOnOutsideClick) (0, $68113dfa49ce8411$export$175e60bb96229ece)(onClose, e);
            else e.redraw = false;
        };
        _this.handleDocumentMouseDown = function(e) {
            var _a = _this.attrs, isOpen = _a.isOpen, onClose = _a.onClose, closeOnOutsideClick = _a.closeOnOutsideClick;
            var contentEl = _this.contentEl;
            var isClickOnOverlay = contentEl && contentEl.contains(e.target);
            if (isOpen && closeOnOutsideClick && !isClickOnOverlay && _this.lastOpened) {
                (0, $68113dfa49ce8411$export$175e60bb96229ece)(onClose, e);
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
            }
        };
        _this.handleKeyDown = function(e) {
            var _a = _this.attrs, closeOnEscapeKey = _a.closeOnEscapeKey, onClose = _a.onClose;
            if (e.which === (0, $d1d62ecbb8386812$export$4b0075e5ea5e1f26).ESCAPE && closeOnEscapeKey && _this.lastOpened) {
                (0, $68113dfa49ce8411$export$175e60bb96229ece)(onClose, e);
                e.preventDefault();
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
            }
        };
        return _this;
    }
    Overlay.prototype.getDefaultAttrs = function() {
        return {
            closeOnEscapeKey: true,
            closeOnOutsideClick: true,
            hasBackdrop: true,
            addToStack: true,
            transitionName: "fade",
            transitionDuration: (0, $f5477a7def05ab0f$export$2e2bcd8739ae039).isEnabled ? 200 : 0
        };
    };
    Overlay.prototype.oninit = function(vnode) {
        _super.prototype.oninit.call(this, vnode);
        this.shouldRender = !!vnode.attrs.isOpen;
    };
    Overlay.prototype.onbeforeupdate = function(vnode, old) {
        var _this = this;
        _super.prototype.onbeforeupdate.call(this, vnode, old);
        var _a = vnode.attrs, isOpen = _a.isOpen, transitionDuration = _a.transitionDuration;
        var wasOpen = old.attrs.isOpen;
        if (isOpen && !wasOpen) {
            this.clearTimeouts();
            this.shouldRender = true;
        } else if (!isOpen && wasOpen) {
            if (transitionDuration > 0) {
                this.handleClose();
                this.setTimeout(function() {
                    _this.shouldRender = false;
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                    _this.handleClosed();
                }, transitionDuration);
            } else {
                this.shouldRender = false;
                this.handleClose();
                this.handleClosed();
            }
        }
    };
    Overlay.prototype.onremove = function() {
        if (this.shouldRender === true) {
            this.handleClose();
            this.handleClosed();
            this.shouldRender = false;
        }
    };
    Overlay.prototype.view = function() {
        var _a = this.attrs, backdropClass = _a.backdropClass, hasBackdrop = _a.hasBackdrop, content = _a.content, inline = _a.inline, className = _a.class, style = _a.style, portalAttrs = _a.portalAttrs;
        if (!this.shouldRender) return null;
        var innerContent = [
            hasBackdrop && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", {
                class: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).OVERLAY_BACKDROP, backdropClass),
                onmousedown: this.handleBackdropMouseDown,
                tabindex: 0
            }),
            content
        ];
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).OVERLAY, inline && (0, $560ae065107eea8c$export$4dbe3495bda74f11).OVERLAY_INLINE, className);
        var container = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", {
            class: classes,
            style: style,
            oncreate: this.onContainerCreate,
            onupdate: this.onContainerUpdate
        }, innerContent);
        return inline ? container : (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $f6cb3d5ec54cf5be$export$602eac185826482c), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, portalAttrs), container);
    };
    Overlay.prototype.handleOpen = function(contentEl) {
        var _a = this.attrs, addToStack = _a.addToStack, closeOnOutsideClick = _a.closeOnOutsideClick, closeOnEscapeKey = _a.closeOnEscapeKey, hasBackdrop = _a.hasBackdrop, onOpened = _a.onOpened, inline = _a.inline;
        this.contentEl = contentEl;
        if (addToStack) Overlay.openStack.push(this.id);
        if (closeOnOutsideClick && !hasBackdrop) document.addEventListener("mousedown", this.handleDocumentMouseDown);
        if (closeOnEscapeKey) document.addEventListener("keydown", this.handleKeyDown);
        this.handleEnterTransition();
        if (hasBackdrop && !inline) {
            document.body.classList.add((0, $560ae065107eea8c$export$4dbe3495bda74f11).OVERLAY_OPEN);
            var bodyHasScrollbar = (0, $68113dfa49ce8411$export$4d450e1748530b6a)(document.body);
            if (bodyHasScrollbar) document.body.style.paddingRight = "".concat((0, $68113dfa49ce8411$export$ace028f8da1a6300)(), "px");
        }
        (0, $68113dfa49ce8411$export$175e60bb96229ece)(onOpened, contentEl);
        this.handleFocus();
    };
    Overlay.prototype.handleClose = function() {
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        document.removeEventListener("keydown", this.handleKeyDown);
        this.handleExitTransition();
    };
    Overlay.prototype.handleClosed = function() {
        var _this = this;
        var _a = this.attrs, restoreFocus = _a.restoreFocus, onClosed = _a.onClosed, hasBackdrop = _a.hasBackdrop, inline = _a.inline;
        if (this.attrs.addToStack) Overlay.openStack = Overlay.openStack.filter(function(id) {
            return id !== _this.id;
        });
        if (this.lastActiveElement && restoreFocus) window.requestAnimationFrame(function() {
            return _this.lastActiveElement.focus();
        });
        if (hasBackdrop && !inline) {
            document.body.classList.remove((0, $560ae065107eea8c$export$4dbe3495bda74f11).OVERLAY_OPEN);
            document.body.style.paddingRight = "";
        }
        (0, $68113dfa49ce8411$export$175e60bb96229ece)(onClosed);
    };
    Overlay.prototype.handleEnterTransition = function() {
        var _a = this.attrs, transitionName = _a.transitionName, transitionDuration = _a.transitionDuration;
        var el = this.contentEl;
        if (el == null || transitionDuration === 0) return;
        el.classList.remove("".concat(transitionName, "-exit"));
        el.classList.remove("".concat(transitionName, "-exit-active"));
        el.classList.add("".concat(transitionName, "-enter"));
        el.scrollTop;
        el.classList.add("".concat(transitionName, "-enter-active"));
    };
    Overlay.prototype.handleExitTransition = function() {
        var _a = this.attrs, transitionDuration = _a.transitionDuration, transitionName = _a.transitionName;
        var el = this.contentEl;
        if (el == null || transitionDuration === 0) return;
        el.classList.remove("".concat(transitionName, "-enter"));
        el.classList.remove("".concat(transitionName, "-enter-active"));
        el.classList.add("".concat(transitionName, "-exit"));
        el.scrollTop;
        el.classList.add("".concat(transitionName, "-exit-active"));
    };
    Overlay.prototype.handleFocus = function() {
        this.lastActiveElement = document.activeElement;
        var contentEl = this.contentEl;
        var _a = this.attrs, isOpen = _a.isOpen, autofocus = _a.autofocus;
        if (!contentEl || !document.activeElement || !isOpen || !autofocus) return;
        window.requestAnimationFrame(function() {
            var isFocusOutsideOverlay = !contentEl.contains(document.activeElement);
            if (isFocusOutsideOverlay) {
                var autofocusEl = contentEl.querySelector("[autofocus]");
                var tabIndexEl = contentEl.querySelector("[tabindex]");
                if (autofocusEl) autofocusEl.focus();
                else if (tabIndexEl) tabIndexEl.focus();
            }
        });
    };
    Object.defineProperty(Overlay.prototype, "lastOpened", {
        get: function() {
            return this.attrs.addToStack ? Overlay.getLastOpened() === this.id : true;
        },
        enumerable: false,
        configurable: true
    });
    Overlay.openStack = [];
    Overlay.getLastOpened = function() {
        return Overlay.openStack[Overlay.openStack.length - 1];
    };
    return Overlay;
}((0, $9da61e952759bc27$export$ca6a3753167de7aa));


var $6696b9e3d0204cd1$export$dd79cf327da3441b = {
    TOP: "top",
    TOP_START: "top-start",
    TOP_END: "top-end",
    BOTTOM: "bottom",
    BOTTOM_START: "bottom-start",
    BOTTOM_END: "bottom-end"
};
var $6696b9e3d0204cd1$export$fb98e3a2a4cd92d7 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Toaster, _super);
    function Toaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toasts = [];
        _this.toastId = 0;
        _this.dismiss = function(key, timedOut) {
            if (timedOut === void 0) timedOut = false;
            var index = _this.toasts.findIndex(function(x) {
                return x.key === key;
            });
            var toast = _this.toasts[index];
            if (toast) {
                (0, $68113dfa49ce8411$export$175e60bb96229ece)(toast.onDismiss, timedOut);
                _this.toasts.splice(index, 1);
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
        };
        return _this;
    }
    Toaster.prototype.getDefaultAttrs = function() {
        return {
            clearOnEscapeKey: true,
            position: "top"
        };
    };
    Toaster.prototype.view = function() {
        var _this = this;
        var _a = this.attrs, className = _a.class, position = _a.position, inline = _a.inline, toasts = _a.toasts, clearOnEscapeKey = _a.clearOnEscapeKey, style = _a.style;
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $560ae065107eea8c$export$4dbe3495bda74f11).TOASTER, "".concat((0, $560ae065107eea8c$export$4dbe3495bda74f11).TOASTER, "-").concat(position), inline && (0, $560ae065107eea8c$export$4dbe3495bda74f11).TOASTER_INLINE, className);
        var renderedToasts = this.isControlled() ? toasts || [] : this.toasts.map(function(toastOptions) {
            return _this.renderToast(toastOptions);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $e82e0ef2905407c2$export$c6fdb837b070b4ff), {
            closeOnEscapeKey: clearOnEscapeKey,
            closeOnOutsideClick: false,
            class: classes,
            content: renderedToasts,
            hasBackdrop: false,
            inline: inline,
            isOpen: renderedToasts.length > 0,
            transitionDuration: 0,
            addToStack: false,
            onClose: function() {
                return _this.clear();
            },
            style: style
        });
    };
    Toaster.prototype.onremove = function() {
        this.clear();
    };
    Toaster.prototype.show = function(attrs) {
        var toastOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, attrs), {
            key: "cui-toast-".concat(this.toastId++)
        });
        this.toasts.push(toastOptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
        return toastOptions.key;
    };
    Toaster.prototype.update = function(key, attrs) {
        var index = this.toasts.findIndex(function(x) {
            return x.key === key;
        });
        this.toasts[index] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.toasts[index]), attrs);
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    };
    Toaster.prototype.clear = function() {
        this.toasts.map(function(x) {
            return (0, $68113dfa49ce8411$export$175e60bb96229ece)(x.onDismiss, false);
        });
        this.toasts.length = 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    };
    Toaster.prototype.getToasts = function() {
        return this.toasts;
    };
    Toaster.prototype.renderToast = function(attrs) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $c198384e79e1bb6f$export$8d8dc7d5f743331b), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, attrs), {
            onDismiss: this.dismiss
        }));
    };
    Toaster.prototype.isControlled = function() {
        return this.attrs.toasts != null;
    };
    return Toaster;
}((0, $9da61e952759bc27$export$ca6a3753167de7aa));





const $4412a4d0220473a9$var$BASE_URL = "https://api.sjef.app/v1/kitchenscreen";
const $4412a4d0220473a9$export$d0204b1ddc8ee140 = {
    get: async (endpoint, authenticated = true)=>{
        return await $4412a4d0220473a9$export$d0204b1ddc8ee140.request("GET", endpoint, {}, authenticated);
    },
    post: async (endpoint, data = {}, authenticated = true)=>{
        return await $4412a4d0220473a9$export$d0204b1ddc8ee140.request("POST", endpoint, data, authenticated);
    },
    request: async (method, endpoint, data = {}, authenticated = true)=>{
        if (authenticated && !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token) {
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("No token available. User is logged out. Request not sent.");
            return;
        }
        const url = `${$4412a4d0220473a9$var$BASE_URL}/${endpoint}`;
        // console.log(url);
        try {
            let headers = {};
            if (authenticated) headers = {
                Authorization: `Bearer ${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token}`
            };
            const response = await (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).request({
                method: method,
                url: url,
                headers: headers,
                body: data
            });
            return {
                success: true,
                data: response || {}
            };
        } catch (error) {
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Error fetching data:" + error);
            let errorMessage = "An error occurred";
            if (error.code === 401) errorMessage = "Unauthorized. Please log in.";
            if (error.code === 403) errorMessage = "Forbidden. You do not have permission to access this resource.";
            if (error.code === 404) errorMessage = "Resource not found.";
            if (error.code === 422) errorMessage = "Invalid data";
            if (error.code === 500) errorMessage = "Server error";
            return {
                success: false,
                error: errorMessage,
                errorCode: error.code || 0
            };
        }
    },
    handleError: (code, message)=>{
        alert(`${code}: ${message || "Something went wrong"}`);
        return false;
    }
};


parcelRequire("45fvw");
const $03f71c0d7b74323f$export$372053738acac6fe = {
    moved: async (id, orderJobLeftOfNewPosition, orderJobRightOfNewPosition)=>{
        try {
            // Обчислити нову позицію
            const position = Math.round((orderJobLeftOfNewPosition + orderJobRightOfNewPosition) / 2);
            // console.log('Moved Item ID:', id);
            // console.log('Calculated new position:', position);
            // console.log('Left Position:', orderJobLeftOfNewPosition);
            // console.log('Right Position:', orderJobRightOfNewPosition);
            const payload = {
                position: position
            };
            const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post(`orderjobs/${id}/position`, payload);
        // console.log(`Moved order with id ${id} to new position ${position}`);
        } catch (error) {
            console.error("Error in moved function:", error);
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Error in moved function: " + error.message);
        }
    },
    // Implementation of getOrders function to fetch open orders
    getOrders: async (status)=>{
        const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).get(`orderjobs?status=${status}`);
        if (!response.ok) throw new Error("Failed to fetch orders.");
        return await response.json();
    },
    // Other methods like toStatus, toStatusBatch, etc. remain unchanged...
    get: async (type)=>{
        if (!type) return;
        try {
            const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).get(`orderjobs/${type}`);
            if (response.error) {
                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("An error occurred while trying to get token");
                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("A0020", response.error);
                return response;
            }
            const orderData = await response.data.data;
            switch(type){
                case "recentready":
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.recentReady = orderData;
                    break;
                case "parked":
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.parked = orderData;
                    break;
                case "open":
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open = orderData;
                    break;
                case "ready":
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.ready = orderData;
                    break;
                default:
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Unknown order type:" + type);
            }
            return {
                success: true,
                data: orderData
            };
        } catch (error) {
            (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0021", error);
            return {
                success: false,
                error: "error occurred"
            };
        }
    },
    toStatus: async (fromStatus, toStatus, id)=>{
        try {
            const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post(`orderjobs/${id}/${toStatus}`);
            // console.log(fromStatus, toStatus, id, response);
            if (response.error) {
                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("An error occurred");
                (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0030", response.error);
                return response;
            }
            const orderIndex = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus].findIndex((order)=>order.id === id);
            const order = response.data.data;
            if (orderIndex > -1) {
                if (toStatus === "prepare") (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus][orderIndex] = order;
                if (toStatus === "ready") {
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus].splice(orderIndex, 1);
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders["ready"].push(order);
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders["recentready"].push(order);
                }
                if (toStatus === "park") {
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus].splice(orderIndex, 1);
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders["parked"].push(order);
                }
                if (toStatus === "serve") (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus].splice(orderIndex, 1);
                if (toStatus === "reopen") {
                    if (fromStatus === "ready" || fromStatus === "served") fromStatus = "recentready";
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[fromStatus].splice(orderIndex, 1);
                    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders["open"].push(order);
                }
            }
            return {
                success: true
            };
        } catch (error) {
            console.log(error);
            (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0031", error);
            // appState.toast(`Error making authenticated request for ${endpoint} action:` + error);
            return error;
        }
    },
    toStatusBatch: async (status, ids = [])=>{
        try {
            if (ids.length === 0) return;
            const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post(`orderjobs/batch/${status}`, {
                ids: ids
            });
            if (response.error) {
                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("An error occurred");
                (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0040", response.error);
                return response;
            }
            await (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.reloadOrders();
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0041", error);
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast(`Error making authenticated request for ${endpoint} action:` + error);
            return error;
        }
    },
    makeTimestampPostRequest: async (id, timestamp)=>{
        try {
            return await $03f71c0d7b74323f$export$372053738acac6fe.postOrderAction("timestamp", id, {
                timestamp: timestamp
            });
        } catch (error) {
            (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0050", error);
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Error making timestamp post request:" + error);
            throw error;
        }
    }
};




const $29dbb0e1f0b9a492$export$8182fa24c18d6618 = {
    playAudio: ()=>{
        if (!(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open) return;
        let notification = document.getElementById("notificationSound");
        const currentOpen = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open.length;
        const previousOpen = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.previousOpen || 0;
        if (typeof currentOpen !== "undefined" && typeof previousOpen !== "undefined" && currentOpen > previousOpen) notification.play();
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.previousOpen = currentOpen;
    }
};


const $7ff2ea747eb3b943$export$b72e390a9ebe1648 = {
    token: localStorage.getItem("token") || null,
    terminalCode: localStorage.getItem("terminalCode") || null,
    isMobile: false,
    language: "en",
    darkMode: true,
    intervalId: null,
    interval: 10000,
    options: [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60
    ].map(String),
    action: [
        "serve",
        "serveAndPrint"
    ],
    selectedAction: "serve",
    selectedOption: 10,
    tabClass: [],
    data: {
        orders: {
            open: [],
            parked: [],
            ready: [],
            recentReady: []
        },
        responseOrder: [],
        selectedOrders: [],
        selectedServeOrders: [],
        previousOpen: []
    },
    toast: (msg, opts)=>{
        let options = {
            key: Date.now(),
            // intent: 'primary',
            // size: 'default',
            timeout: 1500,
            message: msg,
            clearOnEscapeKey: true
        };
        options = Object.assign(options, opts);
        const toasts = $7ff2ea747eb3b943$export$b72e390a9ebe1648.toaster.getToasts(options.key);
        if (toasts.length) {
            $7ff2ea747eb3b943$export$b72e390a9ebe1648.toaster.update(options.key, options);
            $7ff2ea747eb3b943$export$b72e390a9ebe1648.toaster.show(options);
        } else $7ff2ea747eb3b943$export$b72e390a9ebe1648.toaster.show(options);
    },
    toaster: new (0, $6696b9e3d0204cd1$export$fb98e3a2a4cd92d7)(),
    restore: (key, defaultValue = "")=>{
        let val = localStorage.getItem("dash:" + key);
        if (!val) return defaultValue;
        try {
            val = JSON.parse(val);
            return val;
        } catch (err) {
            return val;
        }
    },
    store: (key, val)=>{
        if (val === null) localStorage.removeItem(`dash:${key}`);
        else {
            val = JSON.stringify(val);
            localStorage.setItem(`dash:${key}`, val);
        }
    },
    actions: {
        async init (orderTypes = [
            "open",
            "parked",
            "recentready",
            "ready"
        ]) {
            // Clear any existing interval
            if ($7ff2ea747eb3b943$export$b72e390a9ebe1648.intervalId) clearInterval($7ff2ea747eb3b943$export$b72e390a9ebe1648.intervalId);
            if (!$7ff2ea747eb3b943$export$b72e390a9ebe1648.interval) $7ff2ea747eb3b943$export$b72e390a9ebe1648.interval = 10000;
            localStorage.getItem("selectedOption") && ($7ff2ea747eb3b943$export$b72e390a9ebe1648.selectedOption = localStorage.getItem("selectedOption"));
            localStorage.getItem("selectedAction") && ($7ff2ea747eb3b943$export$b72e390a9ebe1648.selectedAction = localStorage.getItem("selectedAction"));
            // Initialize the orders
            await $7ff2ea747eb3b943$export$b72e390a9ebe1648.actions.reloadOrders(orderTypes);
            // Set interval for reloading orders
            $7ff2ea747eb3b943$export$b72e390a9ebe1648.intervalId = setInterval(()=>$7ff2ea747eb3b943$export$b72e390a9ebe1648.actions.reloadOrders(orderTypes), $7ff2ea747eb3b943$export$b72e390a9ebe1648.interval);
        },
        reloadOrders: async (orderTypes = [
            "open",
            "parked",
            "recentready",
            "ready"
        ])=>{
            const promises = orderTypes.map((type)=>(0, $03f71c0d7b74323f$export$372053738acac6fe).get(type));
            const responses = await Promise.all(promises);
            (0, $29dbb0e1f0b9a492$export$8182fa24c18d6618).playAudio();
            responses.forEach((response, index)=>{
                if (response) {
                    if (orderTypes[index] === "open" && response.data && response.data.length > $7ff2ea747eb3b943$export$b72e390a9ebe1648.data.orders.open.length) console.log("new one");
                    $7ff2ea747eb3b943$export$b72e390a9ebe1648.data.orders[orderTypes[index]] = [];
                    $7ff2ea747eb3b943$export$b72e390a9ebe1648.data.orders[orderTypes[index]] = response.data;
                }
            });
        }
    }
};
window.appState = $7ff2ea747eb3b943$export$b72e390a9ebe1648;


class $2821a39abdc9106d$export$86fbec116b87613f {
    view(vnode) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("main", {
                class: vnode.attrs.class
            }, vnode.children),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toaster)
        ];
    }
}






const $138c3acec8d52e88$export$62819fe1bf99c5f7 = {
    login: async (clientCode, terminalCode, terminalPincode)=>{
        try {
            const payload = {
                client_code: clientCode,
                terminal_code: terminalCode,
                terminal_pincode: terminalPincode
            };
            const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post("auth/login", payload, false);
            if (response.error) {
                (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0010", response.error);
                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("An error occurred while trying to get token");
                return response;
            }
            // TODO: move to appStateService
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token = response.data.token;
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).terminalCode = response.data.terminal_code;
            localStorage.setItem("token", (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token);
            localStorage.setItem("terminalCode", response.data.terminal_code);
            return response;
        } catch (error) {
            console.error(error);
            return {
                success: false,
                error: "error occurred"
            };
        }
    },
    logout: async ()=>{
        try {
            if ((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token) {
                const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post("logout");
                if (response.error) {
                    console.error(response.error);
                    (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0011", response.error);
                }
            }
            // TODO: move to appStateService
            $138c3acec8d52e88$export$62819fe1bf99c5f7.clearAppState();
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/login");
        } catch (error) {
            console.error("Error logging out:", error);
        }
    },
    clearAppState: ()=>{
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token = null;
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).interval = null;
        clearInterval((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).intervalId);
        localStorage.removeItem("token");
    }
};


const $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $673ff3dfc4a496de$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
}
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function $673ff3dfc4a496de$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $673ff3dfc4a496de$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $673ff3dfc4a496de$var$intlVersions = [
    "v4"
];
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    const rules = {};
    $673ff3dfc4a496de$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $673ff3dfc4a496de$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($673ff3dfc4a496de$var$getCleanedCode(code === "dev" ? "en" : code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$673ff3dfc4a496de$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || "{{";
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || "}}";
        this.formatSeparator = formatSeparator || ",";
        this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
        this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(":");
                    const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === "false") formatOptions[trimmedKey] = false;
                    if (val === "true") formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $eb9e67c255c9ebf8$exports = {};
$eb9e67c255c9ebf8$exports = JSON.parse('{"lang":{"status":{"open":"Open","serve":"Serve","served":"Served","ready":"Ready","prepare":"Prepare","inpreparation":"Prepare","parked":"Parked","welcome":"Welcome","in preparation":"In preparation"},"buttons":{"serve":"Serve","served":"Served","open":"Open","ready":"Ready","prepare":"Prepare","login":"Login","logout":"Logout","reopen":"Reopen","close":"Close","yes_prepare":"Yes, prepare","yes_ready":"Yes, ready","parked":"Parked","recent":"Recent","yes_serve":"Yes, serve","split":"Split"},"sorting":{"default":"Default","priority":"Filter by priority","alphabetical":"Alphabetical order","quantity":"Quantity","entryOrder":"Entry order"},"options":{"serve":"Serve","serveAndPrint":"Serve and Print"},"headlines":{"speak_with_server":"Server","order_screen":"Customer mode","serve_screen":"Serve mode","kitchen_screen":"Kitchen mode","make_your_choice":"Make your choice","select_language":"Select language","in_preparation":"In preparation","parked":"Parked","open":"Open","ready":"Ready","recentready":"Recent","orders_loaded_at":"Orders loaded at","ready_to_serve":"Ready to serve","consolidated_orders":"Consolidated orders","open_orders":"Open orders","parked_orders":"Parked orders","recently_complated_orders":"Recently ready orders","login_to_your_kds":"Login to your KDS","prepare_selected_orders":"Prepare selected orders","all_selected_orders":"Are you sure to prepare all selected orders","ready_selected":"Ready selected orders","all_selected_orders_to_ready":"Are you sure to set all selected orders to ready","serve_selected":"Serve selected orders","all_selected_orders_to_serve":"Are you sure to set all selected orders to serve"},"fields":{"bedrijfs_code":"Company code","terminal_code":"Terminal code","pincode":"Pincode"},"modal":{"batchAction":{"prepare":{"title":"Prepare Orders","buttonLabel":"prepare","text":"Are you sure to prepare all selected orders"},"ready":{"title":"Ready Orders","buttonLabel":"ready","text":"Are you sure to set all selected orders to ready"},"serve":{"title":"Serve Orders","buttonLabel":"serve","text":"Are you sure to set all selected orders to serve"},"settings":{"makeTimer":"Set time setting","forOrder":"for All Open Order","printChoice":"Set print setting","yourPrintChoice":"you can choice just \'serve\'or \'serve and print\' "}}}}}');


var $b22c8e1e09a6ba9a$exports = {};
$b22c8e1e09a6ba9a$exports = JSON.parse('{"lang":{"status":{"open":"Open","serve":"Serveren","ready":"Klaar","prepare":"Voorbereiden","parked":"Geparkeerd","welcome":"Welkom","in preparation":"In voorbereiding"},"buttons":{"serve":"Serveren","served":"Geserveerd","open":"Open","ready":"Klaar","prepare":"Voorbereiden","login":"Inloggen","logout":"Uitloggen","reopen":"Heropenen","close":"Sluiten","yes_prepare":"Ja, voorbereiden","yes_ready":"Ja, klaar","parked":"Geparkeerd","recent":"Recent","yes_serve":"Ja, serveren"},"sorting":{"default":"Standaard","priority":"Filter op prioriteit","alphabetical":"Alfabetisch","quantity":"Aantal","entryOrder":"Volgorde van binnenkomst"},"options":{"serve":"Bedienen","serveAndPrint":"Bedienen en afdrukken"},"headlines":{"speak_with_server":"Server","order_screen":"Klantenmodus","serve_screen":"Serveermodus","kitchen_screen":"Keukenmodus","make_your_choice":"Maak uw keuze","select_language":"Selecteer taal","in_preparation":"In voorbereiding","parked":"Geparkeerd","open":"Open","ready":"Klaar","recentready":"Recent","orders_loaded_at":"Bestellingen geladen om","ready_to_serve":"Klaar om te serveren","open_orders":"Open bestellingen","consolidated_orders":"Consolidated orders","parked_orders":"Geparkeerde bestellingen","recently_complated_orders":"Onlangs voltooide bestellingen","login_to_your_kds":"Log in op uw KDS","prepare_selected_orders":"Bereid geselecteerde bestellingen voor","all_selected_orders":"Weet u zeker dat u alle geselecteerde bestellingen wilt voorbereiden","ready_selected":"Geselecteerde bestellingen klaar","all_selected_orders_to_ready":"Weet u zeker dat u alle geselecteerde bestellingen als klaar wilt markeren","serve_selected":"Geselecteerde bestellingen serveren","all_selected_orders_to_serve":"Weet u zeker dat u alle geselecteerde bestellingen wilt serveren"},"fields":{"bedrijfs_code":"Bedrijfscode","terminal_code":"Terminalcode","pincode":"Pincode"},"modal":{"batchAction":{"prepare":{"title":"Bestellingen voorbereiden","buttonLabel":"voorbereiden","text":"Weet u zeker dat u alle geselecteerde bestellingen wilt voorbereiden"},"ready":{"title":"Bestellingen klaar","buttonLabel":"klaar","text":"Weet u zeker dat u alle geselecteerde bestellingen als klaar wilt markeren"},"serve":{"title":"Bestellingen serveren","buttonLabel":"serveren","text":"Weet u zeker dat u alle geselecteerde bestellingen wilt serveren"}}}}}');


var $9b6229c771bb76ca$exports = {};
$9b6229c771bb76ca$exports = JSON.parse('{"lang":{"status":{"open":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E","serve":"\u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438","ready":"\u0413\u043E\u0442\u043E\u0432\u043E","prepare":"\u0413\u043E\u0442\u0443\u0432\u0430\u0442\u0438","parked":"\u041F\u0440\u0438\u043F\u0430\u0440\u043A\u043E\u0432\u0430\u043D\u043E","welcome":"\u041B\u0430\u0441\u043A\u0430\u0432\u043E \u043F\u0440\u043E\u0441\u0438\u043C\u043E","in preparation":"\u0413\u043E\u0442\u0443\u0454\u0442\u044C\u0441\u044F"},"buttons":{"serve":"\u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438","open":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438","ready":"\u0413\u043E\u0442\u043E\u0432\u043E","prepare":"\u0413\u043E\u0442\u0443\u0432\u0430\u0442\u0438","login":"\u0423\u0432\u0456\u0439\u0442\u0438","logout":"\u0412\u0438\u0439\u0442\u0438","reopen":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0437\u043D\u043E\u0432\u0443","close":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","yes_prepare":"\u0422\u0430\u043A, \u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438","yes_ready":"\u0422\u0430\u043A, \u0433\u043E\u0442\u043E\u0432\u043E","parked":"\u041F\u0440\u0438\u043F\u0430\u0440\u043A\u043E\u0432\u0430\u043D\u043E","recent":"\u041D\u0435\u0449\u043E\u0434\u0430\u0432\u043D\u043E","yes_serve":"\u0422\u0430\u043A, \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438"},"sorting":{"default":"\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C","priority":"\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0430 \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442\u043E\u043C","alphabetical":"\u0410\u043B\u0444\u0430\u0432\u0456\u0442\u043D\u0438\u0439 \u043F\u043E\u0440\u044F\u0434\u043E\u043A","quantity":"\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C","entryOrder":"\u041F\u043E\u0440\u044F\u0434\u043E\u043A \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F"},"options":{"serve":"\u041F\u043E\u0434\u0430\u0432\u0430\u0442\u0438","serveAndPrint":"\u041F\u043E\u0434\u0430\u0432\u0430\u0442\u0438 \u0442\u0430 \u0434\u0440\u0443\u043A\u0443\u0432\u0430\u0442\u0438"},"headlines":{"speak_with_server":"\u0421\u0435\u0440\u0432\u0435\u0440","order_screen":"\u0420\u0435\u0436\u0438\u043C \u043A\u043B\u0456\u0454\u043D\u0442\u0430","serve_screen":"\u0420\u0435\u0436\u0438\u043C \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F","kitchen_screen":"\u041A\u0443\u0445\u043E\u043D\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C","make_your_choice":"\u0417\u0440\u043E\u0431\u0456\u0442\u044C \u0441\u0432\u0456\u0439 \u0432\u0438\u0431\u0456\u0440","select_language":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u0443","in_preparation":"\u0413\u043E\u0442\u0443\u0454\u0442\u044C\u0441\u044F","parked":"\u041F\u0440\u0438\u043F\u0430\u0440\u043A\u043E\u0432\u0430\u043D\u043E","open":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E","ready":"\u0413\u043E\u0442\u043E\u0432\u043E","recentready":"\u041D\u0435\u0449\u043E\u0434\u0430\u0432\u043D\u043E","orders_loaded_at":"\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E \u043E","ready_to_serve":"\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043E \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F","open_orders":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","parked_orders":"\u041F\u0440\u0438\u043F\u0430\u0440\u043A\u043E\u0432\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","recently_complated_orders":"\u041D\u0435\u0449\u043E\u0434\u0430\u0432\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","login_to_your_kds":"\u0423\u0432\u0456\u0439\u0434\u0456\u0442\u044C \u0443 \u0432\u0430\u0448 KDS","prepare_selected_orders":"\u0413\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","all_selected_orders":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","ready_selected":"\u0412\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0433\u043E\u0442\u043E\u0432\u0456","all_selected_orders_to_ready":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u044F\u043A \u0433\u043E\u0442\u043E\u0432\u0456","serve_selected":"\u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","all_selected_orders_to_serve":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F"},"fields":{"bedrijfs_code":"\u041A\u043E\u0434 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457","terminal_code":"\u041A\u043E\u0434 \u0442\u0435\u0440\u043C\u0456\u043D\u0430\u043B\u0443","pincode":"PIN-\u043A\u043E\u0434"},"modal":{"batchAction":{"prepare":{"title":"\u0413\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","buttonLabel":"\u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438","text":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F"},"ready":{"title":"\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0433\u043E\u0442\u043E\u0432\u0456","buttonLabel":"\u0433\u043E\u0442\u043E\u0432\u043E","text":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u044F\u043A \u0433\u043E\u0442\u043E\u0432\u0456"},"serve":{"title":"\u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F","buttonLabel":"\u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438","text":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F"}}}}}');


var $612e64f0976e436f$exports = {};
$612e64f0976e436f$exports = JSON.parse('{"lang":{"status":{"open":"Ouvert","serve":"Servir","ready":"Pr\xeat","prepare":"Pr\xe9parer","parked":"En attente","welcome":"Bienvenue","in preparation":"En pr\xe9paration"},"buttons":{"serve":"Servir","served":"Servi","open":"Ouvrir","ready":"Pr\xeat","prepare":"Pr\xe9parer","login":"Connexion","logout":"D\xe9connexion","reopen":"Rouvrir","close":"Fermer","yes_prepare":"Oui, pr\xe9parer","yes_ready":"Oui, pr\xeat","parked":"En attente","recent":"R\xe9cent","yes_serve":"Oui, servir"},"sorting":{"default":"Par d\xe9faut","priority":"Filtrer par priorit\xe9","alphabetical":"Ordre alphab\xe9tique","quantity":"Quantit\xe9","entryOrder":"Ordre d\'entr\xe9e"},"options":{"serve":"Servir","serveAndPrint":"Servir et imprimer"},"headlines":{"speak_with_server":"Serveur","order_screen":"Mode client","serve_screen":"Mode service","kitchen_screen":"Mode cuisine","make_your_choice":"Faites votre choix","select_language":"S\xe9lectionnez la langue","in_preparation":"En pr\xe9paration","parked":"En attente","open":"Ouvert","ready":"Pr\xeat","recentready":"R\xe9cent","orders_loaded_at":"Commandes charg\xe9es \xe0","ready_to_serve":"Pr\xeat \xe0 servir","open_orders":"Commandes ouvertes","parked_orders":"Commandes en attente","consolidated_orders":"Commandes consolid\xe9es","recently_complated_orders":"Commandes r\xe9cemment pr\xeates","login_to_your_kds":"Connectez-vous \xe0 votre KDS","prepare_selected_orders":"Pr\xe9parer les commandes s\xe9lectionn\xe9es","all_selected_orders":"\xcates-vous s\xfbr de vouloir pr\xe9parer toutes les commandes s\xe9lectionn\xe9es","ready_selected":"Commandes s\xe9lectionn\xe9es pr\xeates","all_selected_orders_to_ready":"\xcates-vous s\xfbr de vouloir marquer toutes les commandes s\xe9lectionn\xe9es comme pr\xeates","serve_selected":"Servir les commandes s\xe9lectionn\xe9es","all_selected_orders_to_serve":"\xcates-vous s\xfbr de vouloir servir toutes les commandes s\xe9lectionn\xe9es"},"fields":{"bedrijfs_code":"Code de l\'entreprise","terminal_code":"Code terminal","pincode":"Code PIN"},"modal":{"batchAction":{"prepare":{"title":"Pr\xe9parer les commandes","buttonLabel":"pr\xe9parer","text":"\xcates-vous s\xfbr de vouloir pr\xe9parer toutes les commandes s\xe9lectionn\xe9es"},"ready":{"title":"Commandes pr\xeates","buttonLabel":"pr\xeat","text":"\xcates-vous s\xfbr de vouloir marquer toutes les commandes s\xe9lectionn\xe9es comme pr\xeates"},"serve":{"title":"Servir les commandes","buttonLabel":"servir","text":"\xcates-vous s\xfbr de vouloir servir toutes les commandes s\xe9lectionn\xe9es"}}}}}');


var $530e24a15dfd08f8$exports = {};
$530e24a15dfd08f8$exports = JSON.parse('{"lang":{"status":{"open":"Offen","serve":"Servieren","ready":"Bereit","prepare":"Vorbereiten","parked":"Geparkt","welcome":"Willkommen","in preparation":"In Vorbereitung"},"buttons":{"serve":"Servieren","served":"Serviert","open":"\xd6ffnen","ready":"Bereit","prepare":"Vorbereiten","login":"Anmelden","logout":"Abmelden","reopen":"Wieder \xf6ffnen","close":"Schlie\xdfen","yes_prepare":"Ja, vorbereiten","yes_ready":"Ja, bereit","parked":"Geparkt","recent":"K\xfcrzlich","yes_serve":"Ja, servieren"},"sorting":{"default":"Standard","priority":"Nach Priorit\xe4t filtern","alphabetical":"Alphabetische Reihenfolge","quantity":"Menge","entryOrder":"Eingangsreihenfolge"},"options":{"serve":"Bedienen","serveAndPrint":"Bedienen und drucken"},"headlines":{"speak_with_server":"Server","order_screen":"Kundenmodus","serve_screen":"Serviermodus","kitchen_screen":"K\xfcchenmodus","make_your_choice":"Treffen Sie Ihre Wahl","select_language":"Sprache ausw\xe4hlen","in_preparation":"In Vorbereitung","parked":"Geparkt","open":"Offen","ready":"Bereit","recentready":"K\xfcrzlich","orders_loaded_at":"Bestellungen geladen um","ready_to_serve":"Bereit zu servieren","open_orders":"Offene Bestellungen","parked_orders":"Geparkte Bestellungen","consolidated_orders":"Consolidated Bestellungen","recently_complated_orders":"K\xfcrzlich fertige Bestellungen","login_to_your_kds":"Anmelden zu Ihrem KDS","prepare_selected_orders":"Ausgew\xe4hlte Bestellungen vorbereiten","all_selected_orders":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen vorbereiten m\xf6chten","ready_selected":"Ausgew\xe4hlte Bestellungen bereit","all_selected_orders_to_ready":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen als bereit markieren m\xf6chten","serve_selected":"Ausgew\xe4hlte Bestellungen servieren","all_selected_orders_to_serve":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen servieren m\xf6chten"},"fields":{"bedrijfs_code":"Firmencode","terminal_code":"Terminalcode","pincode":"PIN-Code"},"modal":{"batchAction":{"prepare":{"title":"Bestellungen vorbereiten","buttonLabel":"vorbereiten","text":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen vorbereiten m\xf6chten"},"ready":{"title":"Bestellungen bereit","buttonLabel":"bereit","text":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen als bereit markieren m\xf6chten"},"serve":{"title":"Bestellungen servieren","buttonLabel":"servieren","text":"Sind Sie sicher, dass Sie alle ausgew\xe4hlten Bestellungen servieren m\xf6chten"}}}}}');


var $25ced0d7b08a00c2$exports = {};
$25ced0d7b08a00c2$exports = JSON.parse('{"lang":{"status":{"open":"Abierto","serve":"Servir","ready":"Listo","prepare":"Preparar","parked":"Estacionado","welcome":"Bienvenido","in preparation":"En preparaci\xf3n"},"buttons":{"serve":"Servir","served":"Servido","open":"Abrir","ready":"Listo","prepare":"Preparar","login":"Iniciar sesi\xf3n","logout":"Cerrar sesi\xf3n","reopen":"Reabrir","close":"Cerrar","yes_prepare":"S\xed, preparar","yes_ready":"S\xed, listo","parked":"Estacionado","recent":"Reciente","yes_serve":"S\xed, servir"},"sorting":{"default":"Predeterminado","priority":"Filtrar por prioridad","alphabetical":"Orden alfab\xe9tico","quantity":"Cantidad","entryOrder":"Orden de entrada"},"options":{"serve":"Servir","serveAndPrint":"Servir e imprimir"},"headlines":{"speak_with_server":"Servidor","order_screen":"Modo cliente","serve_screen":"Modo servir","kitchen_screen":"Modo cocina","make_your_choice":"Haga su elecci\xf3n","select_language":"Seleccionar idioma","in_preparation":"En preparaci\xf3n","parked":"Estacionado","open":"Abierto","ready":"Listo","recentready":"Reciente","orders_loaded_at":"Pedidos cargados a las","ready_to_serve":"Listo para servir","open_orders":"Pedidos abiertos","parked_orders":"Pedidos estacionados","recently_complated_orders":"Pedidos recientemente listos","login_to_your_kds":"Iniciar sesi\xf3n en su KDS","prepare_selected_orders":"Preparar pedidos seleccionados","all_selected_orders":"\xbfEst\xe1 seguro de que desea preparar todos los pedidos seleccionados?","ready_selected":"Pedidos seleccionados listos","all_selected_orders_to_ready":"\xbfEst\xe1 seguro de que desea marcar todos los pedidos seleccionados como listos?","serve_selected":"Servir pedidos seleccionados","all_selected_orders_to_serve":"\xbfEst\xe1 seguro de que desea servir todos los pedidos seleccionados?"},"fields":{"bedrijfs_code":"C\xf3digo de la empresa","terminal_code":"C\xf3digo del terminal","pincode":"C\xf3digo PIN"},"modal":{"batchAction":{"prepare":{"title":"Preparar pedidos","buttonLabel":"preparar","text":"\xbfEst\xe1 seguro de que desea preparar todos los pedidos seleccionados?"},"ready":{"title":"Pedidos listos","buttonLabel":"listo","text":"\xbfEst\xe1 seguro de que desea marcar todos los pedidos seleccionados como listos?"},"serve":{"title":"Servir pedidos","buttonLabel":"servir","text":"\xbfEst\xe1 seguro de que desea servir todos los pedidos seleccionados?"}}}}}');



const $cea20f86969d180a$export$686dd0e008bf9f30 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($eb9e67c255c9ebf8$exports)))
    },
    nl: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($b22c8e1e09a6ba9a$exports)))
    },
    ua: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($9b6229c771bb76ca$exports)))
    },
    fr: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($612e64f0976e436f$exports)))
    },
    de: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($530e24a15dfd08f8$exports)))
    },
    es: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($25ced0d7b08a00c2$exports)))
    }
};
const $cea20f86969d180a$export$e4c8a1ed14feeb6c = async ()=>{
    await (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).init({
        lng: "en",
        fallbackLng: [
            "nl",
            "fr",
            "de",
            "es",
            "ua"
        ],
        resources: $cea20f86969d180a$export$686dd0e008bf9f30,
        nsSeparator: false,
        keySeparator: ".",
        initImmediate: false,
        interpolation: {
            escapeValue: false,
            skipOnVariables: false
        }
    });
};
// Event listener for i18next initialization
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).on("initialized", ()=>{
    const language = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).restore("language") ?? "en";
    $cea20f86969d180a$export$bd4eb51dd4569d89(language);
});
const $cea20f86969d180a$export$bd4eb51dd4569d89 = (lang)=>{
    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).language = lang;
    (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).changeLanguage(lang, (error)=>{
        if (error) (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast(error);
    });
    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).store("language", lang);
    setTimeout(()=>{
        document.body.setAttribute("lang", lang);
    }, 300);
};
const $cea20f86969d180a$export$324a75438e87a537 = ()=>{
    return (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language;
};
const $cea20f86969d180a$export$e1a0bf30965c1cae = (key, options)=>(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t(key, options);
const $cea20f86969d180a$export$a53db664bc9bd274 = $cea20f86969d180a$export$e1a0bf30965c1cae;



class $7df76c2b605556a9$export$21a94553ffa41578 {
    constructor(){
        this.client_code = "";
        this.terminal_code = "";
        this.terminal_pincode = "";
    }
    // oninit() {
    //     console.log(i18next);
    // }
    submit = async ()=>{
        try {
            // Perform login
            const result = await (0, $138c3acec8d52e88$export$62819fe1bf99c5f7).login(this.client_code, this.terminal_code, this.terminal_pincode);
            // console.log(result);
            if (result.error) return (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast(result.error);
            await (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.init();
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/kdsMode");
        } catch (error) {
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Error during login:", error);
        }
    };
    handleInput(event, field) {
        this[field] = event.target.value;
    }
    view() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".signin-container", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".signin-heading", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.login_to_your_kds"))
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("form", {
                onsubmit: (event)=>{
                    event.preventDefault();
                    this.submit();
                }
            }, [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".form-fields", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("input.client-code.input-field[type=text][placeholder=" + (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.fields.bedrijfs_code") + "][autofocus][required]", {
                        value: this.client_code,
                        oninput: (event)=>this.handleInput(event, "client_code")
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("input.terminal-code.input-field[type=text][placeholder=" + (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.fields.terminal_code") + "][required]", {
                        value: this.terminal_code,
                        oninput: (event)=>this.handleInput(event, "terminal_code")
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("input.pincode.input-field[type=password][placeholder=" + (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.fields.pincode") + "][required]", {
                        value: this.terminal_pincode,
                        oninput: (event)=>this.handleInput(event, "terminal_pincode")
                    })
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".signin-button", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.submit-button[type=submit]", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.login"))
                ])
            ])
        ]);
    }
}
const $7df76c2b605556a9$var$main = document.getElementById("main");
(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount($7df76c2b605556a9$var$main, $7df76c2b605556a9$export$21a94553ffa41578);








class $c1a523cf6a0c6ba4$export$e835999d8e9cf347 {
    // Method to toggle dark mode
    toggle() {
        // Toggle the darkMode property in appState
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).darkMode = !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).darkMode;
        // Set the document's class name based on the new darkMode value
        document.documentElement.className = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).darkMode ? "theme-dark" : "theme-light";
    }
    // Render method for the component
    view(vnode) {
        // Render the Mithril virtual DOM structure for the switch
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("label.switch", [
            // Input checkbox for toggling dark mode
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("input[type=checkbox]", {
                onclick: ()=>this.toggle(),
                id: "slider"
            }),
            // Span element for the slider
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span.slider.round")
        ]);
    }
}





class $76d75d21365cd7a1$export$fa43c961ec463ef0 {
    isOpen = false;
    // Method to toggle the menu's visibility
    toggleMenu() {
        this.isOpen = !this.isOpen;
    }
    // Method to set the language
    setLanguage(lang) {
        (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).changeLanguage(lang, (error)=>{
            if (error) (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast(error);
        });
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).language = lang;
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).store("language", lang);
        this.toggleMenu();
    }
    view() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalLanguage", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".language-menu-container", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.menu-toggle", {
                onclick: ()=>this.toggleMenu()
            }, (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).language),
            this.isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul.language-menu", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("en")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 -4 28 28",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("g", {
                            "clip-path": "url(#clip0_503_2952)"
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("rect", {
                                width: "28",
                                height: "20",
                                rx: "2",
                                fill: "white"
                            }),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("mask", {
                                id: "mask0_503_2952",
                                style: {
                                    maskType: "alpha"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "0",
                                width: "28",
                                height: "20"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("rect", {
                                    width: "28",
                                    height: "20",
                                    rx: "2",
                                    fill: "white"
                                })
                            ]),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("g", {
                                mask: "url(#mask0_503_2952)"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("rect", {
                                    width: "28",
                                    height: "20",
                                    fill: "#0A17A7"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M-1.28244 -1.91644L10.6667 6.14335V-1.33333H17.3334V6.14335L29.2825 -1.91644L30.7737 0.294324L21.3263 6.66667H28V13.3333H21.3263L30.7737 19.7057L29.2825 21.9165L17.3334 13.8567V21.3333H10.6667V13.8567L-1.28244 21.9165L-2.77362 19.7057L6.67377 13.3333H2.95639e-05V6.66667H6.67377L-2.77362 0.294324L-1.28244 -1.91644Z",
                                    fill: "white"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    d: "M18.668 6.33219L31.3333 -2",
                                    stroke: "#DB1F35",
                                    strokeWidth: "0.666667",
                                    strokeLinecap: "round"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    d: "M20.0128 13.6975L31.3666 21.3503",
                                    stroke: "#DB1F35",
                                    strokeWidth: "0.666667",
                                    strokeLinecap: "round"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    d: "M8.00555 6.31046L-3.83746 -1.67099",
                                    stroke: "#DB1F35",
                                    strokeWidth: "0.666667",
                                    strokeLinecap: "round"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    d: "M9.29006 13.6049L-3.83746 22.3105",
                                    stroke: "#DB1F35",
                                    strokeWidth: "0.666667",
                                    strokeLinecap: "round"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M0 12H12V20H16V12H28V8H16V0H12V8H0V12Z",
                                    fill: "#E6273E"
                                })
                            ])
                        ])
                    ])
                ])),
                // French
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("fr")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 36 36",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#ED2939",
                            d: "M36 27a4 4 0 0 1-4 4h-8V5h8a4 4 0 0 1 4 4v18z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#002495",
                            d: "M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5H4z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#EEE",
                            d: "M12 5h12v26H12z"
                        })
                    ])
                ])),
                // Spanish
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("es")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 36 36",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#C60A1D",
                            d: "M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#FFC400",
                            d: "M0 12h36v12H0z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#EA596E",
                            d: "M9 17v3a3 3 0 1 0 6 0v-3H9z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#F4A2B2",
                            d: "M12 16h3v3h-3z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#DD2E44",
                            d: "M9 16h3v3H9z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ellipse", {
                            fill: "#EA596E",
                            cx: "12",
                            cy: "14.5",
                            rx: "3",
                            ry: "1.5"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ellipse", {
                            fill: "#FFAC33",
                            cx: "12",
                            cy: "13.75",
                            rx: "3",
                            ry: ".75"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#99AAB5",
                            d: "M7 16h1v7H7zm9 0h1v7h-1z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#66757F",
                            d: "M6 22h3v1H6zm9 0h3v1h-3zm-8-7h1v1H7zm9 0h1v1h-1z"
                        })
                    ])
                ])),
                // German
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("de")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 36 36",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#FFCD05",
                            d: "M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-4H0v4z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#ED1F24",
                            d: "M0 14h36v9H0z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#141414",
                            d: "M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4z"
                        })
                    ])
                ])),
                // Ukraine 
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("ua")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 36 36",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        role: "img",
                        class: "iconify iconify--twemoji",
                        preserveAspectRatio: "xMidYMid meet"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#005BBB",
                            d: "M32 5H4a4 4 0 0 0-4 4v9h36V9a4 4 0 0 0-4-4z"
                        }),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                            fill: "#FFD500",
                            d: "M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-9h36v9z"
                        })
                    ])
                ])),
                // Dutch
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.language", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("a", {
                    onclick: ()=>this.setLanguage("nl")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg", {
                        width: "60",
                        height: "60",
                        viewBox: "0 0 28 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none"
                    }, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("g", {
                            "clip-path": "url(#clip0_503_2742)"
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("rect", {
                                x: "0.25",
                                y: "0.25",
                                width: "27.5",
                                height: "19.5",
                                rx: "1.75",
                                fill: "white",
                                stroke: "#F5F5F5",
                                "stroke-width": "0.5"
                            }),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("mask", {
                                id: "mask0_503_2742",
                                style: {
                                    maskType: "alpha"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "0",
                                y: "0",
                                width: "28",
                                height: "20"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("rect", {
                                    x: "0.25",
                                    y: "0.25",
                                    width: "27.5",
                                    height: "19.5",
                                    rx: "1.75",
                                    fill: "white",
                                    stroke: "white",
                                    "stroke-width": "0.5"
                                })
                            ]),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("g", {
                                mask: "url(#mask0_503_2742)"
                            }, [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M0 6.66667H28V0H0V6.66667Z",
                                    fill: "#CA2B39"
                                }),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M0 20H28V13.3333H0V20Z",
                                    fill: "#2C56A2"
                                })
                            ])
                        ])
                    ])
                ]))
            ]) : null
        ]));
    }
}


/* eslint:disable */ 
class $ce2c82f65aa4cba4$var$sjefIconToolsKitchen2 {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconToolsKitchen2", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3" />')));
    }
}
var $ce2c82f65aa4cba4$export$2e2bcd8739ae039 = $ce2c82f65aa4cba4$var$sjefIconToolsKitchen2;


/* eslint:disable */ 
class $a216cb61036f8260$var$sjefIconChefHat {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconChefHat", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4.002 4.002 0 1 1 2.092 -7.723a3.999 3.999 0 0 1 3.908 -3.151z" /><path d="M6.161 17.009l11.839 -.009" />')));
    }
}
var $a216cb61036f8260$export$2e2bcd8739ae039 = $a216cb61036f8260$var$sjefIconChefHat;


/* eslint:disable */ 
class $7f09181eccfbdc61$var$sjefIconLicense {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconLicense", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11" /><line x1="9" y1="7" x2="13" y2="7" /><line x1="9" y1="11" x2="13" y2="11" />')));
    }
}
var $7f09181eccfbdc61$export$2e2bcd8739ae039 = $7f09181eccfbdc61$var$sjefIconLicense;


let $8cd2d12814b11138$var$thema = false;
class $8cd2d12814b11138$export$4a6bedb6e09009d4 {
    constructor(){
    // this.languageService = new LanguageService();
    }
    view(vnode) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".kdsModePage", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalKDSHeader", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $76d75d21365cd7a1$export$fa43c961ec463ef0)),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".flex", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.logout", {
                    onclick: async ()=>{
                        await (0, $138c3acec8d52e88$export$62819fe1bf99c5f7).logout();
                    }
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.logout")), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $c1a523cf6a0c6ba4$export$e835999d8e9cf347)))
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalChoiceBody", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalChoiceTitle", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.make_your_choice")),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalDescription", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".order1.order", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.order_screen"), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.customerButton", {
                        onclick: ()=>{
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/modeCustomer");
                        }
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $7f09181eccfbdc61$export$2e2bcd8739ae039)))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".order2.order", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.serve_screen"), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.kitchenButton.customerButton", {
                        onclick: ()=>{
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/modeServe");
                        }
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $ce2c82f65aa4cba4$export$2e2bcd8739ae039)))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".order3.order", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.kitchen_screen"), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.customerButton", {
                        onclick: ()=>{
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/modeKitchen");
                        }
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $a216cb61036f8260$export$2e2bcd8739ae039))))
                ])
            ])
        ]);
    }
}
const $8cd2d12814b11138$var$main = document.getElementById("main");
(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount($8cd2d12814b11138$var$main, $8cd2d12814b11138$export$4a6bedb6e09009d4);











/* eslint:disable */ 
class $b150472ed85d2f1f$var$sjefIconSettings {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconSettings", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" /><circle cx="12" cy="12" r="3" />')));
    }
}
var $b150472ed85d2f1f$export$2e2bcd8739ae039 = $b150472ed85d2f1f$var$sjefIconSettings;


class $8996eb00720d073d$export$436f5e39bfc74dcb {
    oninit(vnode) {
        vnode.state.isPopoverOpen = false;
        vnode.state.togglePopover = ()=>{
            vnode.state.isPopoverOpen = !vnode.state.isPopoverOpen;
        };
        document.addEventListener("click", (event)=>{
            if (!vnode.dom.contains(event.target)) {
                vnode.state.isPopoverOpen = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
            }
        });
    }
    view(vnode) {
        const options = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).options;
        const onSelectChange = vnode.attrs.onSelectChange;
        const isPopoverOpen = vnode.state.isPopoverOpen;
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".custom-popover-container", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", {
                onclick: ()=>{
                    vnode.state.isPopoverOpen = true;
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $b150472ed85d2f1f$export$2e2bcd8739ae039))),
            isPopoverOpen && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsContainer", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsOverlay", {
                    onclick: ()=>{
                        vnode.state.isPopoverOpen = false;
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                    }
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsDialog", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsBody", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsHeader", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalSettingsTitle", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.modal.batchAction.settings.makeTimer`)), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsOptions", options.map((option)=>{
                            return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".selectOption", {
                                class: parseInt(option) === parseInt((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedOption) ? "selected" : "",
                                onclick: ()=>{
                                    localStorage.setItem("selectedOption", option);
                                    onSelectChange(option);
                                    vnode.state.isPopoverOpen = false;
                                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                                }
                            }, option);
                        }))),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsHeader", [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalSettingsTitle", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.modal.batchAction.settings.printChoice`)),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalSettingsOptionsLarge", (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).action.map((action)=>{
                                return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".selectOption", {
                                    class: action === (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction ? "selected" : "",
                                    onclick: ()=>{
                                        localStorage.setItem("selectedAction", action);
                                        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction = action;
                                        vnode.state.isPopoverOpen = false;
                                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                                    }
                                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.options.${action}`));
                            }))
                        ])
                    ])
                ])
            ])
        ]);
    }
}





const $b3cf76bab13fe31a$var$Switch = {
    view: function(vnode) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("label.switchMode", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("input[type=checkbox]", {
                checked: vnode.attrs.checked,
                onchange: vnode.attrs.onchange
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span.slider1.round1")
        ]);
    }
};
class $b3cf76bab13fe31a$export$8b251419efc915eb {
    constructor(){
        this.switchChecked = false;
    }
    view(vnode) {
        const currentTab = vnode.attrs.currentTab;
        const mode = vnode.attrs.mode;
        const serveValue = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction;
        const tab = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).tabClass;
        const route = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.get(); // Отримання поточного маршруту
        // Умова для відображення Switch: відображаємо тільки для крім '/modeServe'
        const showSwitch = route !== "/modeServe" && route !== "/modeCustomer" && (tab === "open" || tab === "ready");
        const showServe = route !== "/modeCustomer" && (tab === "open" || tab === "ready");
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".header", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".leftPart", showSwitch ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modeSwitcher", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.kitchen_screen"), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))($b3cf76bab13fe31a$var$Switch, {
                onchange: (event)=>{
                    const newMode = event.target.checked ? "serve" : "kitchen";
                    const newTab = event.target.checked ? "ready" : "open";
                    vnode.attrs.onModeChange(newTab, newMode);
                }
            })) : null),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".middlePart", {
                onclick: ()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route.set("/kdsMode");
                }
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".rightPart", [
                showServe ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $8996eb00720d073d$export$436f5e39bfc74dcb), {
                    options: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).options,
                    selectedValue: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedOption,
                    serveValue: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).action,
                    selectedAction: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction,
                    onSelectChange: (value)=>{
                        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedOption = value;
                        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Selected value: " + (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedOption);
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                    },
                    serveChange: (serveValue)=>{
                        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction = serveValue;
                        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("MODE: " + serveValue);
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                    }
                }) : null
            ])
        ]);
    }
}


class $152999f8debeeda8$export$e553a04309473072 {
    view(vnode) {
        const renderOrderLabel = (label)=>{
            return [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerPreparePart", label.slice(0, 5)),
                label.length > 5 && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerPreparePart", label.slice(5))
            ];
        };
        const renderPrepareOrders = ()=>{
            return (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open?.filter((order)=>order.attributes.status === "in preparation").map((order)=>renderOrderLabel(order.attributes.order_label));
        };
        const renderReadyOrders = ()=>{
            return (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.ready?.filter((order)=>order.attributes.status === "ready").map((order)=>(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerReadyPart", order.attributes.order_label));
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".divdiv", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $b3cf76bab13fe31a$export$8b251419efc915eb), {}),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".mainCustomerPart", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".upCustomerPart", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerLeftPart", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.prepare")),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerRightPart", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.ready"))
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerPart", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerPrepareOrders", renderPrepareOrders()),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".customerready", renderReadyOrders())
                ])
            ])
        ]);
    }
}
const $152999f8debeeda8$var$main = document.getElementById("main");
(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount($152999f8debeeda8$var$main, $152999f8debeeda8$export$e553a04309473072);




var $45fvw = parcelRequire("45fvw");






var $45fvw = parcelRequire("45fvw");
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $0aeabd274a3674d8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0aeabd274a3674d8$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0aeabd274a3674d8$var$ownKeys(Object(source), true).forEach(function(key) {
            $0aeabd274a3674d8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0aeabd274a3674d8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0aeabd274a3674d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0aeabd274a3674d8$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $0aeabd274a3674d8$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0aeabd274a3674d8$var$_typeof(obj);
}
function $0aeabd274a3674d8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0aeabd274a3674d8$var$_extends() {
    $0aeabd274a3674d8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0aeabd274a3674d8$var$_extends.apply(this, arguments);
}
function $0aeabd274a3674d8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0aeabd274a3674d8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0aeabd274a3674d8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0aeabd274a3674d8$var$_toConsumableArray(arr) {
    return $0aeabd274a3674d8$var$_arrayWithoutHoles(arr) || $0aeabd274a3674d8$var$_iterableToArray(arr) || $0aeabd274a3674d8$var$_unsupportedIterableToArray(arr) || $0aeabd274a3674d8$var$_nonIterableSpread();
}
function $0aeabd274a3674d8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0aeabd274a3674d8$var$_arrayLikeToArray(arr);
}
function $0aeabd274a3674d8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0aeabd274a3674d8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0aeabd274a3674d8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0aeabd274a3674d8$var$_arrayLikeToArray(o, minLen);
}
function $0aeabd274a3674d8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0aeabd274a3674d8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $0aeabd274a3674d8$var$version = "1.15.2";
function $0aeabd274a3674d8$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $0aeabd274a3674d8$var$IE11OrLess = $0aeabd274a3674d8$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $0aeabd274a3674d8$var$Edge = $0aeabd274a3674d8$var$userAgent(/Edge/i);
var $0aeabd274a3674d8$var$FireFox = $0aeabd274a3674d8$var$userAgent(/firefox/i);
var $0aeabd274a3674d8$var$Safari = $0aeabd274a3674d8$var$userAgent(/safari/i) && !$0aeabd274a3674d8$var$userAgent(/chrome/i) && !$0aeabd274a3674d8$var$userAgent(/android/i);
var $0aeabd274a3674d8$var$IOS = $0aeabd274a3674d8$var$userAgent(/iP(ad|od|hone)/i);
var $0aeabd274a3674d8$var$ChromeForAndroid = $0aeabd274a3674d8$var$userAgent(/chrome/i) && $0aeabd274a3674d8$var$userAgent(/android/i);
var $0aeabd274a3674d8$var$captureMode = {
    capture: false,
    passive: false
};
function $0aeabd274a3674d8$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$0aeabd274a3674d8$var$IE11OrLess && $0aeabd274a3674d8$var$captureMode);
}
function $0aeabd274a3674d8$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$0aeabd274a3674d8$var$IE11OrLess && $0aeabd274a3674d8$var$captureMode);
}
function $0aeabd274a3674d8$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $0aeabd274a3674d8$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $0aeabd274a3674d8$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $0aeabd274a3674d8$var$matches(el, selector) : $0aeabd274a3674d8$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $0aeabd274a3674d8$var$getParentOrHost(el));
    }
    return null;
}
var $0aeabd274a3674d8$var$R_SPACE = /\s+/g;
function $0aeabd274a3674d8$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($0aeabd274a3674d8$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($0aeabd274a3674d8$var$R_SPACE, " ");
        }
    }
}
function $0aeabd274a3674d8$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $0aeabd274a3674d8$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $0aeabd274a3674d8$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $0aeabd274a3674d8$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $0aeabd274a3674d8$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $0aeabd274a3674d8$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $0aeabd274a3674d8$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$0aeabd274a3674d8$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($0aeabd274a3674d8$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $0aeabd274a3674d8$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($0aeabd274a3674d8$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($0aeabd274a3674d8$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $0aeabd274a3674d8$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $0aeabd274a3674d8$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $0aeabd274a3674d8$var$getParentAutoScrollElement(el, true), elSideVal = $0aeabd274a3674d8$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $0aeabd274a3674d8$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $0aeabd274a3674d8$var$getWindowScrollingElement()) break;
        parent = $0aeabd274a3674d8$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $0aeabd274a3674d8$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $0aeabd274a3674d8$var$Sortable.ghost && (includeDragEl || children[i] !== $0aeabd274a3674d8$var$Sortable.dragged) && $0aeabd274a3674d8$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $0aeabd274a3674d8$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $0aeabd274a3674d8$var$Sortable.ghost || $0aeabd274a3674d8$var$css(last, "display") === "none" || selector && !$0aeabd274a3674d8$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $0aeabd274a3674d8$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $0aeabd274a3674d8$var$Sortable.clone && (!selector || $0aeabd274a3674d8$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $0aeabd274a3674d8$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $0aeabd274a3674d8$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $0aeabd274a3674d8$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $0aeabd274a3674d8$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $0aeabd274a3674d8$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $0aeabd274a3674d8$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $0aeabd274a3674d8$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $0aeabd274a3674d8$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $0aeabd274a3674d8$var$getWindowScrollingElement();
}
function $0aeabd274a3674d8$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $0aeabd274a3674d8$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $0aeabd274a3674d8$var$_throttleTimeout;
function $0aeabd274a3674d8$var$throttle(callback, ms) {
    return function() {
        if (!$0aeabd274a3674d8$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $0aeabd274a3674d8$var$_throttleTimeout = setTimeout(function() {
                $0aeabd274a3674d8$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $0aeabd274a3674d8$var$cancelThrottle() {
    clearTimeout($0aeabd274a3674d8$var$_throttleTimeout);
    $0aeabd274a3674d8$var$_throttleTimeout = void 0;
}
function $0aeabd274a3674d8$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $0aeabd274a3674d8$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $0aeabd274a3674d8$var$setRect(el, rect) {
    $0aeabd274a3674d8$var$css(el, "position", "absolute");
    $0aeabd274a3674d8$var$css(el, "top", rect.top);
    $0aeabd274a3674d8$var$css(el, "left", rect.left);
    $0aeabd274a3674d8$var$css(el, "width", rect.width);
    $0aeabd274a3674d8$var$css(el, "height", rect.height);
}
function $0aeabd274a3674d8$var$unsetRect(el) {
    $0aeabd274a3674d8$var$css(el, "position", "");
    $0aeabd274a3674d8$var$css(el, "top", "");
    $0aeabd274a3674d8$var$css(el, "left", "");
    $0aeabd274a3674d8$var$css(el, "width", "");
    $0aeabd274a3674d8$var$css(el, "height", "");
}
function $0aeabd274a3674d8$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$0aeabd274a3674d8$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $0aeabd274a3674d8$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $0aeabd274a3674d8$var$expando = "Sortable" + new Date().getTime();
function $0aeabd274a3674d8$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($0aeabd274a3674d8$var$css(child, "display") === "none" || child === $0aeabd274a3674d8$var$Sortable.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $0aeabd274a3674d8$var$getRect(child)
                });
                var fromRect = $0aeabd274a3674d8$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $0aeabd274a3674d8$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($0aeabd274a3674d8$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $0aeabd274a3674d8$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $0aeabd274a3674d8$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($0aeabd274a3674d8$var$isRectEqual(prevFromRect, toRect) && !$0aeabd274a3674d8$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $0aeabd274a3674d8$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$0aeabd274a3674d8$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $0aeabd274a3674d8$var$css(target, "transition", "");
                $0aeabd274a3674d8$var$css(target, "transform", "");
                var elMatrix = $0aeabd274a3674d8$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $0aeabd274a3674d8$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $0aeabd274a3674d8$var$repaint(target); // repaint
                $0aeabd274a3674d8$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $0aeabd274a3674d8$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $0aeabd274a3674d8$var$css(target, "transition", "");
                    $0aeabd274a3674d8$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $0aeabd274a3674d8$var$repaint(target) {
    return target.offsetWidth;
}
function $0aeabd274a3674d8$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $0aeabd274a3674d8$var$plugins = [];
var $0aeabd274a3674d8$var$defaults = {
    initializeByDefault: true
};
var $0aeabd274a3674d8$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $0aeabd274a3674d8$var$defaults)if ($0aeabd274a3674d8$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $0aeabd274a3674d8$var$defaults[option];
        $0aeabd274a3674d8$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $0aeabd274a3674d8$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $0aeabd274a3674d8$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($0aeabd274a3674d8$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($0aeabd274a3674d8$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $0aeabd274a3674d8$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $0aeabd274a3674d8$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $0aeabd274a3674d8$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $0aeabd274a3674d8$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $0aeabd274a3674d8$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $0aeabd274a3674d8$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$0aeabd274a3674d8$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$0aeabd274a3674d8$var$IE11OrLess && !$0aeabd274a3674d8$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $0aeabd274a3674d8$var$_objectSpread2($0aeabd274a3674d8$var$_objectSpread2({}, extraEventProperties), $0aeabd274a3674d8$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $0aeabd274a3674d8$var$_excluded = [
    "evt"
];
var $0aeabd274a3674d8$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $0aeabd274a3674d8$var$_objectWithoutProperties(_ref, $0aeabd274a3674d8$var$_excluded);
    $0aeabd274a3674d8$var$PluginManager.pluginEvent.bind($0aeabd274a3674d8$var$Sortable)(eventName, sortable, $0aeabd274a3674d8$var$_objectSpread2({
        dragEl: $0aeabd274a3674d8$var$dragEl,
        parentEl: $0aeabd274a3674d8$var$parentEl,
        ghostEl: $0aeabd274a3674d8$var$ghostEl,
        rootEl: $0aeabd274a3674d8$var$rootEl,
        nextEl: $0aeabd274a3674d8$var$nextEl,
        lastDownEl: $0aeabd274a3674d8$var$lastDownEl,
        cloneEl: $0aeabd274a3674d8$var$cloneEl,
        cloneHidden: $0aeabd274a3674d8$var$cloneHidden,
        dragStarted: $0aeabd274a3674d8$var$moved,
        putSortable: $0aeabd274a3674d8$var$putSortable,
        activeSortable: $0aeabd274a3674d8$var$Sortable.active,
        originalEvent: originalEvent,
        oldIndex: $0aeabd274a3674d8$var$oldIndex,
        oldDraggableIndex: $0aeabd274a3674d8$var$oldDraggableIndex,
        newIndex: $0aeabd274a3674d8$var$newIndex,
        newDraggableIndex: $0aeabd274a3674d8$var$newDraggableIndex,
        hideGhostForTarget: $0aeabd274a3674d8$var$_hideGhostForTarget,
        unhideGhostForTarget: $0aeabd274a3674d8$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $0aeabd274a3674d8$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $0aeabd274a3674d8$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $0aeabd274a3674d8$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $0aeabd274a3674d8$var$_dispatchEvent(info) {
    $0aeabd274a3674d8$var$dispatchEvent($0aeabd274a3674d8$var$_objectSpread2({
        putSortable: $0aeabd274a3674d8$var$putSortable,
        cloneEl: $0aeabd274a3674d8$var$cloneEl,
        targetEl: $0aeabd274a3674d8$var$dragEl,
        rootEl: $0aeabd274a3674d8$var$rootEl,
        oldIndex: $0aeabd274a3674d8$var$oldIndex,
        oldDraggableIndex: $0aeabd274a3674d8$var$oldDraggableIndex,
        newIndex: $0aeabd274a3674d8$var$newIndex,
        newDraggableIndex: $0aeabd274a3674d8$var$newDraggableIndex
    }, info));
}
var $0aeabd274a3674d8$var$dragEl, $0aeabd274a3674d8$var$parentEl, $0aeabd274a3674d8$var$ghostEl, $0aeabd274a3674d8$var$rootEl, $0aeabd274a3674d8$var$nextEl, $0aeabd274a3674d8$var$lastDownEl, $0aeabd274a3674d8$var$cloneEl, $0aeabd274a3674d8$var$cloneHidden, $0aeabd274a3674d8$var$oldIndex, $0aeabd274a3674d8$var$newIndex, $0aeabd274a3674d8$var$oldDraggableIndex, $0aeabd274a3674d8$var$newDraggableIndex, $0aeabd274a3674d8$var$activeGroup, $0aeabd274a3674d8$var$putSortable, $0aeabd274a3674d8$var$awaitingDragStarted = false, $0aeabd274a3674d8$var$ignoreNextClick = false, $0aeabd274a3674d8$var$sortables = [], $0aeabd274a3674d8$var$tapEvt, $0aeabd274a3674d8$var$touchEvt, $0aeabd274a3674d8$var$lastDx, $0aeabd274a3674d8$var$lastDy, $0aeabd274a3674d8$var$tapDistanceLeft, $0aeabd274a3674d8$var$tapDistanceTop, $0aeabd274a3674d8$var$moved, $0aeabd274a3674d8$var$lastTarget, $0aeabd274a3674d8$var$lastDirection, $0aeabd274a3674d8$var$pastFirstInvertThresh = false, $0aeabd274a3674d8$var$isCircumstantialInvert = false, $0aeabd274a3674d8$var$targetMoveDistance, // For positioning ghost absolutely
$0aeabd274a3674d8$var$ghostRelativeParent, $0aeabd274a3674d8$var$ghostRelativeParentInitialScroll = [], // (left, top)
$0aeabd274a3674d8$var$_silent = false, $0aeabd274a3674d8$var$savedInputChecked = [];
/** @const */ var $0aeabd274a3674d8$var$documentExists = typeof document !== "undefined", $0aeabd274a3674d8$var$PositionGhostAbsolutely = $0aeabd274a3674d8$var$IOS, $0aeabd274a3674d8$var$CSSFloatProperty = $0aeabd274a3674d8$var$Edge || $0aeabd274a3674d8$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$0aeabd274a3674d8$var$supportDraggable = $0aeabd274a3674d8$var$documentExists && !$0aeabd274a3674d8$var$ChromeForAndroid && !$0aeabd274a3674d8$var$IOS && "draggable" in document.createElement("div"), $0aeabd274a3674d8$var$supportCssPointerEvents = function() {
    if (!$0aeabd274a3674d8$var$documentExists) return;
    // false when <= IE11
    if ($0aeabd274a3674d8$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $0aeabd274a3674d8$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $0aeabd274a3674d8$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $0aeabd274a3674d8$var$getChild(el, 0, options), child2 = $0aeabd274a3674d8$var$getChild(el, 1, options), firstChildCSS = child1 && $0aeabd274a3674d8$var$css(child1), secondChildCSS = child2 && $0aeabd274a3674d8$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $0aeabd274a3674d8$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $0aeabd274a3674d8$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$0aeabd274a3674d8$var$CSSFloatProperty] === "none" || child2 && elCSS[$0aeabd274a3674d8$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $0aeabd274a3674d8$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $0aeabd274a3674d8$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $0aeabd274a3674d8$var$sortables.some(function(sortable) {
        var threshold = sortable[$0aeabd274a3674d8$var$expando].options.emptyInsertThreshold;
        if (!threshold || $0aeabd274a3674d8$var$lastChild(sortable)) return;
        var rect = $0aeabd274a3674d8$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $0aeabd274a3674d8$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $0aeabd274a3674d8$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $0aeabd274a3674d8$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$0aeabd274a3674d8$var$supportCssPointerEvents && $0aeabd274a3674d8$var$ghostEl) $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "display", "none");
}, $0aeabd274a3674d8$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$0aeabd274a3674d8$var$supportCssPointerEvents && $0aeabd274a3674d8$var$ghostEl) $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($0aeabd274a3674d8$var$documentExists && !$0aeabd274a3674d8$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($0aeabd274a3674d8$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $0aeabd274a3674d8$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($0aeabd274a3674d8$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $0aeabd274a3674d8$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$0aeabd274a3674d8$var$expando]._onDragOver(event);
        }
    }
};
var $0aeabd274a3674d8$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($0aeabd274a3674d8$var$dragEl) $0aeabd274a3674d8$var$dragEl.parentNode[$0aeabd274a3674d8$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $0aeabd274a3674d8$var$Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $0aeabd274a3674d8$var$_extends({}, options);
    // Export instance
    el[$0aeabd274a3674d8$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $0aeabd274a3674d8$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $0aeabd274a3674d8$var$Sortable.supportPointer !== false && "PointerEvent" in window && !$0aeabd274a3674d8$var$Safari,
        emptyInsertThreshold: 5
    };
    $0aeabd274a3674d8$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $0aeabd274a3674d8$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $0aeabd274a3674d8$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $0aeabd274a3674d8$var$on(el, "pointerdown", this._onTapStart);
    else {
        $0aeabd274a3674d8$var$on(el, "mousedown", this._onTapStart);
        $0aeabd274a3674d8$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $0aeabd274a3674d8$var$on(el, "dragover", this);
        $0aeabd274a3674d8$var$on(el, "dragenter", this);
    }
    $0aeabd274a3674d8$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $0aeabd274a3674d8$var$_extends(this, $0aeabd274a3674d8$var$AnimationStateManager());
}
$0aeabd274a3674d8$var$Sortable.prototype = /** @lends Sortable.prototype */ {
    constructor: $0aeabd274a3674d8$var$Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $0aeabd274a3674d8$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $0aeabd274a3674d8$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $0aeabd274a3674d8$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($0aeabd274a3674d8$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $0aeabd274a3674d8$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $0aeabd274a3674d8$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($0aeabd274a3674d8$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $0aeabd274a3674d8$var$oldIndex = $0aeabd274a3674d8$var$index(target);
        $0aeabd274a3674d8$var$oldDraggableIndex = $0aeabd274a3674d8$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $0aeabd274a3674d8$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $0aeabd274a3674d8$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $0aeabd274a3674d8$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $0aeabd274a3674d8$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $0aeabd274a3674d8$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$0aeabd274a3674d8$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$0aeabd274a3674d8$var$dragEl && target.parentNode === el) {
            var dragRect = $0aeabd274a3674d8$var$getRect(target);
            $0aeabd274a3674d8$var$rootEl = el;
            $0aeabd274a3674d8$var$dragEl = target;
            $0aeabd274a3674d8$var$parentEl = $0aeabd274a3674d8$var$dragEl.parentNode;
            $0aeabd274a3674d8$var$nextEl = $0aeabd274a3674d8$var$dragEl.nextSibling;
            $0aeabd274a3674d8$var$lastDownEl = target;
            $0aeabd274a3674d8$var$activeGroup = options.group;
            $0aeabd274a3674d8$var$Sortable.dragged = $0aeabd274a3674d8$var$dragEl;
            $0aeabd274a3674d8$var$tapEvt = {
                target: $0aeabd274a3674d8$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $0aeabd274a3674d8$var$tapDistanceLeft = $0aeabd274a3674d8$var$tapEvt.clientX - dragRect.left;
            $0aeabd274a3674d8$var$tapDistanceTop = $0aeabd274a3674d8$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $0aeabd274a3674d8$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $0aeabd274a3674d8$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($0aeabd274a3674d8$var$Sortable.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$0aeabd274a3674d8$var$FireFox && _this.nativeDraggable) $0aeabd274a3674d8$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $0aeabd274a3674d8$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $0aeabd274a3674d8$var$find($0aeabd274a3674d8$var$dragEl, criteria.trim(), $0aeabd274a3674d8$var$_disableDraggable);
            });
            $0aeabd274a3674d8$var$on(ownerDocument, "dragover", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
            $0aeabd274a3674d8$var$on(ownerDocument, "mousemove", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
            $0aeabd274a3674d8$var$on(ownerDocument, "touchmove", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
            $0aeabd274a3674d8$var$on(ownerDocument, "mouseup", _this._onDrop);
            $0aeabd274a3674d8$var$on(ownerDocument, "touchend", _this._onDrop);
            $0aeabd274a3674d8$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($0aeabd274a3674d8$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $0aeabd274a3674d8$var$dragEl.draggable = true;
            }
            $0aeabd274a3674d8$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($0aeabd274a3674d8$var$Edge || $0aeabd274a3674d8$var$IE11OrLess))) {
                if ($0aeabd274a3674d8$var$Sortable.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $0aeabd274a3674d8$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $0aeabd274a3674d8$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $0aeabd274a3674d8$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $0aeabd274a3674d8$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $0aeabd274a3674d8$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $0aeabd274a3674d8$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $0aeabd274a3674d8$var$dragEl && $0aeabd274a3674d8$var$_disableDraggable($0aeabd274a3674d8$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $0aeabd274a3674d8$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $0aeabd274a3674d8$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $0aeabd274a3674d8$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $0aeabd274a3674d8$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $0aeabd274a3674d8$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $0aeabd274a3674d8$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $0aeabd274a3674d8$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $0aeabd274a3674d8$var$on(document, "touchmove", this._onTouchMove);
            else $0aeabd274a3674d8$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $0aeabd274a3674d8$var$on($0aeabd274a3674d8$var$dragEl, "dragend", this);
            $0aeabd274a3674d8$var$on($0aeabd274a3674d8$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $0aeabd274a3674d8$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $0aeabd274a3674d8$var$awaitingDragStarted = false;
        if ($0aeabd274a3674d8$var$rootEl && $0aeabd274a3674d8$var$dragEl) {
            $0aeabd274a3674d8$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $0aeabd274a3674d8$var$on(document, "dragover", $0aeabd274a3674d8$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, options.dragClass, false);
            $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, options.ghostClass, true);
            $0aeabd274a3674d8$var$Sortable.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $0aeabd274a3674d8$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($0aeabd274a3674d8$var$touchEvt) {
            this._lastX = $0aeabd274a3674d8$var$touchEvt.clientX;
            this._lastY = $0aeabd274a3674d8$var$touchEvt.clientY;
            $0aeabd274a3674d8$var$_hideGhostForTarget();
            var target = document.elementFromPoint($0aeabd274a3674d8$var$touchEvt.clientX, $0aeabd274a3674d8$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($0aeabd274a3674d8$var$touchEvt.clientX, $0aeabd274a3674d8$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $0aeabd274a3674d8$var$dragEl.parentNode[$0aeabd274a3674d8$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$0aeabd274a3674d8$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$0aeabd274a3674d8$var$expando]._onDragOver({
                        clientX: $0aeabd274a3674d8$var$touchEvt.clientX,
                        clientY: $0aeabd274a3674d8$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $0aeabd274a3674d8$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($0aeabd274a3674d8$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $0aeabd274a3674d8$var$ghostEl && $0aeabd274a3674d8$var$matrix($0aeabd274a3674d8$var$ghostEl, true), scaleX = $0aeabd274a3674d8$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $0aeabd274a3674d8$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $0aeabd274a3674d8$var$PositionGhostAbsolutely && $0aeabd274a3674d8$var$ghostRelativeParent && $0aeabd274a3674d8$var$getRelativeScrollOffset($0aeabd274a3674d8$var$ghostRelativeParent), dx = (touch.clientX - $0aeabd274a3674d8$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $0aeabd274a3674d8$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $0aeabd274a3674d8$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $0aeabd274a3674d8$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$0aeabd274a3674d8$var$Sortable.active && !$0aeabd274a3674d8$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($0aeabd274a3674d8$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($0aeabd274a3674d8$var$lastDx || 0);
                    ghostMatrix.f += dy - ($0aeabd274a3674d8$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "webkitTransform", cssMatrix);
                $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "mozTransform", cssMatrix);
                $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "msTransform", cssMatrix);
                $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "transform", cssMatrix);
                $0aeabd274a3674d8$var$lastDx = dx;
                $0aeabd274a3674d8$var$lastDy = dy;
                $0aeabd274a3674d8$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$0aeabd274a3674d8$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $0aeabd274a3674d8$var$rootEl, rect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$dragEl, true, $0aeabd274a3674d8$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($0aeabd274a3674d8$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $0aeabd274a3674d8$var$ghostRelativeParent = container;
                while($0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostRelativeParent, "position") === "static" && $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostRelativeParent, "transform") === "none" && $0aeabd274a3674d8$var$ghostRelativeParent !== document)$0aeabd274a3674d8$var$ghostRelativeParent = $0aeabd274a3674d8$var$ghostRelativeParent.parentNode;
                if ($0aeabd274a3674d8$var$ghostRelativeParent !== document.body && $0aeabd274a3674d8$var$ghostRelativeParent !== document.documentElement) {
                    if ($0aeabd274a3674d8$var$ghostRelativeParent === document) $0aeabd274a3674d8$var$ghostRelativeParent = $0aeabd274a3674d8$var$getWindowScrollingElement();
                    rect.top += $0aeabd274a3674d8$var$ghostRelativeParent.scrollTop;
                    rect.left += $0aeabd274a3674d8$var$ghostRelativeParent.scrollLeft;
                } else $0aeabd274a3674d8$var$ghostRelativeParent = $0aeabd274a3674d8$var$getWindowScrollingElement();
                $0aeabd274a3674d8$var$ghostRelativeParentInitialScroll = $0aeabd274a3674d8$var$getRelativeScrollOffset($0aeabd274a3674d8$var$ghostRelativeParent);
            }
            $0aeabd274a3674d8$var$ghostEl = $0aeabd274a3674d8$var$dragEl.cloneNode(true);
            $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$ghostEl, options.ghostClass, false);
            $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$ghostEl, options.fallbackClass, true);
            $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$ghostEl, options.dragClass, true);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "transition", "");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "transform", "");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "box-sizing", "border-box");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "margin", 0);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "top", rect.top);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "left", rect.left);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "width", rect.width);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "height", rect.height);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "opacity", "0.8");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "position", $0aeabd274a3674d8$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "zIndex", "100000");
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "pointerEvents", "none");
            $0aeabd274a3674d8$var$Sortable.ghost = $0aeabd274a3674d8$var$ghostEl;
            container.appendChild($0aeabd274a3674d8$var$ghostEl);
            // Set transform-origin
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$ghostEl, "transform-origin", $0aeabd274a3674d8$var$tapDistanceLeft / parseInt($0aeabd274a3674d8$var$ghostEl.style.width) * 100 + "% " + $0aeabd274a3674d8$var$tapDistanceTop / parseInt($0aeabd274a3674d8$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $0aeabd274a3674d8$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($0aeabd274a3674d8$var$Sortable.eventCanceled) {
            this._onDrop();
            return;
        }
        $0aeabd274a3674d8$var$pluginEvent("setupClone", this);
        if (!$0aeabd274a3674d8$var$Sortable.eventCanceled) {
            $0aeabd274a3674d8$var$cloneEl = $0aeabd274a3674d8$var$clone($0aeabd274a3674d8$var$dragEl);
            $0aeabd274a3674d8$var$cloneEl.removeAttribute("id");
            $0aeabd274a3674d8$var$cloneEl.draggable = false;
            $0aeabd274a3674d8$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$cloneEl, this.options.chosenClass, false);
            $0aeabd274a3674d8$var$Sortable.clone = $0aeabd274a3674d8$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $0aeabd274a3674d8$var$_nextTick(function() {
            $0aeabd274a3674d8$var$pluginEvent("clone", _this);
            if ($0aeabd274a3674d8$var$Sortable.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $0aeabd274a3674d8$var$rootEl.insertBefore($0aeabd274a3674d8$var$cloneEl, $0aeabd274a3674d8$var$dragEl);
            _this._hideClone();
            $0aeabd274a3674d8$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $0aeabd274a3674d8$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $0aeabd274a3674d8$var$off(document, "mouseup", _this._onDrop);
            $0aeabd274a3674d8$var$off(document, "touchend", _this._onDrop);
            $0aeabd274a3674d8$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $0aeabd274a3674d8$var$dragEl);
            }
            $0aeabd274a3674d8$var$on(document, "drop", _this);
            // #1276 fix:
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$dragEl, "transform", "translateZ(0)");
        }
        $0aeabd274a3674d8$var$awaitingDragStarted = true;
        _this._dragStartId = $0aeabd274a3674d8$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $0aeabd274a3674d8$var$on(document, "selectstart", _this);
        $0aeabd274a3674d8$var$moved = true;
        if ($0aeabd274a3674d8$var$Safari) $0aeabd274a3674d8$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $0aeabd274a3674d8$var$Sortable.active, isOwner = $0aeabd274a3674d8$var$activeGroup === group, canSort = options.sort, fromSortable = $0aeabd274a3674d8$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($0aeabd274a3674d8$var$_silent) return;
        function dragOverEvent(name, extra) {
            $0aeabd274a3674d8$var$pluginEvent(name, _this, $0aeabd274a3674d8$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $0aeabd274a3674d8$var$_onMove($0aeabd274a3674d8$var$rootEl, el, $0aeabd274a3674d8$var$dragEl, dragRect, target, $0aeabd274a3674d8$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, $0aeabd274a3674d8$var$putSortable ? $0aeabd274a3674d8$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, options.ghostClass, true);
                }
                if ($0aeabd274a3674d8$var$putSortable !== _this && _this !== $0aeabd274a3674d8$var$Sortable.active) $0aeabd274a3674d8$var$putSortable = _this;
                else if (_this === $0aeabd274a3674d8$var$Sortable.active && $0aeabd274a3674d8$var$putSortable) $0aeabd274a3674d8$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $0aeabd274a3674d8$var$dragEl && !$0aeabd274a3674d8$var$dragEl.animated || target === el && !target.animated) $0aeabd274a3674d8$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $0aeabd274a3674d8$var$dragEl.parentNode[$0aeabd274a3674d8$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $0aeabd274a3674d8$var$newIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl);
            $0aeabd274a3674d8$var$newDraggableIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl, options.draggable);
            $0aeabd274a3674d8$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $0aeabd274a3674d8$var$newIndex,
                newDraggableIndex: $0aeabd274a3674d8$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $0aeabd274a3674d8$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($0aeabd274a3674d8$var$Sortable.eventCanceled) return completedFired;
        if ($0aeabd274a3674d8$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $0aeabd274a3674d8$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $0aeabd274a3674d8$var$parentEl !== $0aeabd274a3674d8$var$rootEl // Reverting item into the original list
        ) : $0aeabd274a3674d8$var$putSortable === this || (this.lastPutMode = $0aeabd274a3674d8$var$activeGroup.checkPull(this, activeSortable, $0aeabd274a3674d8$var$dragEl, evt)) && group.checkPut(this, activeSortable, $0aeabd274a3674d8$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($0aeabd274a3674d8$var$Sortable.eventCanceled) return completedFired;
            if (revert) {
                $0aeabd274a3674d8$var$parentEl = $0aeabd274a3674d8$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$0aeabd274a3674d8$var$Sortable.eventCanceled) {
                    if ($0aeabd274a3674d8$var$nextEl) $0aeabd274a3674d8$var$rootEl.insertBefore($0aeabd274a3674d8$var$dragEl, $0aeabd274a3674d8$var$nextEl);
                    else $0aeabd274a3674d8$var$rootEl.appendChild($0aeabd274a3674d8$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $0aeabd274a3674d8$var$lastChild(el, options.draggable);
            if (!elLastChild || $0aeabd274a3674d8$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $0aeabd274a3674d8$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $0aeabd274a3674d8$var$getRect(target);
                if ($0aeabd274a3674d8$var$_onMove($0aeabd274a3674d8$var$rootEl, el, $0aeabd274a3674d8$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($0aeabd274a3674d8$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($0aeabd274a3674d8$var$dragEl);
                    $0aeabd274a3674d8$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $0aeabd274a3674d8$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $0aeabd274a3674d8$var$getChild(el, 0, options, true);
                if (firstChild === $0aeabd274a3674d8$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $0aeabd274a3674d8$var$getRect(target);
                if ($0aeabd274a3674d8$var$_onMove($0aeabd274a3674d8$var$rootEl, el, $0aeabd274a3674d8$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($0aeabd274a3674d8$var$dragEl, firstChild);
                    $0aeabd274a3674d8$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $0aeabd274a3674d8$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $0aeabd274a3674d8$var$dragEl.parentNode !== el, differentRowCol = !$0aeabd274a3674d8$var$_dragElInRowColumn($0aeabd274a3674d8$var$dragEl.animated && $0aeabd274a3674d8$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $0aeabd274a3674d8$var$isScrolledPast(target, "top", "top") || $0aeabd274a3674d8$var$isScrolledPast($0aeabd274a3674d8$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($0aeabd274a3674d8$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $0aeabd274a3674d8$var$pastFirstInvertThresh = false;
                    $0aeabd274a3674d8$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $0aeabd274a3674d8$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $0aeabd274a3674d8$var$isCircumstantialInvert, $0aeabd274a3674d8$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $0aeabd274a3674d8$var$parentEl.children[dragIndex];
                    }while (sibling && ($0aeabd274a3674d8$var$css(sibling, "display") === "none" || sibling === $0aeabd274a3674d8$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $0aeabd274a3674d8$var$lastTarget = target;
                $0aeabd274a3674d8$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $0aeabd274a3674d8$var$_onMove($0aeabd274a3674d8$var$rootEl, el, $0aeabd274a3674d8$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $0aeabd274a3674d8$var$_silent = true;
                    setTimeout($0aeabd274a3674d8$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($0aeabd274a3674d8$var$dragEl);
                    else target.parentNode.insertBefore($0aeabd274a3674d8$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $0aeabd274a3674d8$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $0aeabd274a3674d8$var$parentEl = $0aeabd274a3674d8$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$0aeabd274a3674d8$var$isCircumstantialInvert) $0aeabd274a3674d8$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $0aeabd274a3674d8$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($0aeabd274a3674d8$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $0aeabd274a3674d8$var$off(document, "mousemove", this._onTouchMove);
        $0aeabd274a3674d8$var$off(document, "touchmove", this._onTouchMove);
        $0aeabd274a3674d8$var$off(document, "pointermove", this._onTouchMove);
        $0aeabd274a3674d8$var$off(document, "dragover", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
        $0aeabd274a3674d8$var$off(document, "mousemove", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
        $0aeabd274a3674d8$var$off(document, "touchmove", $0aeabd274a3674d8$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $0aeabd274a3674d8$var$off(ownerDocument, "mouseup", this._onDrop);
        $0aeabd274a3674d8$var$off(ownerDocument, "touchend", this._onDrop);
        $0aeabd274a3674d8$var$off(ownerDocument, "pointerup", this._onDrop);
        $0aeabd274a3674d8$var$off(ownerDocument, "touchcancel", this._onDrop);
        $0aeabd274a3674d8$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $0aeabd274a3674d8$var$newIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl);
        $0aeabd274a3674d8$var$newDraggableIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl, options.draggable);
        $0aeabd274a3674d8$var$pluginEvent("drop", this, {
            evt: evt
        });
        $0aeabd274a3674d8$var$parentEl = $0aeabd274a3674d8$var$dragEl && $0aeabd274a3674d8$var$dragEl.parentNode;
        // Get again after plugin event
        $0aeabd274a3674d8$var$newIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl);
        $0aeabd274a3674d8$var$newDraggableIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl, options.draggable);
        if ($0aeabd274a3674d8$var$Sortable.eventCanceled) {
            this._nulling();
            return;
        }
        $0aeabd274a3674d8$var$awaitingDragStarted = false;
        $0aeabd274a3674d8$var$isCircumstantialInvert = false;
        $0aeabd274a3674d8$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $0aeabd274a3674d8$var$_cancelNextTick(this.cloneId);
        $0aeabd274a3674d8$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $0aeabd274a3674d8$var$off(document, "drop", this);
            $0aeabd274a3674d8$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($0aeabd274a3674d8$var$Safari) $0aeabd274a3674d8$var$css(document.body, "user-select", "");
        $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$dragEl, "transform", "");
        if (evt) {
            if ($0aeabd274a3674d8$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $0aeabd274a3674d8$var$ghostEl && $0aeabd274a3674d8$var$ghostEl.parentNode && $0aeabd274a3674d8$var$ghostEl.parentNode.removeChild($0aeabd274a3674d8$var$ghostEl);
            if ($0aeabd274a3674d8$var$rootEl === $0aeabd274a3674d8$var$parentEl || $0aeabd274a3674d8$var$putSortable && $0aeabd274a3674d8$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $0aeabd274a3674d8$var$cloneEl && $0aeabd274a3674d8$var$cloneEl.parentNode && $0aeabd274a3674d8$var$cloneEl.parentNode.removeChild($0aeabd274a3674d8$var$cloneEl);
            if ($0aeabd274a3674d8$var$dragEl) {
                if (this.nativeDraggable) $0aeabd274a3674d8$var$off($0aeabd274a3674d8$var$dragEl, "dragend", this);
                $0aeabd274a3674d8$var$_disableDraggable($0aeabd274a3674d8$var$dragEl);
                $0aeabd274a3674d8$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($0aeabd274a3674d8$var$moved && !$0aeabd274a3674d8$var$awaitingDragStarted) $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, $0aeabd274a3674d8$var$putSortable ? $0aeabd274a3674d8$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $0aeabd274a3674d8$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $0aeabd274a3674d8$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($0aeabd274a3674d8$var$rootEl !== $0aeabd274a3674d8$var$parentEl) {
                    if ($0aeabd274a3674d8$var$newIndex >= 0) {
                        // Add event
                        $0aeabd274a3674d8$var$_dispatchEvent({
                            rootEl: $0aeabd274a3674d8$var$parentEl,
                            name: "add",
                            toEl: $0aeabd274a3674d8$var$parentEl,
                            fromEl: $0aeabd274a3674d8$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $0aeabd274a3674d8$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $0aeabd274a3674d8$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $0aeabd274a3674d8$var$_dispatchEvent({
                            rootEl: $0aeabd274a3674d8$var$parentEl,
                            name: "sort",
                            toEl: $0aeabd274a3674d8$var$parentEl,
                            fromEl: $0aeabd274a3674d8$var$rootEl,
                            originalEvent: evt
                        });
                        $0aeabd274a3674d8$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $0aeabd274a3674d8$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $0aeabd274a3674d8$var$putSortable && $0aeabd274a3674d8$var$putSortable.save();
                } else {
                    if ($0aeabd274a3674d8$var$newIndex !== $0aeabd274a3674d8$var$oldIndex) {
                        if ($0aeabd274a3674d8$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $0aeabd274a3674d8$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $0aeabd274a3674d8$var$parentEl,
                                originalEvent: evt
                            });
                            $0aeabd274a3674d8$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $0aeabd274a3674d8$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($0aeabd274a3674d8$var$Sortable.active) {
                    /* jshint eqnull:true */ if ($0aeabd274a3674d8$var$newIndex == null || $0aeabd274a3674d8$var$newIndex === -1) {
                        $0aeabd274a3674d8$var$newIndex = $0aeabd274a3674d8$var$oldIndex;
                        $0aeabd274a3674d8$var$newDraggableIndex = $0aeabd274a3674d8$var$oldDraggableIndex;
                    }
                    $0aeabd274a3674d8$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $0aeabd274a3674d8$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $0aeabd274a3674d8$var$pluginEvent("nulling", this);
        $0aeabd274a3674d8$var$rootEl = $0aeabd274a3674d8$var$dragEl = $0aeabd274a3674d8$var$parentEl = $0aeabd274a3674d8$var$ghostEl = $0aeabd274a3674d8$var$nextEl = $0aeabd274a3674d8$var$cloneEl = $0aeabd274a3674d8$var$lastDownEl = $0aeabd274a3674d8$var$cloneHidden = $0aeabd274a3674d8$var$tapEvt = $0aeabd274a3674d8$var$touchEvt = $0aeabd274a3674d8$var$moved = $0aeabd274a3674d8$var$newIndex = $0aeabd274a3674d8$var$newDraggableIndex = $0aeabd274a3674d8$var$oldIndex = $0aeabd274a3674d8$var$oldDraggableIndex = $0aeabd274a3674d8$var$lastTarget = $0aeabd274a3674d8$var$lastDirection = $0aeabd274a3674d8$var$putSortable = $0aeabd274a3674d8$var$activeGroup = $0aeabd274a3674d8$var$Sortable.dragged = $0aeabd274a3674d8$var$Sortable.ghost = $0aeabd274a3674d8$var$Sortable.clone = $0aeabd274a3674d8$var$Sortable.active = null;
        $0aeabd274a3674d8$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $0aeabd274a3674d8$var$savedInputChecked.length = $0aeabd274a3674d8$var$lastDx = $0aeabd274a3674d8$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($0aeabd274a3674d8$var$dragEl) {
                    this._onDragOver(evt);
                    $0aeabd274a3674d8$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($0aeabd274a3674d8$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $0aeabd274a3674d8$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($0aeabd274a3674d8$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $0aeabd274a3674d8$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $0aeabd274a3674d8$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $0aeabd274a3674d8$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $0aeabd274a3674d8$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$0aeabd274a3674d8$var$expando] = null;
        $0aeabd274a3674d8$var$off(el, "mousedown", this._onTapStart);
        $0aeabd274a3674d8$var$off(el, "touchstart", this._onTapStart);
        $0aeabd274a3674d8$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $0aeabd274a3674d8$var$off(el, "dragover", this);
            $0aeabd274a3674d8$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $0aeabd274a3674d8$var$sortables.splice($0aeabd274a3674d8$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$0aeabd274a3674d8$var$cloneHidden) {
            $0aeabd274a3674d8$var$pluginEvent("hideClone", this);
            if ($0aeabd274a3674d8$var$Sortable.eventCanceled) return;
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $0aeabd274a3674d8$var$cloneEl.parentNode) $0aeabd274a3674d8$var$cloneEl.parentNode.removeChild($0aeabd274a3674d8$var$cloneEl);
            $0aeabd274a3674d8$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($0aeabd274a3674d8$var$cloneHidden) {
            $0aeabd274a3674d8$var$pluginEvent("showClone", this);
            if ($0aeabd274a3674d8$var$Sortable.eventCanceled) return;
            // show clone at dragEl or original position
            if ($0aeabd274a3674d8$var$dragEl.parentNode == $0aeabd274a3674d8$var$rootEl && !this.options.group.revertClone) $0aeabd274a3674d8$var$rootEl.insertBefore($0aeabd274a3674d8$var$cloneEl, $0aeabd274a3674d8$var$dragEl);
            else if ($0aeabd274a3674d8$var$nextEl) $0aeabd274a3674d8$var$rootEl.insertBefore($0aeabd274a3674d8$var$cloneEl, $0aeabd274a3674d8$var$nextEl);
            else $0aeabd274a3674d8$var$rootEl.appendChild($0aeabd274a3674d8$var$cloneEl);
            if (this.options.group.revertClone) this.animate($0aeabd274a3674d8$var$dragEl, $0aeabd274a3674d8$var$cloneEl);
            $0aeabd274a3674d8$var$css($0aeabd274a3674d8$var$cloneEl, "display", "");
            $0aeabd274a3674d8$var$cloneHidden = false;
        }
    }
};
function $0aeabd274a3674d8$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $0aeabd274a3674d8$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$0aeabd274a3674d8$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$0aeabd274a3674d8$var$IE11OrLess && !$0aeabd274a3674d8$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $0aeabd274a3674d8$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $0aeabd274a3674d8$var$_disableDraggable(el) {
    el.draggable = false;
}
function $0aeabd274a3674d8$var$_unsilent() {
    $0aeabd274a3674d8$var$_silent = false;
}
function $0aeabd274a3674d8$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $0aeabd274a3674d8$var$getChildContainingRectFromElement(sortable.el, sortable.options, $0aeabd274a3674d8$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $0aeabd274a3674d8$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $0aeabd274a3674d8$var$getChildContainingRectFromElement(sortable.el, sortable.options, $0aeabd274a3674d8$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $0aeabd274a3674d8$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $0aeabd274a3674d8$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$0aeabd274a3674d8$var$pastFirstInvertThresh && ($0aeabd274a3674d8$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $0aeabd274a3674d8$var$pastFirstInvertThresh = true;
            if (!$0aeabd274a3674d8$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($0aeabd274a3674d8$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $0aeabd274a3674d8$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $0aeabd274a3674d8$var$targetMoveDistance) return -$0aeabd274a3674d8$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $0aeabd274a3674d8$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $0aeabd274a3674d8$var$_getInsertDirection(target) {
    if ($0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl) < $0aeabd274a3674d8$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $0aeabd274a3674d8$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $0aeabd274a3674d8$var$_saveInputCheckedState(root) {
    $0aeabd274a3674d8$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $0aeabd274a3674d8$var$savedInputChecked.push(el);
    }
}
function $0aeabd274a3674d8$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $0aeabd274a3674d8$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($0aeabd274a3674d8$var$documentExists) $0aeabd274a3674d8$var$on(document, "touchmove", function(evt) {
    if (($0aeabd274a3674d8$var$Sortable.active || $0aeabd274a3674d8$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$0aeabd274a3674d8$var$Sortable.utils = {
    on: $0aeabd274a3674d8$var$on,
    off: $0aeabd274a3674d8$var$off,
    css: $0aeabd274a3674d8$var$css,
    find: $0aeabd274a3674d8$var$find,
    is: function is(el, selector) {
        return !!$0aeabd274a3674d8$var$closest(el, selector, el, false);
    },
    extend: $0aeabd274a3674d8$var$extend,
    throttle: $0aeabd274a3674d8$var$throttle,
    closest: $0aeabd274a3674d8$var$closest,
    toggleClass: $0aeabd274a3674d8$var$toggleClass,
    clone: $0aeabd274a3674d8$var$clone,
    index: $0aeabd274a3674d8$var$index,
    nextTick: $0aeabd274a3674d8$var$_nextTick,
    cancelNextTick: $0aeabd274a3674d8$var$_cancelNextTick,
    detectDirection: $0aeabd274a3674d8$var$_detectDirection,
    getChild: $0aeabd274a3674d8$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $0aeabd274a3674d8$var$Sortable.get = function(element) {
    return element[$0aeabd274a3674d8$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $0aeabd274a3674d8$var$Sortable.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $0aeabd274a3674d8$var$Sortable.utils = $0aeabd274a3674d8$var$_objectSpread2($0aeabd274a3674d8$var$_objectSpread2({}, $0aeabd274a3674d8$var$Sortable.utils), plugin.utils);
        $0aeabd274a3674d8$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $0aeabd274a3674d8$var$Sortable.create = function(el, options) {
    return new $0aeabd274a3674d8$var$Sortable(el, options);
};
// Export
$0aeabd274a3674d8$var$Sortable.version = $0aeabd274a3674d8$var$version;
var $0aeabd274a3674d8$var$autoScrolls = [], $0aeabd274a3674d8$var$scrollEl, $0aeabd274a3674d8$var$scrollRootEl, $0aeabd274a3674d8$var$scrolling = false, $0aeabd274a3674d8$var$lastAutoScrollX, $0aeabd274a3674d8$var$lastAutoScrollY, $0aeabd274a3674d8$var$touchEvt$1, $0aeabd274a3674d8$var$pointerElemChangedInterval;
function $0aeabd274a3674d8$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $0aeabd274a3674d8$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $0aeabd274a3674d8$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $0aeabd274a3674d8$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $0aeabd274a3674d8$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $0aeabd274a3674d8$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $0aeabd274a3674d8$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $0aeabd274a3674d8$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $0aeabd274a3674d8$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $0aeabd274a3674d8$var$clearPointerElemChangedInterval();
            $0aeabd274a3674d8$var$clearAutoScrolls();
            $0aeabd274a3674d8$var$cancelThrottle();
        },
        nulling: function nulling() {
            $0aeabd274a3674d8$var$touchEvt$1 = $0aeabd274a3674d8$var$scrollRootEl = $0aeabd274a3674d8$var$scrollEl = $0aeabd274a3674d8$var$scrolling = $0aeabd274a3674d8$var$pointerElemChangedInterval = $0aeabd274a3674d8$var$lastAutoScrollX = $0aeabd274a3674d8$var$lastAutoScrollY = null;
            $0aeabd274a3674d8$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $0aeabd274a3674d8$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $0aeabd274a3674d8$var$Edge || $0aeabd274a3674d8$var$IE11OrLess || $0aeabd274a3674d8$var$Safari) {
                $0aeabd274a3674d8$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $0aeabd274a3674d8$var$getParentAutoScrollElement(elem, true);
                if ($0aeabd274a3674d8$var$scrolling && (!$0aeabd274a3674d8$var$pointerElemChangedInterval || x !== $0aeabd274a3674d8$var$lastAutoScrollX || y !== $0aeabd274a3674d8$var$lastAutoScrollY)) {
                    $0aeabd274a3674d8$var$pointerElemChangedInterval && $0aeabd274a3674d8$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $0aeabd274a3674d8$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $0aeabd274a3674d8$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $0aeabd274a3674d8$var$clearAutoScrolls();
                        }
                        $0aeabd274a3674d8$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $0aeabd274a3674d8$var$lastAutoScrollX = x;
                    $0aeabd274a3674d8$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $0aeabd274a3674d8$var$getParentAutoScrollElement(elem, true) === $0aeabd274a3674d8$var$getWindowScrollingElement()) {
                    $0aeabd274a3674d8$var$clearAutoScrolls();
                    return;
                }
                $0aeabd274a3674d8$var$autoScroll(evt, this.options, $0aeabd274a3674d8$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $0aeabd274a3674d8$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $0aeabd274a3674d8$var$clearAutoScrolls() {
    $0aeabd274a3674d8$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $0aeabd274a3674d8$var$autoScrolls = [];
}
function $0aeabd274a3674d8$var$clearPointerElemChangedInterval() {
    clearInterval($0aeabd274a3674d8$var$pointerElemChangedInterval);
}
var $0aeabd274a3674d8$var$autoScroll = $0aeabd274a3674d8$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $0aeabd274a3674d8$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($0aeabd274a3674d8$var$scrollRootEl !== rootEl) {
        $0aeabd274a3674d8$var$scrollRootEl = rootEl;
        $0aeabd274a3674d8$var$clearAutoScrolls();
        $0aeabd274a3674d8$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($0aeabd274a3674d8$var$scrollEl === true) $0aeabd274a3674d8$var$scrollEl = $0aeabd274a3674d8$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $0aeabd274a3674d8$var$scrollEl;
    do {
        var el = currentParent, rect = $0aeabd274a3674d8$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $0aeabd274a3674d8$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$0aeabd274a3674d8$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$0aeabd274a3674d8$var$autoScrolls[i]) $0aeabd274a3674d8$var$autoScrolls[i] = {};
        }
        if ($0aeabd274a3674d8$var$autoScrolls[layersOut].vx != vx || $0aeabd274a3674d8$var$autoScrolls[layersOut].vy != vy || $0aeabd274a3674d8$var$autoScrolls[layersOut].el !== el) {
            $0aeabd274a3674d8$var$autoScrolls[layersOut].el = el;
            $0aeabd274a3674d8$var$autoScrolls[layersOut].vx = vx;
            $0aeabd274a3674d8$var$autoScrolls[layersOut].vy = vy;
            clearInterval($0aeabd274a3674d8$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $0aeabd274a3674d8$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $0aeabd274a3674d8$var$Sortable.active._onTouchMove($0aeabd274a3674d8$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $0aeabd274a3674d8$var$autoScrolls[this.layer].vy ? $0aeabd274a3674d8$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $0aeabd274a3674d8$var$autoScrolls[this.layer].vx ? $0aeabd274a3674d8$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($0aeabd274a3674d8$var$Sortable.dragged.parentNode[$0aeabd274a3674d8$var$expando], scrollOffsetX, scrollOffsetY, evt, $0aeabd274a3674d8$var$touchEvt$1, $0aeabd274a3674d8$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $0aeabd274a3674d8$var$scrollBy($0aeabd274a3674d8$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $0aeabd274a3674d8$var$getParentAutoScrollElement(currentParent, false)));
    $0aeabd274a3674d8$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $0aeabd274a3674d8$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $0aeabd274a3674d8$var$Revert() {}
$0aeabd274a3674d8$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $0aeabd274a3674d8$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $0aeabd274a3674d8$var$drop
};
$0aeabd274a3674d8$var$_extends($0aeabd274a3674d8$var$Revert, {
    pluginName: "revertOnSpill"
});
function $0aeabd274a3674d8$var$Remove() {}
$0aeabd274a3674d8$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $0aeabd274a3674d8$var$drop
};
$0aeabd274a3674d8$var$_extends($0aeabd274a3674d8$var$Remove, {
    pluginName: "removeOnSpill"
});
var $0aeabd274a3674d8$var$lastSwapEl;
function $0aeabd274a3674d8$var$SwapPlugin() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $0aeabd274a3674d8$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $0aeabd274a3674d8$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $0aeabd274a3674d8$var$toggleClass(target, options.swapClass, true);
                    $0aeabd274a3674d8$var$lastSwapEl = target;
                } else $0aeabd274a3674d8$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $0aeabd274a3674d8$var$lastSwapEl) $0aeabd274a3674d8$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $0aeabd274a3674d8$var$lastSwapEl && $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$lastSwapEl, options.swapClass, false);
            if ($0aeabd274a3674d8$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $0aeabd274a3674d8$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $0aeabd274a3674d8$var$swapNodes(dragEl, $0aeabd274a3674d8$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $0aeabd274a3674d8$var$lastSwapEl = null;
        }
    };
    return $0aeabd274a3674d8$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $0aeabd274a3674d8$var$lastSwapEl
            };
        }
    });
}
function $0aeabd274a3674d8$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $0aeabd274a3674d8$var$index(n1);
    i2 = $0aeabd274a3674d8$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $0aeabd274a3674d8$var$multiDragElements = [], $0aeabd274a3674d8$var$multiDragClones = [], $0aeabd274a3674d8$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$0aeabd274a3674d8$var$multiDragSortable, $0aeabd274a3674d8$var$initialFolding = false, // Initial multi-drag fold when drag started
$0aeabd274a3674d8$var$folding = false, // Folding any other time
$0aeabd274a3674d8$var$dragStarted = false, $0aeabd274a3674d8$var$dragEl$1, $0aeabd274a3674d8$var$clonesFromRect, $0aeabd274a3674d8$var$clonesHidden;
function $0aeabd274a3674d8$var$MultiDragPlugin() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $0aeabd274a3674d8$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $0aeabd274a3674d8$var$on(document, "mouseup", this._deselectMultiDrag);
                $0aeabd274a3674d8$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $0aeabd274a3674d8$var$on(document, "keydown", this._checkKeyDown);
        $0aeabd274a3674d8$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($0aeabd274a3674d8$var$multiDragElements.length && $0aeabd274a3674d8$var$multiDragSortable === sortable) $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $0aeabd274a3674d8$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$0aeabd274a3674d8$var$multiDragElements.indexOf($0aeabd274a3674d8$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $0aeabd274a3674d8$var$multiDragElements.length; i++){
                $0aeabd274a3674d8$var$multiDragClones.push($0aeabd274a3674d8$var$clone($0aeabd274a3674d8$var$multiDragElements[i]));
                $0aeabd274a3674d8$var$multiDragClones[i].sortableIndex = $0aeabd274a3674d8$var$multiDragElements[i].sortableIndex;
                $0aeabd274a3674d8$var$multiDragClones[i].draggable = false;
                $0aeabd274a3674d8$var$multiDragClones[i].style["will-change"] = "";
                $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$multiDragClones[i], this.options.selectedClass, false);
                $0aeabd274a3674d8$var$multiDragElements[i] === $0aeabd274a3674d8$var$dragEl$1 && $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($0aeabd274a3674d8$var$multiDragElements.length && $0aeabd274a3674d8$var$multiDragSortable === sortable) {
                    $0aeabd274a3674d8$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $0aeabd274a3674d8$var$insertMultiDragClones(false, rootEl);
            $0aeabd274a3674d8$var$multiDragClones.forEach(function(clone) {
                $0aeabd274a3674d8$var$css(clone, "display", "");
            });
            cloneNowShown();
            $0aeabd274a3674d8$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $0aeabd274a3674d8$var$multiDragClones.forEach(function(clone) {
                $0aeabd274a3674d8$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $0aeabd274a3674d8$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $0aeabd274a3674d8$var$multiDragSortable) $0aeabd274a3674d8$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $0aeabd274a3674d8$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $0aeabd274a3674d8$var$multiDragElements = $0aeabd274a3674d8$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $0aeabd274a3674d8$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0aeabd274a3674d8$var$dragEl$1) return;
                        $0aeabd274a3674d8$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$dragEl$1, false, true, true);
                    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0aeabd274a3674d8$var$dragEl$1) return;
                        $0aeabd274a3674d8$var$setRect(multiDragElement, dragRect);
                    });
                    $0aeabd274a3674d8$var$folding = true;
                    $0aeabd274a3674d8$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $0aeabd274a3674d8$var$folding = false;
                $0aeabd274a3674d8$var$initialFolding = false;
                if (_this2.options.animation) $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                    $0aeabd274a3674d8$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $0aeabd274a3674d8$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($0aeabd274a3674d8$var$folding && ~$0aeabd274a3674d8$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($0aeabd274a3674d8$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $0aeabd274a3674d8$var$folding ? $0aeabd274a3674d8$var$getRect(multiDragElement) : dragRect
                    });
                    $0aeabd274a3674d8$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $0aeabd274a3674d8$var$folding = false;
                $0aeabd274a3674d8$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $0aeabd274a3674d8$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $0aeabd274a3674d8$var$multiDragElements.length > 1 && ($0aeabd274a3674d8$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$dragEl$1, false, true, true);
                    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0aeabd274a3674d8$var$dragEl$1) return;
                        $0aeabd274a3674d8$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $0aeabd274a3674d8$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$0aeabd274a3674d8$var$folding) $0aeabd274a3674d8$var$removeMultiDragElements();
                    if ($0aeabd274a3674d8$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $0aeabd274a3674d8$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$0aeabd274a3674d8$var$clonesHidden && clonesHiddenBefore) $0aeabd274a3674d8$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $0aeabd274a3674d8$var$clonesFromRect
                            });
                            clone.fromRect = $0aeabd274a3674d8$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $0aeabd274a3674d8$var$clonesFromRect = $0aeabd274a3674d8$var$_extends({}, dragRect);
                var dragMatrix = $0aeabd274a3674d8$var$matrix($0aeabd274a3674d8$var$dragEl$1, true);
                $0aeabd274a3674d8$var$clonesFromRect.top -= dragMatrix.f;
                $0aeabd274a3674d8$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($0aeabd274a3674d8$var$folding) {
                $0aeabd274a3674d8$var$folding = false;
                $0aeabd274a3674d8$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$0aeabd274a3674d8$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $0aeabd274a3674d8$var$toggleClass($0aeabd274a3674d8$var$dragEl$1, options.selectedClass, !~$0aeabd274a3674d8$var$multiDragElements.indexOf($0aeabd274a3674d8$var$dragEl$1));
                if (!~$0aeabd274a3674d8$var$multiDragElements.indexOf($0aeabd274a3674d8$var$dragEl$1)) {
                    $0aeabd274a3674d8$var$multiDragElements.push($0aeabd274a3674d8$var$dragEl$1);
                    $0aeabd274a3674d8$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $0aeabd274a3674d8$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $0aeabd274a3674d8$var$lastMultiDragSelect && sortable.el.contains($0aeabd274a3674d8$var$lastMultiDragSelect)) {
                        var lastIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$lastMultiDragSelect), currentIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$0aeabd274a3674d8$var$multiDragElements.indexOf(children[i])) continue;
                                $0aeabd274a3674d8$var$toggleClass(children[i], options.selectedClass, true);
                                $0aeabd274a3674d8$var$multiDragElements.push(children[i]);
                                $0aeabd274a3674d8$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $0aeabd274a3674d8$var$lastMultiDragSelect = $0aeabd274a3674d8$var$dragEl$1;
                    $0aeabd274a3674d8$var$multiDragSortable = toSortable;
                } else {
                    $0aeabd274a3674d8$var$multiDragElements.splice($0aeabd274a3674d8$var$multiDragElements.indexOf($0aeabd274a3674d8$var$dragEl$1), 1);
                    $0aeabd274a3674d8$var$lastMultiDragSelect = null;
                    $0aeabd274a3674d8$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $0aeabd274a3674d8$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($0aeabd274a3674d8$var$dragStarted && this.isMultiDrag) {
                $0aeabd274a3674d8$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$0aeabd274a3674d8$var$expando].options.sort || parentEl !== rootEl) && $0aeabd274a3674d8$var$multiDragElements.length > 1) {
                    var dragRect = $0aeabd274a3674d8$var$getRect($0aeabd274a3674d8$var$dragEl$1), multiDragIndex = $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$0aeabd274a3674d8$var$initialFolding && options.animation) $0aeabd274a3674d8$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$0aeabd274a3674d8$var$initialFolding) {
                        if (options.animation) {
                            $0aeabd274a3674d8$var$dragEl$1.fromRect = dragRect;
                            $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $0aeabd274a3674d8$var$dragEl$1) {
                                    var rect = $0aeabd274a3674d8$var$folding ? $0aeabd274a3674d8$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $0aeabd274a3674d8$var$removeMultiDragElements();
                        $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $0aeabd274a3674d8$var$index($0aeabd274a3674d8$var$dragEl$1)) {
                            var update = false;
                            $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $0aeabd274a3674d8$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                        $0aeabd274a3674d8$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $0aeabd274a3674d8$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $0aeabd274a3674d8$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $0aeabd274a3674d8$var$dragStarted = false;
            $0aeabd274a3674d8$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $0aeabd274a3674d8$var$off(document, "pointerup", this._deselectMultiDrag);
            $0aeabd274a3674d8$var$off(document, "mouseup", this._deselectMultiDrag);
            $0aeabd274a3674d8$var$off(document, "touchend", this._deselectMultiDrag);
            $0aeabd274a3674d8$var$off(document, "keydown", this._checkKeyDown);
            $0aeabd274a3674d8$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $0aeabd274a3674d8$var$dragStarted !== "undefined" && $0aeabd274a3674d8$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($0aeabd274a3674d8$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $0aeabd274a3674d8$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($0aeabd274a3674d8$var$multiDragElements.length){
                var el = $0aeabd274a3674d8$var$multiDragElements[0];
                $0aeabd274a3674d8$var$toggleClass(el, this.options.selectedClass, false);
                $0aeabd274a3674d8$var$multiDragElements.shift();
                $0aeabd274a3674d8$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $0aeabd274a3674d8$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$0aeabd274a3674d8$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$0aeabd274a3674d8$var$multiDragElements.indexOf(el)) return;
                if ($0aeabd274a3674d8$var$multiDragSortable && $0aeabd274a3674d8$var$multiDragSortable !== sortable) {
                    $0aeabd274a3674d8$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $0aeabd274a3674d8$var$multiDragSortable = sortable;
                }
                $0aeabd274a3674d8$var$toggleClass(el, sortable.options.selectedClass, true);
                $0aeabd274a3674d8$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$0aeabd274a3674d8$var$expando], index = $0aeabd274a3674d8$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $0aeabd274a3674d8$var$toggleClass(el, sortable.options.selectedClass, false);
                $0aeabd274a3674d8$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($0aeabd274a3674d8$var$folding && multiDragElement !== $0aeabd274a3674d8$var$dragEl$1) newIndex = -1;
                else if ($0aeabd274a3674d8$var$folding) newIndex = $0aeabd274a3674d8$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $0aeabd274a3674d8$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $0aeabd274a3674d8$var$_toConsumableArray($0aeabd274a3674d8$var$multiDragElements),
                clones: [].concat($0aeabd274a3674d8$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $0aeabd274a3674d8$var$insertMultiDragElements(clonesInserted, rootEl) {
    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $0aeabd274a3674d8$var$insertMultiDragClones(elementsInserted, rootEl) {
    $0aeabd274a3674d8$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $0aeabd274a3674d8$var$removeMultiDragElements() {
    $0aeabd274a3674d8$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $0aeabd274a3674d8$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$0aeabd274a3674d8$var$Sortable.mount(new $0aeabd274a3674d8$var$AutoScrollPlugin());
$0aeabd274a3674d8$var$Sortable.mount($0aeabd274a3674d8$var$Remove, $0aeabd274a3674d8$var$Revert);
$0aeabd274a3674d8$var$Sortable.mount(new $0aeabd274a3674d8$var$SwapPlugin());
$0aeabd274a3674d8$var$Sortable.mount(new $0aeabd274a3674d8$var$MultiDragPlugin());
var $0aeabd274a3674d8$export$2e2bcd8739ae039 = $0aeabd274a3674d8$var$Sortable;









/* eslint:disable */ 
class $ef4bb18badfafdf1$var$sjefIconChevronsRight {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconChevronsRight", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="7 7 12 12 7 17" /><polyline points="13 7 18 12 13 17" />')));
    }
}
var $ef4bb18badfafdf1$export$2e2bcd8739ae039 = $ef4bb18badfafdf1$var$sjefIconChevronsRight;


let $24e63ff9d49366e9$var$selectedOrderjob = {};
let $24e63ff9d49366e9$var$payloadSplit = {};
const $24e63ff9d49366e9$var$addOrderjobLine = (quantity, line, crossed = false)=>{
    return {
        quantity: quantity,
        description: line.description,
        kitchen_groceries: line.kitchen_groceries,
        notes: line.notes,
        crossed: line.crossed || crossed
    };
};
class $24e63ff9d49366e9$export$44193a81d8646dc4 {
    form = {
        status: ""
    };
    order = null;
    parentCloseModal;
    form = {};
    // orderSplit = {};
    oninit(vnode) {
        this.order = JSON.parse(JSON.stringify(vnode.attrs.order));
        if (typeof vnode.attrs.closeModal === "function") this.parentCloseModal = vnode.attrs.closeModal;
        this.form = {
            id: this.order.id,
            status: this.order.attributes.status,
            lines: this.order.attributes.lines
        };
    }
    async postOrderForSplit() {
        // Initialize the current and new lines arrays
        // const linesCurrent = [];
        // const linesNew = [];
        const payload = {
            status: this.form.status,
            lines_current: [],
            lines_new: []
        };
        this.form.lines.forEach((line)=>{
            if (line.quantity === 0 && line.quantity_new === 0) return;
            // Process lines with quantity greater than 0
            if (line.quantity > 0) payload.lines_current.push($24e63ff9d49366e9$var$addOrderjobLine(line.quantity, line, false));
            // Process lines with quantity_new greater than 0
            if (line.quantity_new > 0) {
                payload.lines_current.push($24e63ff9d49366e9$var$addOrderjobLine(line.quantity_new, line, true));
                payload.lines_new.push($24e63ff9d49366e9$var$addOrderjobLine(line.quantity_new, line));
            }
        });
        const response = await (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).post(`orderjobs/${this.form.id}/split`, payload);
        if (response.error) {
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("An error occurred");
            (0, $4412a4d0220473a9$export$d0204b1ddc8ee140).handleError("A0060", response.error);
            return response;
        }
        await (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.reloadOrders();
    }
    // Render the view of the modal order details component
    view(vnode) {
        if (!this.order) return null;
        // selectedOrderjob = JSON.parse(JSON.stringify(order));
        // Render the Mithril virtual DOM structure for the modal
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalContainer", {
            id: "modalContainer"
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalOverlay", {
                onclick: ()=>{
                    if (typeof this.parentCloseModal === "function") this.parentCloseModal();
                }
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalDialog", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalHeader", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".flex.between", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalTitle", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalId", this.order.attributes.order_label)
                    ]),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalTitle", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalId", this.order.attributes.table_label)
                    ])
                ])),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalBody", [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul.modalAttributes", this.form.lines.map((line, index)=>{
                        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.modalDescription1", {
                            key: index,
                            class: line.crossed ? "crossed" : ""
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".flex.start", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", `${Math.round(line.quantity)} x - ${line.description}`), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".flex", !line.crossed ? [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                    onclick: ()=>{
                                        if (line.quantity === 0 || line.crossed) return;
                                        line.quantity--;
                                        if (line.quantity_new === undefined) line.quantity_new = 1;
                                        else line.quantity_new++;
                                    // m.redraw();
                                    }
                                }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $ef4bb18badfafdf1$export$2e2bcd8739ae039))),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", `${line.quantity_new || 0}`)
                            ] : null)),
                            // Nested list of kitchen groceries
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul", Object.entries(line.kitchen_groceries).map(([key, value])=>{
                                return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.modalGroceries", [
                                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.groceriesRow", `${key}: `),
                                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.groceriesRow", ` ${value}`)
                                ]);
                            })),
                            // List of notes for the line item
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul.notes", line.notes)
                        ]);
                    }))
                ]),
                // Modal footer with close button
                // create select box for split order -> payloadSplit.status
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".setStatus", [
                    "open",
                    "in preparation",
                    "ready",
                    "parked",
                    "served"
                ].map((option)=>{
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".selectOption", {
                        class: this.form.status === option ? "selected" : "",
                        onclick: ()=>{
                            this.form.status = option;
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw(); // Ensure UI is updated
                        }
                    }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.status.${option.replace(/\s+/g, "")}`));
                })),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalFooter", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".buttonFlexer", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.modalCloseButton", {
                    onclick: async ()=>{
                        await this.postOrderForSplit();
                        if (typeof this.parentCloseModal === "function") this.parentCloseModal();
                    }
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.split")), (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.modalCloseButton", {
                    onclick: ()=>{
                        if (typeof this.parentCloseModal === "function") this.parentCloseModal();
                    }
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.close"))))
            ])
        ]);
    }
}




var $45fvw = parcelRequire("45fvw");

// const PRINT_URL ='http://192.168.79.195/StarWebPRNT/SendMessage'
const $d181d12e69d4ab16$var$PRINT_URL = undefined;
const $d181d12e69d4ab16$export$4523ab464ecf033 = {
    printOrder: async function(order) {
        const loaded_at = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("DD-MM-YY HH:mm");
        const timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.attributes.timestamp).format("DD-MM-YY HH:mm");
        const orderTable = order.attributes.table_label !== null ? `${order.attributes.order_label} / ${order.attributes.table_label}` : `${order.attributes.order_label}`;
        const orderDataLines = order.attributes.lines.map((line)=>{
            const kitchenGroceriesList = Object.entries(line.kitchen_groceries).map(([key, value])=>`${key}: \n${value}`).join("\n");
            return `${Math.round(line.quantity)}x - ${line.description}\n${kitchenGroceriesList}`;
        });
        const orderData = orderDataLines.join("\n");
        const builder = new StarWebPrintBuilder();
        let request = "";
        request += builder.createInitializationElement();
        request += builder.createTextElement({
            characterspace: 2
        });
        request += builder.createAlignmentElement({
            position: "left"
        });
        request += builder.createTextElement({
            data: timestamp,
            width: 1,
            height: 1
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createAlignmentElement({
            position: "center"
        });
        request += builder.createTextElement({
            data: orderTable,
            width: 2,
            height: 2
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createAlignmentElement({
            position: "left"
        });
        request += builder.createTextElement({
            data: orderData,
            width: 1,
            height: 2
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createTextElement({
            data: "\n"
        });
        request += builder.createAlignmentElement({
            position: "center"
        });
        request += builder.createTextElement({
            data: loaded_at,
            width: 1,
            height: 1
        });
        request += builder.createCutPaperElement({
            feed: true,
            type: "full"
        });
        await this.print(request);
    },
    print: async function(request) {
        const printer = new StarWebPrintTrader({
            url: $d181d12e69d4ab16$var$PRINT_URL
        });
        printer.onReceive = ()=>{
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Print successful:");
        };
        printer.onError = ()=>{
            (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast("Print error:");
        };
        printer.sendMessage({
            request: request
        });
    }
};






class $79d1c2a48476c530$export$d8004dd2b851706f {
    modalOpen = false;
    // Method to open the modal
    openModal = ()=>{
        this.modalOpen = true;
    };
    // Method to close the modal
    closeModal = ()=>{
        this.modalOpen = false;
    };
    // Render method for the component
    view(vnode) {
        const { ids: ids, action: action, callback: callback } = vnode.attrs;
        // Render the component structure using Mithril's virtual DOM
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".title", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", [
                // Button to trigger modal opening
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".prepareFooterButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                    class: ids.length === 0 ? "blurred" : "",
                    onclick: async ()=>{
                        // Check if there are selected ids; if not, return early
                        if (ids.length === 0) return;
                        this.openModal(); // Open the modal
                    }
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.buttons.${vnode.attrs.action}`) // Button text localized using _t function
                ))
            ]),
            // Render modal content if modalOpen is true
            this.modalOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSContainer", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSOverlay", {
                    onclick: ()=>{
                        this.closeModal();
                    }
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSDialog", [
                    // Modal header with title
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSHeader", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.modalPRSTitle", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.modal.batchAction.${action}.title`))
                    ]),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSBody", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.modal.batchAction.${action}.text`))
                    ]),
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".modalPRSFooter", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.modalPRSCloseButton", {
                            onclick: ()=>{
                                this.closeModal();
                            }
                        }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.close")),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.modalPRSActionButton", {
                            onclick: async ()=>{
                                await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatusBatch(action, ids);
                                callback();
                                this.closeModal();
                            }
                        }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.modal.batchAction.${action}.buttonLabel`) // Action button label localized using _t function
                        )
                    ])
                ])
            ]) : ""
        ]);
    }
}


/* eslint:disable */ 
class $9438b087479153da$var$sjefIconHandStop {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconHandStop", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5" /><path d="M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5" /><path d="M14 5.5a1.5 1.5 0 0 1 3 0v6.5" /><path d="M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />')));
    }
}
var $9438b087479153da$export$2e2bcd8739ae039 = $9438b087479153da$var$sjefIconHandStop;


/* eslint:disable */ 
class $8b973217246585a8$var$sjefIconReceipt {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconReceipt", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2" />')));
    }
}
var $8b973217246585a8$export$2e2bcd8739ae039 = $8b973217246585a8$var$sjefIconReceipt;


class $993a25673b496d62$export$fd6f350a6ddafb60 {
    orders = [];
    selectedIds = [];
    selectedOrderIndex = null;
    modalDetailsIsOpen = false;
    getSelectedOrdersIds() {
        return this.selectedIds;
    }
    clearSelectedOrdersIds() {
        this.selectedIds = [];
    }
    view(vnode) {
        const mode = vnode.attrs.mode;
        const currentTab = vnode.attrs.currentTab;
        const orders = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[currentTab] || [];
        const containerClass = currentTab === "ready" ? ".serve-containers" : ".main-containers";
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".container-wrapper", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.headlines.${currentTab}`), "  (" + orders.length + ")"),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(containerClass, {
                class: [
                    "mode-" + mode
                ].join(" "),
                oncreate: (vnode)=>{
                    if (mode === "kitchen") (0, $0aeabd274a3674d8$export$2e2bcd8739ae039).create(vnode.dom, {
                        animation: 500,
                        disabled: false,
                        handle: ".upPart",
                        onEnd: async (event)=>{
                            const newIndex = event.newIndex;
                            const oldIndex = event.item.dataset.idx;
                            const orders = (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open;
                            if (parseInt(newIndex) === parseInt(oldIndex)) return;
                            if (!orders.length) return;
                            const id = event.item.dataset.id;
                            const direction = parseInt(newIndex) < parseInt(oldIndex) ? "backwards" : "forwards";
                            let leftPosition;
                            let rightPosition;
                            let leftOrder;
                            let rightOrder;
                            if (direction === "backwards") {
                                if (newIndex === 0) leftPosition = orders[0].attributes.position - 5999;
                                else {
                                    leftOrder = orders[newIndex - 1];
                                    leftPosition = leftOrder.attributes.position;
                                }
                                rightOrder = orders[newIndex];
                                rightPosition = rightOrder.attributes.position;
                            } else if (direction === "forwards") {
                                leftOrder = orders[newIndex];
                                leftPosition = leftOrder.attributes.position;
                                if (newIndex === orders.length - 1) rightPosition = orders[orders.length - 1].attributes.position + 6001;
                                else {
                                    rightOrder = orders[newIndex + 1];
                                    rightPosition = rightOrder.attributes.position;
                                }
                            }
                            try {
                                await (0, $03f71c0d7b74323f$export$372053738acac6fe).moved(id, leftPosition, rightPosition);
                                // Update orders after moving
                                await (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.reloadOrders();
                                // appState.data.orders.open=orders
                                // Optionally, you can log or perform other actions after successful move
                                console.log(`Order ${id} moved successfully.`);
                            } catch (error) {
                                (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).toast(`Error moving order: ${error}`);
                            }
                        }
                    });
                }
            }, orders.map((order, index)=>{
                const isActive = this.selectedIds.includes(order.id);
                const orderTimestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.attributes.timestamp);
                const currentTimestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
                const differenceInMinutes = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(currentTimestamp.diff(orderTimestamp)).asMinutes();
                const selectedOptionMinutes = parseInt((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedOption);
                let borderClass = "";
                if (differenceInMinutes > selectedOptionMinutes + 10) borderClass = "danger";
                else if (differenceInMinutes > selectedOptionMinutes) borderClass = "almostDanger";
                let buttonClass = "";
                if (order.attributes.status === "open") buttonClass = "open";
                else if (order.attributes.status === "in preparation") buttonClass = "prepare";
                return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".container", {
                    key: currentTab + "-" + order.attributes.position,
                    id: "container" + index,
                    "data-idx": index,
                    "data-id": order.id,
                    "data-position": order.attributes.position,
                    class: [
                        isActive ? "active-container" : "containerA",
                        borderClass
                    ].join(" ")
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".containerFrame", {}, [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".upPart", {
                            class: isActive ? "true" : "false",
                            onclick: ()=>{
                                const orderId = order.id;
                                const indexToRemove = this.selectedIds.indexOf(orderId);
                                if (indexToRemove === -1) this.selectedIds.push(orderId);
                                else this.selectedIds.splice(indexToRemove, 1);
                                if (typeof vnode.attrs.onChangeId === "function") vnode.attrs.onChangeId(this.selectedIds);
                            }
                        }, [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".idContainer", order.attributes.table_label ? order.attributes.table_label : order.attributes.order_label),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".orderStatus", {
                                class: [
                                    "colorOfButton",
                                    buttonClass
                                ].join(" ")
                            }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".orderStatus", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.status." + order.attributes.status))),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".orderTimestamp", (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(order.attributes.timestamp).format("HH:mm:ss"))
                        ]),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowPart", [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderMain", [
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".orderWrapper", {
                                    onclick: (event)=>{
                                        event.stopPropagation();
                                        this.selectedOrderIndex = order.id;
                                        this.modalDetailsIsOpen = true;
                                    }
                                }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul.order", order.attributes.lines.map((line, line_index)=>{
                                    const lineContent = [
                                        // if line.crossed === true add class crossed
                                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.lowOrderMainOrders", [
                                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(// if line.crossed === true add class crossed
                                            "span", {
                                                class: line.crossed ? "line-through" : ""
                                            }, `${Math.round(line.quantity)} x - ${line.description}`),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul", Object.entries(line.kitchen_groceries).map(([key, value])=>{
                                                return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("li.groceries", [
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.groceriesKey", `${key}: `),
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.groceriesValue", `${value}`)
                                                ]);
                                            })),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("ul.notes", line.notes)
                                        ])
                                    ];
                                    if (line_index > 0 && order.attributes.lines[line_index - 1].display_order !== line.display_order) lineContent.unshift((0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".divov", "------"));
                                    return lineContent;
                                }))),
                                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrder", [
                                    [
                                        "open",
                                        "in preparation"
                                    ].includes(order.attributes.status) && mode === "kitchen" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderRightButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                        class: [
                                            "colorOfButton",
                                            buttonClass
                                        ].join(" "),
                                        onclick: async ()=>{
                                            if (order.attributes.status === "open") await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus("open", "prepare", order.id);
                                            else if (order.attributes.status === "in preparation") await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus("open", "ready", order.id);
                                        }
                                    }, order.attributes.status === "open" ? (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.prepare") : (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.ready"))) : null,
                                    [
                                        "open",
                                        "in preparation"
                                    ].includes(order.attributes.status) && mode === "kitchen" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderLeftButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                        onclick: async ()=>{
                                            await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus("open", "park", order.id);
                                        }
                                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $9438b087479153da$export$2e2bcd8739ae039)))) : null,
                                    [
                                        "parked",
                                        "ready",
                                        "served"
                                    ].includes(order.attributes.status) && mode === "kitchen" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderRightButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                        onclick: async ()=>{
                                            await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus(order.attributes.status !== "served" ? order.attributes.status : "recentready", "reopen", order.id);
                                        }
                                    }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.reopen"))) : null,
                                    [
                                        "ready"
                                    ].includes(order.attributes.status) && mode === "serve" ? [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderLeftButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                            onclick: async ()=>{
                                                (0, $d181d12e69d4ab16$export$4523ab464ecf033).printOrder(order);
                                            }
                                        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $8b973217246585a8$export$2e2bcd8739ae039)))),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".lowOrderRightButton", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button", {
                                            onclick: async ()=>{
                                                if (order.attributes.status === "ready") {
                                                    if (!(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction) return;
                                                    if ((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction === "serveAndPrint") {
                                                        //   console.log('Print and serve', serveValue);
                                                        (0, $d181d12e69d4ab16$export$4523ab464ecf033).printOrder(order);
                                                        await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus("ready", "serve", order.id);
                                                    } else if ((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).selectedAction === "serve") //   console.log('Serve only', serveValue);
                                                    await (0, $03f71c0d7b74323f$export$372053738acac6fe).toStatus("ready", "serve", order.id);
                                                }
                                            }
                                        }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.serve")))
                                    ] : null
                                ])
                            ])
                        ])
                    ]),
                    this.modalDetailsIsOpen && this.selectedOrderIndex === order.id && (order.attributes.status === "open" || order.attributes.status === "in preparation") && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $24e63ff9d49366e9$export$44193a81d8646dc4), {
                        order: order,
                        closeModal: ()=>{
                            this.modalDetailsIsOpen = false;
                        }
                    })
                ]);
            }))
        ]);
    }
}





/* eslint:disable */ 
class $85e471e63dadd603$var$sjefIconChevronsDown {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconChevronsDown", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="7 7 12 12 17 7" /><polyline points="7 13 12 18 17 13" />')));
    }
}
var $85e471e63dadd603$export$2e2bcd8739ae039 = $85e471e63dadd603$var$sjefIconChevronsDown;


/* eslint:disable */ 
class $d400dbb726409e30$var$sjefIconChevronsUp {
    view({ attrs: { classes: classes = [], size: size = "24", strokeWidth: strokeWidth = "2", color: color = "currentColor", fill: fill = "none", onclick: onclick, ...htmlAttrs } }) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".sjefIcon.sjefIconChevronsUp", {
            onclick: onclick,
            class: [
                "icon-sjefIcon2Fa",
                ...classes
            ].join(" "),
            ...htmlAttrs
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("svg[xmlns=http://www.w3.org/2000/svg].icon-svg", {
            width: size || "24",
            height: size || "24",
            stroke: color || "currentColor",
            fill: fill || "none",
            "stroke-width": strokeWidth || "2",
            "viewBox": "0 0 24 24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).trust('<path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="7 11 12 6 17 11" /><polyline points="7 17 12 12 17 17" />')));
    }
}
var $d400dbb726409e30$export$2e2bcd8739ae039 = $d400dbb726409e30$var$sjefIconChevronsUp;


class $97f260ddf432e013$export$99dfce4af396d6bf {
    constructor(){
        this.sortCriteria = "default"; // Default sorting criteria
        this.sortOrder = "asc"; // Default sorting order
        this.isOpen = false; // Flag to control dropdown visibility
    }
    // Consolidates orders to count each product quantity
    consolidateOrders(orders) {
        return orders.reduce((productQuantities, order)=>{
            order.attributes.lines.forEach((line)=>{
                const productName = line.description;
                const quantity = Math.round(line.quantity);
                productQuantities[productName] = (productQuantities[productName] || 0) + quantity;
            });
            return productQuantities;
        }, {});
    }
    // Sort product quantities based on selected criteria and order
    sortProductQuantities(productQuantities) {
        const entries = Object.entries(productQuantities);
        switch(this.sortCriteria){
            case "priority":
                break;
            case "alphabetical":
                entries.sort((a, b)=>{
                    return this.sortOrder === "asc" ? a[0].localeCompare(b[0]) : b[0].localeCompare(a[0]);
                });
                break;
            case "quantity":
                entries.sort((a, b)=>{
                    return this.sortOrder === "asc" ? a[1] - b[1] : b[1] - a[1];
                });
                break;
            case "entryOrder":
            default:
                break;
        }
        return entries;
    }
    // Handle click on SVG for changing sort criteria
    handleClickSortCriteria(criteria) {
        this.sortCriteria = criteria;
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw(); // Redraw to reflect the change
    }
    // Handle click on SVG for changing sort order
    handleClickSortOrder() {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    }
    // Renders the view of the sidebar component
    view() {
        // Consolidate orders from appState
        const productQuantities = this.consolidateOrders((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open || []);
        // Sort product quantities based on current sorting criteria and order
        const sortedProductQuantities = this.sortProductQuantities(productQuantities);
        const sortOptions = [
            "default",
            "priority",
            "alphabetical",
            "quantity",
            "entryOrder"
        ];
        // Sorting button
        const sortButton = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("button.sortButton", {
            onclick: ()=>{
                this.handleClickSortOrder();
            }
        }, this.sortOrder === "asc" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $d400dbb726409e30$export$2e2bcd8739ae039)) : (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $85e471e63dadd603$export$2e2bcd8739ae039)));
        // Custom select dropdown with SVG
        const customSelect = (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".custom-select-container", {}, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".consolidatedFilter", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.selected-option", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("span.selected-text", {
                    onclick: ()=>{
                        this.isOpen = !this.isOpen;
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
                    }
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.sorting.${this.sortCriteria}`))
            ]), sortButton),
            this.isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".options", sortOptions.map((option)=>(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("div.option", {
                    class: this.sortCriteria === option ? "active" : "",
                    onclick: ()=>this.handleClickSortCriteria(option)
                }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)(`lang.sorting.${option}`))))
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".consolidatedOrders", [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".consolidatedOrderMain", [
                customSelect,
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.consolidated_orders")),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".orders", sortedProductQuantities.map(([productName, quantity])=>{
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".consolidatedOrder", `${quantity} x - ${productName}`);
                }))
            ])
        ]);
    }
}



let $5e8cc35361df5812$var$ids = [];
let $5e8cc35361df5812$var$options = [];
let $5e8cc35361df5812$var$currentTab = "open";
class $5e8cc35361df5812$export$99afd7b994aff74f {
    orderList = new (0, $993a25673b496d62$export$fd6f350a6ddafb60)();
    tab = $5e8cc35361df5812$var$currentTab;
    loaded_at = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("HH:mm:ss");
    mode = "kitchen";
    setTab(tab) {
        this.tab = tab;
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.reloadOrders();
    }
    setMode(mode) {
        this.mode = mode;
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    }
    view() {
        const tabClass = [
            this.tab
        ].join(" ");
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).tabClass = tabClass;
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".webSiteVersion", {
            class: tabClass
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $b3cf76bab13fe31a$export$8b251419efc915eb), {
                currentClass: this.class,
                currentTab: this.tab,
                settingsActive: true,
                onModeChange: (newTab, newMode)=>{
                    this.setTab(newTab);
                    this.setMode(newMode);
                },
                onSelectChange: async (newNumber)=>{
                    $5e8cc35361df5812$var$options = newNumber;
                }
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(this.orderList, {
                    mode: this.mode,
                    currentTab: this.tab,
                    orders: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[this.tab] || [],
                    options: $5e8cc35361df5812$var$options,
                    onChangeId: async (newIds)=>{
                        $5e8cc35361df5812$var$ids = newIds;
                    }
                }),
                this.tab === "open" && !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $97f260ddf432e013$export$99dfce4af396d6bf)) : null,
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footer", [
                    !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerTime", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerTimeInner", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.orders_loaded_at") + " " + this.loaded_at)) : null,
                    this.mode === "kitchen" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerNavBar", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.openOrderFooter", {
                            class: this.tab === "open" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("open");
                                this.setMode("kitchen");
                            }
                        }, [
                            (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.open"),
                            `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open?.length || 0})`
                        ]),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.parkedOrderFooter", {
                            class: this.tab === "parked" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("parked");
                                this.setMode("kitchen");
                            }
                        }, [
                            (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.parked"),
                            `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.parked?.length || 0})`
                        ]),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.readyFooter", {
                            class: this.tab === "recentready" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("recentready");
                                this.setMode("kitchen");
                            }
                        }, [
                            (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.ready"),
                            `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.recentready?.length || 0})`
                        ])
                    ]) : null,
                    !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".header-title", [
                        this.tab === "open" && [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $79d1c2a48476c530$export$d8004dd2b851706f), {
                                ids: this.orderList.getSelectedOrdersIds(),
                                action: "prepare",
                                callback: ()=>{
                                    this.orderList.clearSelectedOrdersIds();
                                }
                            }),
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $79d1c2a48476c530$export$d8004dd2b851706f), {
                                ids: this.orderList.getSelectedOrdersIds(),
                                action: "ready",
                                callback: ()=>{
                                    this.orderList.clearSelectedOrdersIds();
                                }
                            })
                        ],
                        this.tab !== "open" && [
                            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $79d1c2a48476c530$export$d8004dd2b851706f), {
                                ids: this.orderList.getSelectedOrdersIds(),
                                action: "serve",
                                callback: ()=>{
                                    this.orderList.clearSelectedOrdersIds();
                                }
                            })
                        ]
                    ]) : null
                ])
            ])
        ]);
    }
}
// On document load, call appState.actions.init
document.addEventListener("DOMContentLoaded", async ()=>{
    if ((0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).token) await (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.init();
});
const $5e8cc35361df5812$var$main = document.getElementById("main");
(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount($5e8cc35361df5812$var$main, $5e8cc35361df5812$export$99afd7b994aff74f);





var $45fvw = parcelRequire("45fvw");






let $5e65643d9e35d199$var$ids = [];
let $5e65643d9e35d199$var$options = [];
let $5e65643d9e35d199$var$serveValue = "serve";
let $5e65643d9e35d199$var$currentTab = "ready";
class $5e65643d9e35d199$export$1f46a41a5760d4bf {
    orderList = new (0, $993a25673b496d62$export$fd6f350a6ddafb60)();
    loaded_at = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("HH:mm:ss");
    tab = $5e65643d9e35d199$var$currentTab;
    mode = "serve";
    setTab(tab) {
        this.tab = tab;
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).actions.reloadOrders();
    }
    setMode(mode) {
        this.mode = mode;
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
    }
    view() {
        const tabClass = [
            this.tab
        ].join(" ");
        // console.log('Current tab class:', tabClass);
        (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).tabClass = tabClass;
        return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".webSiteVersion", {
            class: tabClass
        }, [
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $b3cf76bab13fe31a$export$8b251419efc915eb), {
                currentClass: this.class,
                currentTab: this.tab,
                mode: this.mode,
                settingsActive: true,
                onSelectChange: async (newNumber)=>{
                    $5e65643d9e35d199$var$options = newNumber;
                },
                serveChange: async (newStatus)=>{
                    $5e65643d9e35d199$var$serveValue = newStatus;
                },
                onModeChange: (newTab, newMode)=>{
                    this.setTab(newTab);
                    this.setMode(newMode);
                }
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", [
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(this.orderList, {
                    key: this.tab,
                    mode: this.mode,
                    serveValue: $5e65643d9e35d199$var$serveValue,
                    currentTab: this.tab,
                    orders: (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders[this.tab] || [],
                    options: $5e65643d9e35d199$var$options,
                    onChangeId: async (newIds)=>{
                        $5e65643d9e35d199$var$ids = newIds;
                    }
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footer", {
                    key: "footer"
                }, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerTime", (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerTimeInner", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.headlines.orders_loaded_at") + " " + this.loaded_at)),
                    this.tab === "open" ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".footerNavBar", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.openOrderFooter", {
                            class: this.tab === "open" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("open");
                                this.setMode("kitchen");
                            }
                        }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("", (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.open"), `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.open?.length || 0})`)),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.parkedOrderFooter", {
                            class: this.tab === "parked" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("parked");
                                this.setMode("kitchen");
                            }
                        }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.parked"), `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.parked?.length || 0})`),
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))("h3.recentReadyFooter", {
                            class: this.tab === "recentready" ? "active" : "",
                            onclick: ()=>{
                                this.setTab("recentready");
                                this.setMode("kitchen");
                            }
                        }, (0, $cea20f86969d180a$export$e1a0bf30965c1cae)("lang.buttons.ready"), `(${(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).data.orders.recentReady?.length || 0})`)
                    ]) : null,
                    !(0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))(".header-title", [
                        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $79d1c2a48476c530$export$d8004dd2b851706f), {
                            ids: this.orderList.getSelectedOrdersIds(),
                            action: "serve",
                            callback: ()=>{
                                this.orderList.clearSelectedOrdersIds();
                            }
                        })
                    ]) : null
                ])
            ])
        ]);
    }
}
const $5e65643d9e35d199$var$main = document.getElementById("main");
(0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).mount($5e65643d9e35d199$var$main, $5e65643d9e35d199$export$1f46a41a5760d4bf);


var $6fb3a6f0458e4b44$export$2e2bcd8739ae039 = {
    Routes: ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).route(document.getElementById("main"), "/", {
            "/": {
                render: function() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $7df76c2b605556a9$export$21a94553ffa41578), {
                        class: "login"
                    });
                }
            },
            "/kdsMode": {
                render: function() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $2821a39abdc9106d$export$86fbec116b87613f), {
                        class: "kdsMode"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $8cd2d12814b11138$export$4a6bedb6e09009d4)));
                }
            },
            "/modeKitchen": {
                render: function() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $2821a39abdc9106d$export$86fbec116b87613f), {
                        class: "modeKitchen"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $5e8cc35361df5812$export$99afd7b994aff74f)));
                }
            },
            "/modeCustomer": {
                render: function() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $2821a39abdc9106d$export$86fbec116b87613f), {
                        class: "modeCustomer"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $152999f8debeeda8$export$e553a04309473072)));
                }
            },
            "/modeServe": {
                render: function() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $2821a39abdc9106d$export$86fbec116b87613f), {
                        class: "modeServe "
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports)))((0, $5e65643d9e35d199$export$1f46a41a5760d4bf)));
                }
            }
        });
    }
};





const $8f6a480bb40b134f$var$updateMobileState = ()=>{
    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).isMobile = window.innerWidth <= 768;
    (0, (/*@__PURE__*/$parcel$interopDefault($65d5daca13f5010c$exports))).redraw();
};
// Update mobile state on window resize
window.addEventListener("resize", $8f6a480bb40b134f$var$updateMobileState);
// Initialize the app once the DOM content is loaded
document.addEventListener("DOMContentLoaded", ()=>{
    $8f6a480bb40b134f$var$updateMobileState();
    (0, $6fb3a6f0458e4b44$export$2e2bcd8739ae039).Routes();
    (0, $cea20f86969d180a$export$e4c8a1ed14feeb6c)("en");
    (0, $7ff2ea747eb3b943$export$b72e390a9ebe1648).language = (0, $cea20f86969d180a$export$324a75438e87a537)();
});


//# sourceMappingURL=index.15c0bad3.js.map
